module.exports = {
	"ok": "ok",
	"by": "by",
	"sku": "Inturn ID",
	"whl": "WHL",
	"add": "add",
	"ats": "ATS",
	"set": "set",
	"min": "min",
	"max": "max",
	"avg": "avg",
	"N/A": "N/A",
	"you": "You",
	"your": "your",
	"url": "url",
	"zip": "zip / postal code",
	"code": "code",
	"team": "team",
	"no": "no",
	"City": "City",
	"from": "From",
	"edit": "edit",
	"bulk": "bulk",
	"save": "save",
	"drop": "drop",
	"help": "help",
	"next": "next",
	"done": "done",
	"cost": "cost",
	"msrp": "MSRP",
	"sort": "sort",
	"Sort": "Sort",
	"view": "view",
	"View": "View",
	"size": "size",
	"back": "back",
	"ends": "ends",
	"sent": "sent",
	"date": "date",
	"time": "time",
	"none": "None",
	"baby": "baby",
	"mens": "men's",
	"avail": "avail.",
	"login": "login",
	"email": "email",
	"offer": "offer",
	"yes": "yes",
	"title": "title",
	"style": "style",
	"clear": "clear",
	"price": "price",
	"ratio": "ratio",
	"Ratio": "Ratio",
	"sizes": "sizes",
	"color": "color",
	"items": "items",
	"dashboard_products": "Products",
	"products_word": "products",
	"units": "Total Units",
	"Total_Cost": "Total Cost",
	"Unallocated_Cost": "Unallocated Cost",
	"Unallocated_WHL": "Unallocated WHL",
	"Unallocated_MSRP": "Unallocated MSRP",
	"Units": "Units",
	"Cases": "Cases",
	"reset": "reset",
	"close": "close",
	"print": "print",
	"error": "error",
	"draft": "draft",
	"valid": "valid",
	"links": "links",
	"phone": "phone",
	"apply": "apply",
	"state": "state / province",
	"State/Province": "State/Province",
	"ZIP/Postal": "ZIP/Postal",
	"proft": "profit",
	"total": "total",
	"buyer": "buyer",
	"ended": "ended",
	"retry": "retry",
	"added": "added",
	"offers": "offers",
	"logout": "logout",
	"cancel": "cancel",
	"delete": "delete",
	"submit": "submit",
	"finish": "finish",
	"accept": "accept",
	"remove": "remove",
	"sku_id": "Inturn ID",
	"amount": "amount",
	"search": "search",
	"Search": "Search",
	"expand": "expand",
	"filter": "filter",
	"ticket": "retail price",
	"margin": "margin",
	"markup": "markup",
	"status": "status",
	"revoke": "revoke",
	"rollup": "rollup",
	"browse": "browse",
	"notice": "notice",
	"rounds": "rounds",
	"failed": "failed",
	"active": "active",
	"closed": "closed",
	"market": "market",
	"change": "change",
	"buyers": "buyers",
	"errors": "errors",
	"undone": "This Cannot Be Undone",
	"custom": "custom",
	"womens": "women's",
	"legend": "legend",
	"account": "account",
	"connect": "connect",
	"company": "company",
	"minimum": "minimum",
	"maximum": "maximum",
	"go_back": "go back",
	"created": "created",
	"folders": "folders",
	"loading": "loading...",
	"Loading...": "Loading...",
	"profile": "profile",
	"sign_up": "sign up",
	"updated": "updated",
	"show_me": "show me",
	"results": "results",
	"success": "success",
	"warning": "warning",
	"viewing": "viewing",
	"editing": "editing",
	"expired": "expired",
	"decline": "decline",
	"options": "options",
	"preview": "preview",
	"twitter": "twitter",
	"Twitter": "Twitter",
	"pending": "pending",
	"filters": "filters",
	"markets": "markets",
	"actions": "actions",
	"address": "address",
	"Address": "Address",
	"country": "country",
	"Country": "Country",
	"percent": "percent",
	"creator": "creator",
	"revenue": "revenue",
	"dismiss": "dismiss",
	"no_data": "no data",
	"support": "support",
	"special": "special sizes",
	"username": "username",
	"password": "password",
	"Password": "Password",
	"listings": "listings",
	"my_offer": "My Offer",
	"quantity": "quantity",
	"view_qty": "view qty",
	"uploaded": "uploaded ",
	"selected": "selected",
	"num_selected": "%{num} selected",
	"advanced": "advanced",
	"included": "included",
	"collapse": "collapse",
	"optional": "optional",
	"schedule": "schedule",
	"add_item": "add item",
	"turn_off": "turn off",
	"end_date": "end date",
	"#items": "%{smart_count} item |||| %{smart_count} items",
	"#products": "%{smart_count} product |||| %{smart_count} products",
	"#units": "%{smart_count} unit |||| %{smart_count} units",
	"%smart_count_products": "%{smart_count} product |||| %{smart_count} products",
	"%smart_count_Products": "%{smart_count} Product |||| %{smart_count} Products",
	"%smart_count_Products_label_only": "Product |||| Products",
	"%smart_count_units": "%{smart_count} unit |||| %{smart_count} units",
	"%smart_count_cases": "%{smart_count} case |||| %{smart_count} cases",
	"%smart_count_CSPKs": "%{smart_count} CSPK |||| %{smart_count} CSPKs",
	"%smart_count_Items": "%{smart_count} Item |||| %{smart_count} Items",
	"%count_CSPKs": "%{count} CSPK |||| %{count} CSPKs",
	"%count_cases": "%{count} case |||| %{count} cases",
	"%count_items": "%{count} item |||| %{count} items",
	"%count_units": "%{count} unit |||| %{count} units",
	"#users": "%{smart_count} user |||| %{smart_count} users",
	"page_#": "page # %{smart_count}",
	"products": "%{smart_count} product |||| %{smart_count} products",
	"in_offer": "in offer",
	"accepted": "accepted",
	"declined": "declined",
	"category": "category",
	"download": "download",
	"page_hex": "accent color",
	"minimize": "minimize",
	"facebook": "facebook",
	"Facebook": "Facebook",
	"linkedin": "linkedin",
	"about_us": "about us",
	"position": "position",
	"currency": "currency",
	"received": "received",
	"show_all": "show all...",
	"show_advanced_pricing": "Show Advanced Pricing",
	"all_done": "ALL DONE",
	"settings": "settings",
	"multiple": "Multiple",
	"register": "register",
	"Register": "Register",
	"children": "children's",
	"allocate": "allocate",
	"inventory": "inventory",
	"available": "available",
	"compare": "compare",
	"size_name": "size name",
	"units_str": "units",
	"casepacks": "casepacks",
	"search...": "search...",
	"connected": "connected",
	"view_item": "view item",
	"reset_all": "reset all",
	"card_view": "card view",
	"list_view": "list view",
	"export_po": "download order details",
	"edit_mode": "edit mode",
	"unit_cost": "avg unit cost",
	"all_items": "All Items",
	"drag_drop": "drag & drop",
	"thank_you": "thank you!",
	"#buyers": "%{smart_count} buyer |||| %{smart_count} buyers",
	"#images": "%{smart_count} image |||| %{smart_count} images",
	"#offers": "%{smart_count} offer |||| %{smart_count} offers",
	"submitted": "submitted",
	"total_whl": "total WHL",
	"last_name": "last name",
	"Last_Name": "Last Name",
	"no_offers": "No other offers to show",
	"no_offers_selected": "No Offers Selected",
	"offers_%smart_count_selected": "%{smart_count} Offer Selected |||| %{smart_count} Offers Selected",
	"edit_logo": "edit logo",
	"add_photo": "add photo",
	"try_again": "try again",
	"uploading": "uploading",
	"processed": "processed",
	"pinterest": "pinterest",
	"suspended": "suspended",
	"negotiate": "negotiate",
	"job_title": "job title",
	"address_2": "address 2",
	"Address_2": "Address 2",
	"address_3": "address 3",
	"your_info": "your info",
	"add_sizes": "add sizes",
	"add_items": "add items",
	"drop_here": "drop here",
	"completed": "completed",
	"po_export": "Order Export",
	"maternity": "maternity",
	"new_label": "new label",
	"in_offers": "in offers",
	"In_Offers": "In Offers",
	"hide_price": "hide price",
	"avail_prod": "avail. products",
	"edit_sizes": "edit sizes",
	"view_items": "view items",
	"sizes_incl": "sizes incl.",
	"color_code": "color code",
	"color_may_vary": "color may vary",
	"unit_price": "unit price",
	"accept_buy": "accept & buy",
	"new_folder": "create new folder",
	"last_offer": "last offer",
	"view_sizes": "view sizes",
	"start_date": "start date",
	"total_cost": "total cost",
	"total_msrp": "total MSRP",
	"msrp_range": "MSRP Range",
	"%index_of_%count": "%{index} of %{count}",
	"#folders": "%{smart_count} folder |||| %{smart_count} folders",
	"select_all": "select all",
	"no_results": "No Results",
	"first_name": "first name",
	"First_Name": "First Name",
	"this_round": "this round",
	"offer_sent": "offer sent",
	"edit_photo": "edit photo",
	"Edit_Photo": "Edit Photo",
	"add_images": "add images",
	"processing": "processing",
	"successful": "successful",
	"department": "department",
	"offer_name": "offer name",
	"offer_title": "YOUR OFFER: %{title}",
	"send_offer": "send offer",
	"size_taken": "Size already exists, try entering a different size",
	"learn_more": "learn more",
	"start_over": "start over",
	"item_title": "item title",
	"edit_offer": "edit offer",
	"contact_us": "contact us",
	"one_number": "At least one number",
	"categories": "categories",
	"other_home": "Home",
	"unit_count": "total units",
	"allocation": "allocation",
	"view_offer": "VIEW OFFER",
	"sycning_img": "syning images",
	"add_product": "add product",
	"view_rollup": "view rollup",
	"hide_rollup": "hide rollup",
	"sync_images": "sync images",
	"Sync_Images": "Sync Images",
	"sizes_avail": "sizes avail.",
	"in_progress": "in progress",
	"print_offer": "print offer",
	"total_offer": "total offer",
	"total_price": "total price",
	"accept_sell": "accept & sell",
	"agree_offer": "agree to offer",
	"clear_draft": "clear draft",
	"download_po": "download order details",
	"draft_offer": "draft offer",
	"remove_item": "remove item",
	"total_items": "no. of items",
	"total_products": "no. of products",
	"no_of_units": "no. of units",
	"show_me_how": "show me how",
	"back_to_inv": "back to inventory & upload",
	"select_role": "Select Role",
	"emails_sent": "emails sent",
	"count_round": "round %{round}",
	"no_end_date": "no end date",
	"Clone_Successful": "Clone Successful",
	"clone_offer": "clone available",
	"Clone_Offer": "Clone Available",
	"create_item": "create new item",
	"edit_banner": "edit banner",
	"upload_file": "Upload File",
	"delete_item": "delete item",
	"website_url": "website url",
	"description": "description",
	"change_role": "change role",
	"color_title": "color",
	"offer_price": "offer price",
	"group_label": "group label",
	"grand_total": "grand total",
	"display_whl": "display WHL",
	"hide_review": "hide review",
	"close_offer": "close offer",
	"get_started": "GET STARTED",
	"price_items": "price items",
	"unpublished": "unpublished",
	"help-center": "help center",
	"folder_name": "folder name",
	"folder_info": "folder info",
	"no_products": "You have no products",
	"please_note": "Please Note",
	"import_info": "import info",
	"last_update": "last update",
	"view_images": "View images",
	"results_for": "results for",
	"history_for": "History for %{name}",
	"other_other": "Other",
	"tl_add_item": "Adding item...",
	"ts_add_item": "Item added successfully.",
	"te_add_item": "Item failed to add.",
	"total_units": "total units",
	"other_terms": "Shipping, Payment and Other Terms.",
	"view_offers": "view offers",
	"add_to_offer": "add to offer",
	"team_members": "team members",
	"select sizes": "select sizes",
	"item_gallery": "item gallery",
	"product_info": "product info",
	"total_amount": "total amount",
	"item_deleted": "product deleted",
	"show_filters": "show filters",
	"hide_filters": "hide filters",
	"accept_offer": "accept offer",
	"revoke_offer": "revoke offer",
	"submit_offer": "submit offer",
	"create_offer": "create offer",
	"remove_items": "remove items",
	"total_profit": "total profit",
	"save_confirm": "save & confirm",
	"not_in_offer": "not in offer",
	"no_of_styles": "no. of styles",
	"add_new_size": "add new size",
	"back_to_user": "back to your profile",
	"back_to_page": "back to \"%{page}\"",
	"invalid_file": "invalid file:  you must upload an .xls, .xlsx, .psv, or .csv",
	"deselect_all": "deselect all",
	"company_name": "company name",
	"company_logo": "company logo",
	"company_info": "company info",
	"phone_number": "phone number",
	"pending_user": "invited user - pending",
	"missing_data": "missing data",
	"offer_status": "offer status",
	"whl_high_low": "WHL (highest to lowest)",
	"whl_low_high": "WHL (lowest to highest)",
	"display_msrp": "display MSRP",
	"review_offer": "review offer",
	"delete_offer": "delete offer",
	"restrictions": "restrictions",
	"market_taken": "Market name already exists, try entering a different name",
	"update_sizes": "update sizes",
	"changed_item": "changed item",
	"images_added": "images added",
	"your_folders": "your folders",
	"Your_Folders": "Your Folders",
	"import_error": "Import Error",
	"edit_profile": "edit profile",
	"Edit_Profile": "Edit Profile",
	"baby_apparel": "Baby Apparel",
	"mens_apparel": "Men's Apparel",
	"edit_company": "edit company",
	"total_ticket": "total retail price",
	"unit_revenue": "avg retail price",
	"view_summary": "VIEW SUMMARY",
	"view_profile": "VIEW PROFILE",
	"view_history": "view history",
	"modify_offer": "modify offer",
	"edit_quantity": "edit total units",
	"security_code": "security code",
	"view_casepack": "view casepack",
	"reset_filters": "reset filters",
	"create_folder": "create folder",
	"counter_offer": "counter-offer",
	"negotiate_qty": "negotiate total units",
	"apply_filters": "apply filters",
	"discard_draft": "discard draft",
	"close_listing": "close listing",
	"current_offer": "current offer",
	"delete_folder": "delete folder",
	"changed_items": "changed items",
	"add_all_sizes": "add all sizes",
	"sizes_and_qty": "sizes and quantities",
	"Casepack_QTY": "Casepack QTY",
	"casepack_info": "casepack info",
	"default_title": "new item",
	"notifications": "%{smart_count} notification |||| %{smart_count} notifications",
	"error_generic": "an error has ocurred",
	"url_not_found": "Sorry the requested URL could not be found.",
	"total_include": "total incl.",
	"offer_sent_on": "You sent this offer on %{datestr}",
	"back_to_login": "Back to login",
	"back_to_previous_page": "Go back to previous page",
	"back_to_offer": "back to offer",
	"not_for_color": "not for color",
	"name_with_you": "%{name} (you)",
	"offer_expired": "offer expired",
	"decline_offer": "decline offer",
	"upload_images": "Upload Images",
	"save_and_exit": "save & exit",
	"look_like_you": "Looks like you are trying to remove all items by removing the sizes. To do this, just remove the item from the offer.",
	"other_actions": "other actions",
	"msrp_high_low": "MSRP (highest to lowest)",
	"msrp_low_high": "MSRP (lowest to highest)",
	"display_sizes": "display sizes",
	"details": "details",
	"inturn_id": "INTURN ID",
	"error_details": "error details",
	"date_imported": "date imported",
	"over_max_size": "Over Max File Size",
	"add_inventory": "Add Inventory",
	"updates_error": "Updates Error",
	"offer_history": "offer history",
	"Cloning_Offer": "Cloning Offer",
	"cloning_offer": "Cloning Offer...",
	"Cloning_Failed": "Cloning Failed",
	"clone_changes": "An offer is currently undergoing changes.",
	"baby_footwear": "Baby Footwear",
	"mens_footwear": "Men's Footwear",
	"photo_gallery": "photo gallery",
	"minimum_price": "minimum price",
	"maximum_price": "maximum price",
	"casepack_name": "casepack name",
	"not_in_offers": "not in offers",
	"Not_In_Offers": "Not In Offers",
	"loading_sizes": "loading sizes...",
	"select_market": "select market",
	"SELECT_MARKET": "SELECT MARKET",
	"my_draft_offer": "My Draft Offer",
	"companys_offer": "%{company}'s offer",
	"classification": "classification",
	"total_included": "total included",
	"view_casepacks": "view casepacks",
	"create_listing": "create listing",
	"click_to_reset": "click to reset",
	"sizes_included": "sizes included",
	"market_pricing": "market pricing",
	"download_excel": "download excel",
	"previous_offer": "previous offer",
	"revoking_offer": "Revoking offer",
	"rollup_summary": "rollup summary",
	"quantity_range": "Total Units Range",
	"percent_markup": "markup",
	"percent_margin": "Margin",
	"show_all_items": "Show All Items",
	"view_all_items": "view all items",
	"add_new_market": "add new market",
	"back_to_folder": "back to folder",
	"back_to_offers": "back to offers",
	"total_quantity": "total quantity",
	"#unitsString": "%{value} unit |||| %{value} units",
	"casepack_items": " %{smart_count} item |||| %{smart_count} items",
	"or_select_file": "...or select a file",
	"page_not_found": "Page Not Found (404)",
	"500_error_desc": "We're experiencing some issues, and should have them resolved soon. If you're not able to access this page in a few minutes, please contact support@inturn.co.",
	"status_viewing": "You received this offer",
	"status_editing": "You are editing your draft offer",
	"status_expired": "This listing has expired",
	"offer_submited": "offer submitted",
	"casepack_price": "casepack price",
	"required_field": "this field is required",
	"offer_accepted": "offer accepted",
	"listing_closed": "listing closed",
	"offer_declined": "offer declined",
	"privacy_policy": "privacy policy",
	"Privacy_Policy": "Privacy Policy",
	"confirm_delete": "confirm delete",
	"company_banner": "company banner",
	"clear_to_erase": "to remove, clear the text and save",
	"body_add_sizes": "Select the sizes you want to include in your offer from '%{product_name}'.  Once done, just click ADD TO OFFER.",
	"offer_is_empty": "this offer is empty.  please add items to see a rollup.",
	"no_restriction": "no restriction",
	"unpriced_items": "Show Unpriced Products Only",
	"compare_offers": "compare offers",
	"in_negotiation": "in negotiation",
	"offer_overview": "offer overview",
	"uploading_file": "uploading...",
	"edit_and_price": "Edit and Price",
	"Reset_Password": "Reset Password",
	"create_account": "create account",
	"i_accept_terms": "I accept the Terms of Service",
	"womens_apparel": "Women's Apparel",
	"can_not_delete": "This folder cannot be deleted at this time as there are items included in the following open offers:",
	"original_price": "original price",
	"total_original": "total original",
	"to_get_started": "to get started.",
	"distribute_all": "distribute all units",
	"Distribute_All_CSPKs": "Distribute All CSPKs",
	"add_allocation": "Add allocation",
	"remember_email": "remember email",
	"Remember_Email": "Remember Email",
	"view_inventory": "view inventory",
	"total_available": "total available",
	"forgot_password": "forgot password",
	"create_casepack": "create casepack",
	"sizes_available": "sizes available",
	"create_a_folder": "create a folder",
	"create_an_offer": "create an offer",
	"Create_an_Offer": "Create an Offer",
	"negotiate_price": "negotiate price",
	"offer_submitted": "Offer Submitted",
	"accepting_offer": "Accepting offer",
	"wholesale_range": "Wholesale Range",
	"total_casepacks": "total casepacks",
	"mandatory_field": "This field is mandatory.",
	"no_of_casepacks": "No. of Casepacks",
	"404_error_title": "404",
	"403_error_title": "403 Unauthorized",
	"500_error_title": "Internal Error (500)",
	"item_unit_count": "%{items} items • %{units} units",
	"status_declined": "This offer has been declined",
	"ready_to_submit": "ready to submit",
	"list_of_changes": "list of changes",
	"filter_show_all": "show all items",
	"pricing_options": "pricing options",
	"form_type_error": "wrong type",
	"save_and_review": "save and review",
	"search_products": "search items...",
	"end_negotiation": "end negotiation",
	"error_uploading": "error uploading",
	"company_address": "company address",
	"profile_picture": "profile picture",
	"group_type_name": "group name",
	"items_allocated": "Your items have been allocated",
	"title_add_sizes": "include your preferred sizes",
	"no_restrictions": "no restrictions",
	"review_and_send": "review & send",
	"too_large_limit": "File is too large. Must be less than %{limit}",
	"preparing_items": "Preparing items for syncing",
	"expiration_date": "expiration date",
	"add_buyers_link": "Select one or multiple Buyers",
	"More_Actions...": "More Actions...",
	"new_file_upload": "Fortunately, it's easy to upload a new one.",
	"file_read_error": "We couldn't read your file. Make sure it is the right format.",
	"do_in_this_file": "What would you like to do?",
	"upload_new_file": "Upload New File",
	"creating_folder": "creating folder",
	"upload_done_100": "upload done 100%",
	"inturns_network": "INTURN's Network",
	"error_searching": "error searching",
	"clone_edit_desc": "An offer from %{companyName} is currently undergoing changes. You will be notified if the offer is resent.",
	"change_password": "change password",
	"Change_Password": "Change Password",
	"special_apparel": "Special Sizes Apparel",
	"womens_footwear": "Women's Footwear",
	"select_currency": "Select a currency",
	"choose_currency": "Choose the currency most commonly used in your transactions",
	"display_profile": "Display in Profile",
	"your_categories": "Your Categories",
	"updating_folder": "updating folder",
	"actualize_offer": "actualize offer",
	"allocated_units": "allocated units",
	"remaining_units": "remaining units",
	"allocation_name": "allocation name",
	"desc_select_all": "Select all items in your current filter",
	"selected_market": "selected market",
	"my_current_offer": "My Current Offer",
	"sizes_and_ratios": "sizes and ratios",
	"work_in_progress": "work in progress",
	"submitting_offer": "Submitting offer",
	"percent_off_msrp": "% off MSRP",
	"update_inventory": "update inventory",
	"title_new_folder": "new folder",
	"import_new_coach": "Let's start by importing your inventory.",
	"remove_item_note": "Removing an item from a casepack will restore it back to inventory",
	"status_draft_qty": "select items to negotiate qty",
	"status_submitted": "You submitted this offer",
	"offer_expired_on": "This offer expired on %{datestr}",
	"i_agree_to_terms": "i agree to terms",
	"confirm_password": "confirm password",
	"search_casepacks": "Search casepacks...",
	"recommended_size": "recommended size",
	"Recommended_size:_%width_by_%height": "Recommended size: %{width} by %{height}",
	"terms_of_service": "terms of service",
	"Terms_of_Service": "Terms of Service",
	"simply_drag_drop": "simply drag & drop",
	"add_size_default": "size %{smart_count}",
	"ticket_price_asc": "retail price (lowest to highest)",
	"business_address": "business address",
	"wrong_credential": "Invalid email or password.",
	"create_new_group": "create new group",
	"create_or_search": "create or search",
	"allocating_items": "Your items are being allocated",
	"allocation_error": "Unable to allocate, please try again.",
	"uploading_images": "upload images",
	"select_a_version": "select a version",
	"purchasing_rules": "purchasing rules",
	"whats_your_title": "What's your title?",
	"offer_expiration": "Offer Expiration",
	"manage_inventory": "Manage Inventory",
	"UPDATE_INVENTORY": "Update complete",
	"error_processing": "Error processing image",
	"import_completed": "Import Completed",
	"image_sync_error": "Image Sync Error",
	"view_bid_history": "View item bid history",
	"edit_clone_offer": "Edit and Price Items",
	"current_password": "current password",
	"Current_Password": "Current Password",
	"Enter_Current_Password": "Enter Current Password",
	"we_sent_an_email": "We sent an email to %{email}. Follow the link provided in the email for password reset instructions.",
	"email_support_at": "Email support at",
	"eight_characters": "At least 8 characters",
	"baby_accessories": "Baby Accessories",
	"mens_accessories": "Men's Accessories",
	"children_apparel": "Children's Apparel",
	"your_price_range": "your price range",
	"about_offer_name": "about offer name",
	"tl_editing_offer": "Preparing your offer for Edit",
	"unit_offer_price": "avg unit price",
	"title_select_all": "select all items",
	"create_offer_now": "create offer now",
	"upload_inventory": "upload inventory",
	"percent_off_offer": "% off offer",
	"updated_inventory": "inventory updated!",
	"back_to_inventory": "back to inventory",
	"edit_your_profile": "edit your profile",
	"Edit_Your_Profile": "Edit Your Profile",
	"Profile_%userName": "Profile | %{userName}",
	"create_new_folder": "create new folder",
	"items_in_casepack": "items in casepack",
	"#units_assigned": "%{smart_count} unit assigned |||| %{smart_count} units assigned",
	"number_of_results": "%{start} - %{end} of %{total} ",
	"error_reload_page": "an error has ocurred. please reload the page.",
	"remove_item_error": "Item could not be removed.",
	"note_invalid_file": "The file format was invalid.",
	"replace_inventory": "replace inventory",
	"offer_accepted_on": "%{name} accepted this offer on %{datestr}",
	"listing_closed_on": "%{name} closed this listing on %{datestr}",
	"waiting_to_accept": "Waiting for %{name} to Accept",
	"password_strength": "password strength",
	"offer_received_on": "You received this offer on %{datestr}",
	"suspended_account": "suspended account",
	"quantity_high_low": "Total Units (highest to lowest)",
	"quantity_low_high": "Total Units (lowest to highest)",
	"ticket_price_desc": "retail price (highest to lowest)",
	"no_links_provided": "No links provided",
	"total_offer_price": "total price",
	"remove_allocation": "remove allocation",
	"allocation_rollup": "allocation rollup",
	"define_offer_name": "name & describe your offer",
	"offer_description": "offer description",
	"review_your_offer": "review your offer",
	"items_and_pricing": "items & pricing",
	"buyer_information": "buyer information",
	"no_files_uploaded": "Looks like you have no files uploaded.",
	"maximum_file_size": "maximum size per file: '10mb'",
	"no_offers_message": "Looks like you have no %{type}.",
	"no_photos_to_show": "No photos to show",
	"import_processing": "Import Processing",
	"updates_completed": "Updates Completed",
	"add_item_to_offer": "Add item to offer",
	"re_enter_password": "re-enter password",
	"Re_enter_password": "Re-enter password",
	"changing_password": "Changing password",
	"children_footwear": "Children's Footwear",
	"maternity_apparel": "Maternity Apparel",
	"negotiation_rules": "negotiation rules",
	"m_send_offer_text": "You are about to send this offer",
	"tsb_print_preview": "VIEW",
	"casepack_quantity": "casepack total units",
	"Casepack_Quantity": "Casepack Quantity",
	"unallocated_units": "unallocated units",
	"about_other_terms": "About Shipping, Payment and Terms",
	"dashboard_welcome": "welcome, %{fName}!",
	"inventory_summary": "inventory summary",
	"Inventory_Summary": "Inventory Summary",
	"too_many_requests": "too many requests",
	"units_per_casepack": "units per casepack",
	"casepacks_included": "casepacks included",
	"dismantle_casepack": "dismantle casepack",
	"show_changed_items": "Show Changed Items",
	"show_all_casepacks": "Show All Casepacks",
	"updating_inventory": "Updating inventory. Please check back shortly.",
	"add_from_inventory": "add from inventory",
	"included_casepacks": "included casepacks",
	"how_many_casepacks": "how many casepacks do you want to create?",
	"leftover_casepacks": "your leftover units are %{count}",
	"note_info_updating": "Updating your info",
	"Updating_your_info": "Updating your info",
	"status_draft_price": "select items to negotiate price",
	"rollup_calculation": "Rollup is calculated based on filter selection.",
	"add_pricing_option": "add pricing option",
	"items_per_casepack": "items per casepack",
	"items_selected": "Items Selected",
	"units_selected": "Units Selected",
	"item_offer_history": "item offer history",
	"view_current_offer": "view current offer",
	"social_media_links": "social media links",
	"department_default": "experience department",
	"new_market_default": "new market %{smart_count}",
	"product_categories": "product categories",
	"group_name_example": "(e.g. Stores)",
	"is_not_valid_email": "is not a valid email",
	"choose_your_buyers": "Add your Buyers",
	"allow_counteroffer": "Allow Buyers to Counter-Offer on Price",
	"start_and_end_date": "start & end date",
	"custom_restriction": "Custom restrictions",
	"casepacks_in_offer": "Only casepacks in my offer",
	"no_expiration_date": "no expiration date",
	"no_buyers_selected": "no buyers selected",
	"allocation_manager": "allocation rollup",
	"seller_information": "seller information",
	"new_product_upload": "Fortunately, it's easy to create a new one.",
	"define_folder_name": "define folder name",
	"sync_folder_images": "sync folder images",
	"add_folder_success": "Successfully created folder",
	"empty_ended_offers": "offers that have ended",
	"updates_processing": "Updates Processing",
	"export_po_complete": "Order export is complete",
	"back_to_offer_name": "back to offer %{name}",
	"buyer_actions_hold": "Buyer actions on this offer will be put on hold",
	"Enter_new_password": "Enter new password",
	"one_capital_letter": "At least one capital letter",
	"womens_accessories": "Women's Accessories",
	"m_delete_item_text": "You are about to delete this item.",
	"m_clone_offer_text": "You are about to clone this offer.",
	"m_agree_offer_text": "You are about to agree to this offer from %{company_name}.",
	"m_clear_draft_text": "You are about to clear your draft offer.",
	"allow_pickingitems": "Cherry-Pick Individual Items",
	"allow_pickingsizes": "Cherry-Pick Quantities of Items by Size",
	"invalid_size_ratio": "invalid size ratio",
	"upload_images_desc": "Images will sync with your items when new inventory is imported",
	"keyboard_shortcuts": "keyboard shortcuts",
	"empty_request_body": "The body of request must not be empty",
	"units_per_category": "Unit per Category",
	"size_distribution": "Size Distribution",
	"too_many_categories": "Too many categories in the offer to show a useful chart.",
	"too_many_sizes": "Too many sizes in category to show a useful chart. Choose a different category.",
	"offer_insights": "offer insights",
	"offer_insight_desc": "Offer Insights aims to provide a deep intuitive and high level understanding of offers between each party.",
	"original_offer": "original offer",
	"initial_offer": "Initial Offer",
	"All_Products": "All Products",
	"Only_Received_Products": "Only Received Products",
	"COMPARE_TO": "COMPARE TO",
	"manage_linesheet": "Manage Linesheet",
	"view_offer_link": "View Products in Offer",
	"empty_offer": "This column will populate once you start getting new rounds",
	"empty_offer_insight": "This section will populate once you start adding items to your offer",
	"invite_team_members": "Invite Team Members",
	"available_casepacks": "avail. casepacks",
	"num_available_units": "Available Units:  %{num}",
	"view_all": "View All",
	"view_filters": "View Filters",
	"%smart_count_results": "%{smart_count} Result |||| %{smart_count} Results",
	"num_total_products": "%{smart_count} Total Product |||| %{smart_count} Total Products",
	"total_products_str": "total products",
	"negotiate_price_qty": "negotiate price & qty",
	"resale_restrictions": "resale restrictions",
	"replacing_inventory": "Replacing inventory. Please check back shortly.",
	"inventory & uploads": "inventory & uploads",
	"max_no_of casepacks": "you can create %{smart_count} casepack |||| you can create %{smart_count} casepacks",
	"to_import_inventory": "to import inventory",
	"note_folder_deleted": "Folder has been deleted.",
	"units_in_a_casepack": "units per casepack",
	"emails_were_invited": "The emails you submitted were invited to join the team.",
	"we_will_contact_you": "We will be in contact with you right after",
	"your_listing_offers": "Your Listing Offers",
	"password_validation": "password must be at least 8 characters with 1 number and 1 letter",
	"password_hint_empty": "the more complex, the better",
	"you_will_get_offers": "You will get the offer history once buyers send you new offers",
	"image_not_for_color": "image not for color",
	"listing_declined_on": "%{name} declined this listing on %{datestr}",
	"view_previous_offer": "view previous offer",
	"note_item_no_images": "This item has no images",
	"phonenumber_default": "(000) 000-0000",
	"group_label_example": "(e.g. Century 21)",
	"allocations_removed": "Allocations removed",
	"error_allocate_zero": "You can not add by zero",
	"image_upload_failed": "image upload failed",
	"add_and_price_items": "add & price items",
	"show_items_in_offer": "Show only items in my offer",
	"tab_title_add_items": "items in inventory",
	"disallow_edit_sizes": "The sizes can not be updated while in active offers.",
	"network_unavailable": "Network unavailable. Waiting for connection...",
	"offer_card_declined": "Declined on %{declinedDate}",
	"no_folders_uploaded": "Looks like you have no folders created",
	"upload_another_file": "Feel free to browse around or upload another file while you wait.",
	"add_product_loading": "creating item",
	"add_product_success": "created item",
	"note_converted_from": "Converted from %{value} %{currency}",
	"incorrect_file_type": "Incorrect File Type",
	"all_fields_required": "All fields required",
	"avg_unit_price_sold": "AVG Unit Price Sold",
	"avg_unit_price": "AVG Unit Price",
	"avg_retail_price": "AVG Retail Price",
	"buyer_avg_retail_price": "Buyer AVG Retail Price",
	"initial_markup": "Initial Markup",
	"special_accessories": "Special Accessories",
	"m_submit_offer_text": "You are about to submit your draft offer to %{company_name}.",
	"m_accept_offer_text": "You are about to accept this offer from %{company_name}.",
	"m_revoke_offer_text": "You are about to revoke your offer to %{company_name}.",
	"m_delete_offer_text": "You are about to delete this offer.",
	"allow_online_resale": "Allow items to be re-sold online",
	"edit_offer_settings": "edit offer",
	"invalid_json_format": "The request contains invalid json format",
	"note_max_min_length": "Min. %{min} characters. Max. %{max} characters",
	"error_loading_sizes": "There was an error loading some sizes.",
	"m_modify_offer_help": "Be sure to communicate changes to products with your buyers.",
	"view_company_profile": "view company profile",
	"Upload_PO_(PDF)": "Upload PO (PDF)",
	"total_units_included": "total units included",
	"show_unchanged_items": "Show Unchanged Items",
	"forgot_your_password": "forgot your password?",
	"back_to_your_company": "back to your company",
	"note_info_form_error": "There are errors on your form. Please correct them and try again.",
	"you_receive_an_offer": "Once you receive an offer, you will see it listed here",
	"form_minlength_error": "too short",
	"form_maxlength_error": "too long",
	"reviewing_submission": "We will have our staff review your submission as soon as possible",
	"passwords_must_match": "passwords must match",
	"reset_password_title": "please use this form to set your password",
	"you_must_make_offers": "You will get the offer history once you make a new offer",
	"upload_new_file_desc": "Creates a new folder of inventory",
	"nothing_to_show_here": "nothing to show here",
	"removing_allocations": "Removing allocations",
	"image_upload_success": "image upload succeeded",
	"no_previous_versions": "There are no previous versions of this offer.",
	"select_an_item_group": "Name your offer, pick one or more buyers, select your settings and, add & price your items.",
	"whats_your_last_name": "What's your last name?",
	"buyer_margin_tooltip": "(retail price - unit price) / retail price",
	"buyer_initial_markup_tooltip": "(retail price - offer price) / offer price",
	"how_we_calculate_values": "How we calculate values",
	"no_items_added_price": "no items added/price",
	"add_price_items_link": "Add & Price Items",
	"disallow_edit_prices": "The prices can not be updated while in active offers.",
	"items_are_not_priced": "Some items are still not priced yet",
	"upload_images_folder": "upload images / folder",
	"file_being_processed": "Your file is being uploaded right now!",
	"image_upload_summary": "image upload summary",
	"file_changes_warning": "Be sure the file you select includes all items you want to keep in the folder. Any items not included in the file or that have a total units of 0 will be removed from the existing folder. Any offers containing replaced inventory will automatically be adjusted to reflect your changes.",
	"image_sync_completed": "Image Sync Completed",
	"export_po_processing": "Order export is processing",
	"edit_and_price_items": "edit items & price",
	"email_not_showing_up": "Email not showing up?",
	"one_lowercase_letter": "At least one lowercase letter",
	"Passwords_should_match": "Passwords should match",
	"children_accessories": "Children's Accessories",
	"info_used_in_profile": "This information will be used in your profile",
	"estimated_conversion": "estimated conversion",
	"filter_single_market": "To view the rest of the rollup, filter to view a single Market.",
	"m_send_offer_subtext": "will be notified",
	"total_original_price": "total original price",
	"note_max_allocations": "You have reached the maximum amount of allocations.",
	"existing_allocations": "existing allocations",
	"error_over_allocated": "You have already allocated 100% of units",
	"about_offer_name_tip": "Your offer name will be the first thing your buyers see when they receive your offer. When possible, it is best to list the brand, season, department (i.e. men’s, women’s, baby/child, plus size, etc.), and category/categories included in your offer. For example:  X Brand Spring 2016 Women’s Swimwear and Accessories.",
	"purchase_entireoffer": "Purchase entire offer",
	"percent_off_wholesale": "% off WHL",
	"casepack_item_removed": "Product successfully removed from casepack",
	"add_items_to_casepack": "add items to casepack",
	"item_unit_image_count": "%{items} items • %{units} units • %{imagesUploaded} images",
	"note_quantity_updated": "Total units have been updated.",
	"note_qty_update_error": "Total units could not be updated. Try again later.",
	"note_info_not_changed": "You have not changed any info",
	"status_accpeted_buyer": "Your offer was accepted",
	"filter_missing_images": "items missing images",
	"type_an_email_address": "Type an email address",
	"end_negotiation_error": "Could not end negotiation",
	"business_phone_number": "business phone number",
	"restore_offer_version": "restore offer version",
	"whats_your_first_name": "What's your first name?",
	"seller_margin_tooltip": "(unit price - cost) / unit price",
	"seller_markup_tooltip": "(unit price - cost) / cost",
	"failed_load_size_data": "failed to load sizes",
	"tab_title_price_items": "items in your offer",
	"must_upload_inventory": "You must upload inventory to create an offer",
	"send_offer_directions": "To send your offer navigate back to Offer Edit and click SEND OFFER.",
	"upload_new_attributes": "Select the file containing the updated  attributes.",
	"empty_accepted_offers": "accepted offers",
	"image_sync_processing": "Image Sync Processing",
	"export_offer_complete": "Export is ready",
	"selected_items_priced": "Selected Items Priced",
	"note_amount_to_submit": "Amount you will submit",
	"Re_enter_new_password": "Re-enter new password",
	"An_authentication_error_occured:": "An authentication error occured:",
	"change_password_error": "Please ensure your current password is correct.",
	"maternity_accessories": "Maternity Accessories",
	"submit_modal_currency": "Your offer will be submitted in the %{actual_currency} amount shown above, which has been converted from %{converted_currency}.",
	"m_delete_item_subtext": "This item will not be recoverable.",
	"m_clone_offer_subtext": "The offer will clone Buyers, Settings, and Items & Pricing, but not Expiration Date. You can find this offer in Unpublished Offers.",
	"m_clear_draft_subtext": "This cannot be undone.",
	"create_new_allocation": "create new allocation",
	"about_other_terms_tip": "This can include information about where your items are located and will be shipping from, which party is responsible for paying for shipping, how items will be shipped, payment terms (e.g. net-15 or net-30), how payment should be made (e.g. wire transfer, check, etc.), as well as any other information that your buyers should have upfront about shipping and payment.",
	"desc_open_sizes_modal": "View sizes for focused bid, or the first bid on the page if none is focused",
	"desc_close_size_modal": "Return to negotiation page from sizes view",
	"show_changed_casepacks": "Show Changed Casepacks",
	"create_new_folder_note": "Enter a title for the new folder.",
	"title_inventory_upload": "inventory & upload",
	"clear_draft_modal_desc": "You are about to clear your draft offer.",
	"note_updated_inventory": "Inventory has been updated.",
	"note_remove_item_error": "Item could not be removed.",
	"note_info_update_error": "Your info could not be updated. Please try again.",
	"Your_info_could_not_be_updated_Please_try_again": "Your info could not be updated. Please try again.",
	"status_draft_price_qty": "select items to negotiate price & qty",
	"status_accpeted_seller": "You accepted this offer",
	"ready_to_submit_status": "Reviewing your offer. Click Submit Offer, when ready.",
	"overlapping_list_title": "Overlapping offers that will be updated",
	"conflicting_list_title": "Conflicting offers that will be declined",
	"password_reset_success": "your password has been successfully reset",
	"change_allocation_desc": "You are about to change your current allocation and all items in your offer. Your pricing will be lost.",
	"remove_allocation_desc": "You are about to remove your current allocation and all items in your offer. Your pricing will be lost.",
	"remove_item_popup_desc": "You are trying to remove all of this item's sizes. If you want to remove this item from the offer now, click the button below.",
	"offer_display_settings": "offer display settings",
	"add_custom_restriction": "Add custom resale restrictions.",
	"add_a_restriction_link": "Add a Restriction",
	"offer_is_not_ready_yet": "Offer is not ready to be sent yet",
	"disallow_edit_casepack": "The casepack can not be edited while in active offers.",
	"offer_card_sent_status": "Sent on %{startDate} by %{username}",
	"update_file_quantities": "Update, Add, or Remove Products in a Folder",
	"upload_creating_folder": "By uploading this file, we will create a folder for you.",
	"please_try_again_later": "please try again later",
	"remove_item_from_offer": "Remove item from offer",
	"passwords_do_not_match": "Passwords do not match",
	"no_categories_provided": "No categories provided",
	"No_categories_provided.": "No categories provided.",
	"m_delete_casepack_text": "You are about to delete this casepack.",
	"m_submit_offer_subtext": "%{company_name} will be notified.",
	"m_end_negotiation_text": "You are about to end the negotiation with %{counterparty}",
	"m_delete_offer_subtext": "This cannot be undone.",
	"click_manage_inventory": "click manage inventory",
	"about_purchasing_rules": "about purchasing rules",
	"do_not_show_this_again": "Don't show this again",
	"title_open_sizes_modal": "open sizes view",
	"title_close_size_modal": "close sizes view",
	"offers_waiting_for_you": "offers waiting for you",
	"m_modify_offer_subtext": "You will be able to add, remove and price items as well as edit offer setting and rules. By clicking \"Withdraw Offer\" all unsubmitted buyer changes to this offer will be lost.",
	"download_excel_preview": "Download Excel Preview",
	"edit_quantity_and_sizes": "edit total units & sizes",
	"create_new_folder_coach": "Let's start by creating a folder.",
	"go_back_to_the_homepage": "Go back to the homepage.",
	"note_sizes_update_error": "Could not update sizes.",
	"filter_missing_key_data": "items missing key data",
	"password_hint_too_short": "your password must be 8 characters",
	"end_negotiation_success": "Negotiation ended successfully",
	"note_inventory_replaced": "inventory has been replaced",
	"disable_history_tooltip": "Offer history will appear after negotiating on this item",
	"view_product_categories": "view product categories",
	"title_remove_allocation": "Select the allocations from which you want to remove products.",
	"count_remove_allocation": "remove allocation from (%{count})",
	"you_must_enter_an_email": "You must enter an email.",
	"bid_submit_status_saved": "saved",
	"bid_submit_status_error": "error saving",
	"show_me_recommendations": "SHOW ME RECOMMENDATIONS ",
	"connect_with_person_now": "Connect with %{first_name} now",
	"listing_publish_loading": "Your offer is publishing...",
	"listing_publish_success": "Your offer was successfully published",
	"pricing_items_sucessful": "Pricing items successful",
	"offer_price_items_title": "add & price items",
	"disallow_delete_product": "The item can not be deleted while in active offers.",
	"offer_card_draft_status": "Drafting an offer to %{username}",
	"no_description_provided": "No description provided",
	"back_to_offers_overview": "back to offers overview",
	"available_once_uploaded": "This becomes available once you have items uploaded.",
	"update_attributes_error": "Update Attributes Error",
	"export_offer_processing": "download is processing",
	"nobody_to_recommend_yet": "Nobody to Recommend Yet",
	"note_offer_update_error": "There was an error updating your offer.  Please try again.",
	"change_password_success": "Password has been updated",
	"tl_price_items_in_offer": "Pricing selected items",
	"ts_price_items_in_offer": "Priced selected items successfully.",
	"te_price_items_in_offer": "Price items failed.",
	"m_agree_offer_l_subtext": "%{company_name} will be notified.",
	"m_accept_offer_subtext1": "By accepting this offer, you will be submitting %{overlaps} updated offers and declining %{conflicts} offers.",
	"m_accept_offer_subtext2": "The respective parties will be notified.",
	"m_revoke_offer_subtext1": "This cannot be undone..",
	"about_offer_description": "about offer description",
	"allow_pickingquantities": "Cherry-Pick Quantities of Items",
	"m_modify_offer_subtitle": "Include the items and prices from: ",
	"show_unchanged_casepacks": "Show Unchanged Casepacks",
	"clear_draft_modal_subtxt": "This cannot be undone..",
	"note_folder_name_updated": "Folder name has been updated.",
	"note_casepack_dismantled": "Casepack has been dismantled.",
	"note_info_update_success": "Your info has been successfully updated.",
	"close_listing_modal_desc": "You are about to close all offers.",
	"thank_you_for_submitting": "thank you for submitting",
	"counter_offer_successful": "counter-offer successful",
	"delete_folder_with_items": "This catalogue can not be deleted because it has active items in a listing",
	"no_phone_number_provided": "No phone number provided",
	"add_item_allocation_desc": "You are about to add this item to your allocation as well as your offer.",
	"time_machine_modal_title": "Restore Offer Versions",
	"restore_offer_to_version": "restore offer to version",
	"bid_submit_status_saving": "saving...",
	"Request Entity Too Large": "File or POST is too large",
	"write_custom_restriction": "Write your custom restrictions here",
	"working_on_several_files": "Working on several files",
	"successfully_upload_file": "we successfully uploaded your file. click next to process it.",
	"or_select_images_folders": "...or select a set of images",
	"how_to_upload_quantities": "First select the existing folder you would like to replace.",
	"too_many_filters_warning": "The number of filter options shown below may cause the page to load slowly. If you are experiencing problems, please contact support@inturn.co.",
	"body_currency_conversion": "Currency Converter will automatically change currencies in your INTURN account.",
	"note_currency_conversion": "Note:  All conversions are estimates.",
	"empty_unpublished_offers": "unpublished offers",
	"replace_quantities_error": "Replace Quantities Error",
	"note_profile_completed_1": "Your INTURN profile is now complete!",
	"note_profile_completed_2": "Now let's see if we can recommend some new connections for you.",
	"recommendations_settings": "Recommendations Settings",
	"to_continue_accept_terms": "To continue, you must accept the Terms of Service.",
	"this_is_a_required_field": "This is a required field",
	"category_recommendations": "Inturn uses this information to help you find the right connections.",
	"m_delete_casepacksubtext": "This cannot be undone..",
	"tl_add_casepack_to_offer": "Adding casepacks to your offer...",
	"ts_add_casepack_to_offer": "Casepacks added to your offer successfully.",
	"te_add_casepack_to_offer": "Casepacks failed to be added to your offer.",
	"popover_display_settings": "about offer display settings",
	"enter_term_reseale_rules": "Enter Terms & Resale Rules",
	"m_modify_offer_help_link": "Learn more about messaging",
	"invite_team_members_title": "Invite Team Members to Inturn",
	"back_to_previous_location": "Back to previous location",
	"overwrite_existing_prices": "overwrite existing prices",
	"error_network_unavailable": "we are unable to connect to the network at this time.",
	"tip_missing_key_data_text": "This item is either missing a title or cost, WHL and MSRP.",
	"note_sizes_update_success": "Sizes have been updated.",
	"select_items_to_negotiate": "Select Items to Negotiate",
	"change_allocation_subtext": "This cannot be undone..",
	"remove_allocation_subtext": "This cannot be undone..",
	"image_upload_partial_fail": "some images failed",
	"allow_counteroffer_subtxt": "",
	"add_items_by_pricing_them": "Add items to your offer and then price them.",
	"margin_markup_calculation": "Margin/Markup Calculation",
	"offer_add_product_loading": "Products are being added to your Offer",
	"offer_add_product_success": "Products were added to your Offer",
	"select_one_or_more_buyers": "Select your buyers or enter an email address to invite them to this offer",
	"add_items_from_allocation": "add items from allocation",
	"buyer_option_disable_hint": "Add/Remove buyers is not allowed once the offer is published",
	"offer_is_ready_to_be_sent": "Offer is ready to be sent",
	"offer_card_sent_status_to": "Sent on %{startDate} to %{username}",
	"offer_card_expired_status": "Expired on %{expiredDate}",
	"title_currency_conversion": "currency converter",
	"for_additional_assistance": "For additional assistance contact",
	"multiple_markets_selected": "multiple markets selected",
	"m_dismantle_casepack_text": "You are about to dismantle this casepack.",
	"m_end_negotiation_subtext": "This cannot be undone.",
	"m_decline_offer_from_text": "You are about to decline this offer from %{company_name}.",
	"tl_remove_item_from_offer": "Removing items from your offer...",
	"ts_remove_item_from_offer": "Items removed from your offer successfully.",
	"te_remove_item_from_offer": "Items failed to be removed from your offer.",
	"tl_print_preview_progress": "Loading print preview...%{progress}%",
	"duplicate_allocation_name": "Duplicate allocation name",
	"note_overwrite_allocation": "Assigning allocations on multiple items will overwrite any existing allocations on those items. Are you sure you would like to continue?",
	"choose_a_market_and_price": "choose a market, add & price items",
	"desc_sizes_modal_add_item": "When in sizes view, add item to your offer (if not included in offer)",
	"desc_navigate_size_modals": "When in sizes view, open sizes view for next or previous item",
	"desc_navigate_product_detail_modal": "When in product detail view, navigate to the next or previous item",
	"dashboard_offer_info_sent": "sent offers",
	"close_listing_modal_subtxt": "The respective parties will be notified.",
	"password_hint_more_complex": "your password must contain letters and numbers",
	"assign_all_sizes_to_groups": "assign all sizes to groups",
	"remove_item_from_offer_now": "remove item from offer now",
	"note_cost_is_never_visible": "(NOTE:  Your cost is never made visible to buyers.)",
	"allow_picking_items_subtxt": "Buyer may purchase individual items but must take all offered units and sizes of those items.",
	"allow_picking_sizes_subtxt": "Buyer may purchase quantities and sizes of items as desired.",
	"warning_max_add_to_listing": "A max of %{max} %{type} will be added at a time.",
	"offer_price_items_subtitle": "Add items to your offer then price them accordingly",
	"offer_card_received_status": "Received on %{receivedDate} from %{username}",
	"offer_card_accepted_status": "Accepted on %{acceptedDate} by %{username}",
	"item_is_currently_in_offer": "Item is currently in offer",
	"header_currency_conversion": "about currency converter",
	"buyer_actions_hold_verbose": "Buyers will not be able to take action on this offer until editing is completed. Are you sure you'd like to continue?",
	"be_sure_to_check_your_spam": "Be sure to check your spam folder.",
	"no_avg_unit_price_provided": "No AVG unit price provided",
	"about_purchasing_rules_tip": "The nature of your inventory, your business needs, and your relationship with the buyers will help determine which purchasing rule to select.\n\n“Purchase entire offer” is best if you need to liquidate all of the items you’re offering and can’t be left with any remaining inventory. Buyers will typically be more likely to agree to this type of offer if it includes highly popular/desireable items, if items are competitively priced, and if they generally have a favorable size run.\n\n“Cherry-pick individual items” gives buyers the ability to pick and choose which items they would like to purchase, but requires that they purchase all units of those items. Remember that buyers will be more likely to purchase items that have favorable size runs.\n\n“Cherry-pick quantities of items” allows buyers to choose how many of a particular item they would like to purchase, but does not allow them to change the size ratio you have offered. For example, if you offered 10 units of an item (4 small, 4 medium, 2 large) and your buyer counters by requesting 5, INTURN will automatically adjust the distribution accordingly: 2 small, 2 medium, 1 large. This rule is best if you want to give your buyers flexibility, but don’t want to be left with broken size runs for remaining items.\n\n“Cherry-pick quantities of items by size” gives buyers the most flexibility, and is typically used for offers that contain a very large assortment of items with high unit counts.\n",
	"title_sizes_modal_add_item": "add item to offer in sizes view",
	"title_navigate_size_modals": "navigate sizes view to next/previous item",
	"title_navigate_product_detail_modal": "Navigate product detail view to next/previous item",
	"dashboard_offer_info_ended": "ended offers",
	"modify_offer_loading_toast": "Modifying offer...",
	"withdraw_offer_loading_toast": "Withdrawing offer...",
	"item_removed_from_inventory": "Product removed from inventory",
	"casepack_contents_and_sizes": "casepack contents and sizes",
	"title_all_inventory_folders": "all inventory folders",
	"no_of_casepacks_modal_title": "No. of casepacks",
	"body_select_sizes_and_units": "Select the sizes you want to include in your allocation from '%{product_name}'.  Once done, just click ALLOCATE.",
	"remove_item_allocation_desc": "You are about to remove this item from your offer, it will also be removed from your allocation.",
	"add_item_allocation_subtext": "Are you sure you'd like to continue?",
	"time_machine_modal_subtitle": "Restore to a Previous Version",
	"product_list_item_image_url": "",
	"disallow_dismantle_casepack": "The casepack can not be dismantled while in active offers.",
	"update_file_quantities_desc": "Adjust quantities or add attributes to existing products",
	"see_todays_conversion_rates": "See today's conversion rates:  ",
	"empty_in_negotiation_offers": "offers in negotiation",
	"connection_request_received": "connection request received",
	"update_attributes_completed": "Update Attributes Completed",
	"discover_placeholder_search": "Search by name, company, title or department",
	"offer_actualized_item_title": "offer actualized on",
	"m_remove_item_from_casepack": "You are about to remove this item from a casepack",
	"header_overwrite_allocation": "you might be overwriting some allocations",
	"Allocate_To_Labels": "Allocate To Labels",
	"bulk_sizing_note": "Note: If any product contains less than desired quantity, it will add the maximum available.",
	"bulk_pricing_hint": "Lock top section to modify ONLY advanced pricing.",
	"about_offer_description_tip": "This can include any descriptive information about the items in your offer that will help your buyers make informed decisions upfront. For example:  General condition of items, How items are packed, If items include tags (and if so, what information is included)",
	"#view_pending_connections": "view %{smart_count} pending |||| view %{smart_count} pending",
	"dashboard_note_create_offer": "Get started by adding your inventory to an offer, pricing your items, and picking your buyers.",
	"title_inventory_upload_coach": "Inventory & upload is where you upload your inventory files and view your items.",
	"items_and_most_recent_offers": "Items & Most Recent Offers",
	"you_can_send_multiple_emails": "To invite more than one team member, use a comma between email addresses. (Example: 'user@company.com,user@company.com)'",
	"title_select_sizes_and_units": "select your sizes and units",
	"on_before_unload_bulk_images": "If you close the window now, your pending uploads will be cancelled",
	"purchase_entire_offer_subtxt": "Buyer must purchase all items and units offered.",
	"person_accepted_a_connection": "%{first_name} accepted your connection",
	"offer_remove_product_loading": "Products are being removed from your Offer",
	"offer_remove_product_success": "Products have been removed from your Offer",
	"market_currency_disable_hint": "Market currency is locked, because items/casepacks were already added to this offer.",
	"offer_card_processing_status": "This offer is currently going over changes....please check back in a few minutes",
	"seller_accepts_counteroffers": "The seller is accepting counter offers.",
	"inventory_upload_unavailable": "Inventory upload is currently unavailable",
	"replace_quantities_completed": "Replace Quantities Completed",
	"update_attributes_processing": "Update Attributes Processing",
	"enter_email_forgot_pass_desc": "Enter the email address associated with your INTURN account to receive password reset instructions.",
	"m_dismantle_casepack_subtext": "Dismantling a casepack removes all of its items and restores them back to inventory.",
	"m_no_of_casepacks_modal_desc": "No. of casepacks you can create:  %{smart_count}",
	"m_decline_offer_from_subtext": "Add a personal note or comment to %{firstname} %{last_name}",
	"about_offer_display_settings": "About Offer Display Settings",
	"desc_navigate_bidcard_inputs": "Submit any changes and select the next editable input",
	"desc_sizes_modal_remove_item": "When in sizes view, remove item from your offer (if included in offer)",
	"m_modify_offer_success_toast": "Successfully modified offer",
	"m_withdraw_offer_success_toast": "Successfully withdrawn offer",
	"some_items_are_yet_not_priced": "some items are not yet priced",
	"markets_missing_key_data_text": "To use this market, make sure to have at least one price.",
	"bid_quantity_modal_title_edit": "edit total units",
	"select_casepacks_to_negotiate": "Select Casepacks to Negotiate",
	"category_recommendations_desc": "Inturn uses this information to help you find the right connections.",
	"role_must_be_admin_or_manager": "Role must be Admin or Manager.",
	"person_requested_a_connection": "%{first_name} requested a connection",
	"offer_card_unpublished_status": "%{username} is still drafting the first offer",
	"please_wait_while_its_updated": "Please wait while it’s updated.",
	"select_file_upload_quantities": "Now select the file with the updated attributes.",
	"replace_quantities_processing": "Replace total units Processing",
	"note_offer_submitted_currency": "Your offer will be submitted in the *%{isoCode}* amount shown above, regardless of the selected currency conversion.",
	"forgot_password_expired_token": "The validation link to reset your password has expired after 24 hours. Please follow the instructions below to reset your password.",
	"allocated_(will_overwrite_existing_labels)": "allocated (will overwrite existing labels)",
	"title_navigate_bidcard_inputs": "navigate bid inputs",
	"title_sizes_modal_remove_item": "remove item from offer in sizes view",
	"dashboard_offer_info_accepted": "accepted offers",
	"dashboard_header_create_offer": "Add Inventory to Offers",
	"note_casepack_dismantled_error": "Casepack could not be dismantled.",
	"view_items_negotiation_history": "view item's negotiation history",
	"view_listings_settings_tooltip": "you can view listing settings here",
	"or_select_multiple_image_files": "... or select multiple image files",
	"remove_item_allocation_subtext": "Are you sure you'd like to continue?",
	"time_machine_modal_description": "INTURN keeps older versions of your draft offers for 30 days and auto-saves every 5 minutes. Select the version you want to restore.",
	"ensure_you_have_items_selected": "Ensure you have items selected.",
	"item_is_currently_not_in_offer": "Item is currently not in offer",
	"casepack_is_currently_in_offer": "Casepack is currently in offer",
	"now_the_file_update_quantities": "Now select the file that will replace your existing inventory folder.",
	"pending_connections_empty_body": "You have no pending incoming connection requests.",
	"discovery_note_empty_inventory": "Once your inventory is uploaded, you'll be able to create and send offers to buyers.",
	"what_things_to_display_in_offer": "Choose which item attributes are visible to the buyers.",
	"allow_picking_quantities_subtxt": "Buyer may purchase desired quantities of items, but must maintain the offered size ratio of those items.",
	"onboarding_register_expired_msg": "Oops! The link that brought you here is more than 30 days old and has expired. Please contact your company admin to send you a new link.",
	"which_department_do_you_work_in": "Which department do you work in?",
	"file_changes_warning_allocation": "Allocations that can not maintain their total units will be cleared",
	"m_no_of_casepacks_modal_subtxt1": "How many casepacks do you want to create?",
	"m_no_of_casepacks_modal_subtxt2": "No. of units left over:  %{smart_count}",
	"casepacks_and_most_recent_offers": "Casepacks & Most Recent Offers",
	"choose_your_negotiation_settings": "Choose Your Negotiation Settings",
	"price_and_add_items_disable_hint": "You can not edit items and prices because the buyers have begun negotiating on this offer.",
	"this_offer_is_going_over_changes": "This offer is currently going over changes.",
	"popover_display_settings_content": "These can include ticketing requirements, etc.",
	"about_offer_display_settings_tip": "The more information your buyers have, the higher the price you’re likely to receive for your offer. We recommend checking each of these item attributes to make them all visible to your buyers. However, if you are a reseller and your wholesale price is equivalent to your cost, you may want to consider not displaying wholesale to your buyers.",
	"dashboard_offer_info_unpublished": "unpublished offers",
	"discovery_header_empty_inventory": "Let's get your Inventory on INTURN!",
	"bid_quantity_modal_title_readonly": "view total units",
	"note_currency_conversion_disabled": "For your convenience, these currencies are not converted.",
	"this_is_not_a_valid_email_address": "This is not a valid email address.",
	"desc_submit_current_bidcard_input": "Submit the current value of the input which is focused",
	"tn_create_offer_previous_settings": "For your convenience the settings from your last offer have been pre-populated",
	"buyer_must_respond_before_set_date": "Buyers must respond to your offer by the expiration date, or they will no longer be able to accept or counter your offer.",
	"offer_card_sent_status_no_end_date": "Sent on %{startDate} by %{username}",
	"casepack_is_currently_not_in_offer": "Casepack is currently not in offer",
	"label_currency_conversion_dropdown": "Convert All Currencies to",
	"m_remove_item_from_casepack_subtxt": "This cannot be undone..",
	"note_invalid_offer_actualize_value": "%{key} must be at least %{min}.  Please correct and try again",
	"title_submit_current_bidcard_input": "submit current bid input",
	"count_assign_selected_to_allocation": "assign (%{count}) to allocation",
	"product_list_item_allocate_image_url": "",
	"seller_does_not_accept_counteroffers": "The seller is not accepting counter offers",
	"offer_card_sent_status_to_no_end_date": "Sent on %{startDate} to %{username}",
	"file_changes_warning_allocation_modal": "Please Note:  Any changes made will update the '%{allocationName}' allocation. If quantities need to be taken from another allocation, then affected allocations will be emptied for this item.",
	"You_must_select_at_least_one_category": "You must select at least one category",
	"There_was_an_error_updating_categories": "There was an error updating your categories",
	"There_was_an_error_updating_user_avatar": "There was an error updating user avatar",
	"There_was_an_error_updating_password": "There was an error updating password",
	"Updating_categories": "Updating categories",
	"You_successfully_updated_your_categories": "You successfully updated your categories",
	"some_information_provided_here_is_private": "Some information provided here is private and only visible to you.",
	"note_allocation_manager_sidebar_empty_state": "You don’t have any allocations for this Market yet. Please select another Market.",
	"packs_from_each_casepack": "packs from each casepack",
	"units_from_each_item": "units from each item",
	"toast_loading": "loading",
	"toast_success": "success",
	"toast_error": "error",
	"toast_notice": "notice",
	"enter_your_message": "Enter your message...",
	"message_with_username": "message %{username}",
	"new_message": "new message",
	"note_select_recipient": "Select a recipient to get the conversation started.",
	"close_message": "close message",
	"compose_message": "compose message",
	"inbox": "inbox",
	"note_empty_thread_state": "Your conversations will be shown here.",
	"back_to_inbox": "back to inbox",
	"title_report_thread": "report abuse",
	"header_report_thread": "You are about to report this message thread for possible spam or abuse",
	"body_report_thread": "Tell us a little more below and a customer service representative will look into this case for you.",
	"clear_recipient": "clear recipient",
	"offer_does_not_expire": "This offer does not expire.",
	"offer_does_expire_seller": "The buyer must respond to this offer by %{date} at %{time} or they will no longer be able to accept, or counter on this offer.",
	"offer_does_expire_buyer": "Please respond to this offer by %{date} at %{time}, otherwise you will no longer be able to accept, or counter on this offer.",
	"allow_counter_offer_seller": "You are allowing buyers to counter offer on price.",
	"do_not_allow_counter_offer_seller": "You are not allowing buyers to counter offer on price.",
	"take_all_seller": "The buyer must purchase all items offered.",
	"cherrypick_items_seller": "The buyer may purchase individual items but must take all offered units and sizes of those items.",
	"cherrypick_qty_total_seller": "The buyer may purchase desired quantities of items, but must maintain the offered size ratio of those items.",
	"cherrypick_qty_size_seller": "The buyer may purchase quantities and sizes of items as desired.",
	"allow_counter_offer_buyer": "You may counter offer on price.",
	"do_not_allow_counter_offer_buyer": "You may not counter offer on price.",
	"take_all_buyer": "You must purchase all items offered.",
	"cherrypick_items_buyer": "You may purchase individual items but must take all offered units and sizes of those items.",
	"cherrypick_qty_total_buyer": "You may purchase desired quantities of items, but must maintain the offered size ratio of those items.",
	"cherrypick_qty_size_buyer": "You may purchase quantities and sizes of items as desired.",
	"terms_resale_rules": "Terms & Resale Rules",
	"no_terms_resale_rules": "No terms & resale rules",
	"my_network": "my network",
	"inventory_empty_state_text_no_config": "You have no inventory",
	"inventory_empty_state_subtext_no_config": "Fortunately, it's easy to add new inventory. Click \"Create Folder\" to get started.",
	"inventory_empty_state_learn": "Learn more about what you can do with your inventory.",
	"inventory_empty_state_text": "You have no inventory uploaded",
	"inventory_empty_state_subtext": "Fortunately, it's easy to upload new inventory. Click 'Upload Inventory' to get started.",
	"inventory_no_results_subtext": "There are no results for your search or filter selection. Reset to view your inventory.",
	"offers_empty_state_learn": "Learn more about offers",
	"offers_empty_state_text": "You have no offers",
	"offers_empty_state_subtext_seller": "Click \"Create Offer\" to get started.",
	"offers_empty_state_subtext_buyer": "Discover new sellers to connect with",
	"offers_empty_state_subtext_seller_with_offers": "To get started, click \"Create offer\" on the upper right of the page.",
	"offers_empty_state_subtext_seeler_can_not_create_offers": "We noticed you have no inventory. Upload new inventory before you can Create an Offer.",
	"offers_empty_state_subtext_no_inventory": "To create an offer, first upload some inventory.",
	"offers_no_results_subtext": "There are no results for your search or filter selection. Reset to view your offers.",
	"http_401": "You're not authenticated",
	"http_403": "You're not authorized to perform this operation",
	"http_404": "The resource is not found",
	"http_500": "There is some problem in the server",
	"lv_item_sku": "PRODUCT/INTURN ID",
	"lv_available_units": "Available\nUnits\n",
	"lv_total_units": "Units in\nOffer\n",
	"lv_units_per_casepack": "Units Per\nCasepack\n",
	"lv_available_casepacks": "Available\nCasepacks\n",
	"lv_casepacks_in_offer": "Casepacks\nin Offer\n",
	"lv_item_cost": "Unit Cost",
	"lv_unit_price_previous": "Previous Offer\nUnit Price\n",
	"lv_unit_price_current": "Your Offer\nUnit Price\n",
	"lv_total_price_previous": "Previous Offer\nTotal Price\n",
	"lv_total_price_current": "Your Offer\nTotal Price\n",
	"lv_percent_off_whl_previous": "Previous Offer\n% Off WHL\n",
	"lv_percent_off_whl_current": "Your Offer\n% Off WHL\n",
	"lv_percent_off_msrp_previous": "Previous Offer\n% Off MSRP\n",
	"lv_percent_off_msrp_current": "Your Offer\n% Off MSRP\n",
	"lv_margin": "Margin",
	"lv_retail_price": "Retail Price",
	"lv_markup": "Markup",
	"lv_add_or_remove": "Add or\nRemove\n",
	"lv_history": "Item\nHistory\n",
	"you_agreed_qty": "You Agreed to Qty",
	"buyer_agreed_qty": "Buyer Agreed to Qty",
	"seller_agreed_qty": "Seller Agreed to Qty",
	"you_agreed_price": "You Agreed to Price",
	"buyer_agreed_price": "Buyer Agreed to Price",
	"seller_agreed_price": "Seller Agreed to Price",
	"you_countered_qty": "You Changed Qty",
	"buyer_countered_qty": "Buyer Changed Qty",
	"seller_countered_qty": "Seller Changed Qty",
	"you_countered_price": "You Changed Price",
	"buyer_countered_price": "Buyer Changed Price",
	"seller_countered_price": "Seller Changed Price",
	"agreed_by_buyer": "Agreed by buyer",
	"changed_by_buyer": "Changed by buyer",
	"agreed_by_seller": "Agreed by seller",
	"changed_by_seller": "Changed by seller",
	"changed_by_you": "Changed by you",
	"view_error_title": "Oops! Something went wrong!",
	"view_error_desc1": "Don't worry, we've been notified.",
	"view_error_desc2": "We're on it!",
	"welcome_to_inturn": "Welcome To INTURN",
	"welcome_desc_1_buyer": "We're ready to streamline your buying process and give you access to new brands.",
	"welcome_desc_1_seller": "Click “Get Started” and answer a few short questions to get your account profile fully set up.",
	"welcome_desc_2_buyer": "We just need to know a little more about you.",
	"welcome_desc_3_buyer": "Click \"Get Started\" to answer a few short questions and you'll be on your way!",
	"onboarding_password_title": "First things first - let's set up your password.",
	"onboarding_password_desc": "You can change this at any time from your profile page.",
	"onboarding_info_title": "Tell us a little about yourself!",
	"onboarding_info_desc": "You can edit this information at any time from your profile page.",
	"onboarding_info_profile_pic": "Upload your Profile Picture",
	"onboarding_info_company_pic": "Upload your Company Logo",
	"onboarding_info_user_first_name": "What’s your first name?",
	"onboarding_info_user_last_name": "What's your last name?",
	"onboarding_info_user_title": "What's your title?",
	"onboarding_info_user_department": "In which department do you work?",
	"onboarding_categories_title_buyer": "What are your primary categories?",
	"onboarding_categories_title_seller": "What categories do you focus on?",
	"onboarding_categories_desc_buyer": "We’ll match you with sellers who specialize in these categories.",
	"onboarding_thank_you_title": "Thank you!",
	"onboarding_thank_you_desc": "Your INTURN profile is now complete!",
	"tl_export_po": "Exporting order details...",
	"ts_export_po": "Export order details successful.",
	"te_export_po": "Export order details failed.",
	"tl_send_offer": "Sending offer...",
	"ts_send_offer": "Offer sent successfully.",
	"te_send_offer": "Offer failed to send.",
	"tl_add_folder": "Adding folder...",
	"ts_add_folder": "Folder added successfully.",
	"te_add_folder": "Folder failed to add.",
	"tl_clone_offer": "Cloning offer...",
	"ts_clone_offer": "Offer cloned successfully.",
	"te_clone_offer": "Offer failed to clone.",
	"tl_delete_item": "Deleting item...",
	"ts_delete_item": "Item deleted successfully.",
	"te_delete_item": "Item failed to delete.",
	"tl_agree_offer": "Agreeing to Offer",
	"te_agree_offer": "Offer failed to agree",
	"ts_agree_offer": "Offer Agreed to successfully.",
	"tl_delete_size": "Deleting size...",
	"ts_delete_size": "Size deleted successfully.",
	"te_delete_size": "Size failed to delete",
	"tl_add_to_offer": "Adding to your offer",
	"ts_add_to_offer": "Added to offer successfully.",
	"te_add_to_offer": "Add to offer failed.",
	"tl_create_offer": "Creating offer...",
	"ts_create_offer": "Offer created successfully.",
	"te_create_offer": "Offer failed to create.",
	"tsb_clone_offer": "VIEW CLONED OFFER",
	"tl_update_offer": "Updating offer...",
	"ts_update_offer": "Your offer has been updated successfully.",
	"te_update_offer": "Offer failed to update.",
	"tl_submit_offer": "Submitting offer...",
	"ts_submit_offer": "Offer submitted successfully.",
	"te_submit_offer": "Offer failed to submit.",
	"tl_accept_offer": "Accepting offer...",
	"ts_accept_offer": "Offer accepted successfully.",
	"te_accept_offer": "Offer failed to accept.",
	"tl_revoke_offer": "Revoking offer...",
	"ts_revoke_offer": "Offer revoked successfully.",
	"te_revoke_offer": "Revoke offer failed.",
	"ts_export_offer": "Export offer successful.",
	"te_export_offer": "Export offer failed.",
	"tl_delete_offer": "Deleting offer...",
	"ts_delete_offer": "Offer deleted successfully.",
	"te_delete_offer": "Failed to delete offer.",
	"ts_restore_offer": "Offer restored successfully.",
	"te_restore_offer": "Offer failed to restore.",
	"tl_report_thread": "Sending report...",
	"ts_report_thread": "Report sent successfully.",
	"te_report_thread": "Report send failed.",
	"tl_delete_folder": "Deleting folder...",
	"ts_delete_folder": "Folder deleted successfully.",
	"te_delete_folder": "Folder failed to delete.",
	"tl_decline_offer": "Declining offer...",
	"ts_decline_offer": "Offer declined successfully.",
	"te_decline_offer": "Offer failed to decline.",
	"tl_print_preview": "Loading print preview...",
	"ts_print_preview": "Print preview ready.",
	"te_print_preview": "Print preview failed.",
	"tl_restore_version": "Restoring offer...",
	"tl_actualize_offer": "Actualizing offer...",
	"ts_actualize_offer": "Actualized offer successfully.",
	"te_actualize_offer": "Actualize offer failed.",
	"tl_remove_from_offer": "Removing from your offer",
	"ts_remove_from_offer": "Removed from your offer successfully.",
	"te_remove_from_offer": "Remove from offer failed.",
	"tl_edit_items_prices": "Preparing your offer for editing…",
	"ts_edit_items_prices": "Offer is ready for editing.",
	"te_edit_items_prices": "Offer failed to load into edit mode.",
	"tl_clear_draft_offer": "Clearing your draft offer...",
	"ts_clear_draft_offer": "Your draft offer was cleared successfully.",
	"te_clear_draft_offer": "Draft offer failed to be cleared.",
	"tl_add_item_to_offer": "Adding items to your offer...",
	"ts_add_item_to_offer": "Items added to your offer successfully.",
	"te_add_item_to_offer": "Items failed to be added to your offer.",
	"tl_close_negotiation": "Closing negotiation...",
	"ts_close_negotiation": "Negotiation closed successfully.",
	"te_close_negotiation": "Negotiation failed to close.",
	"tl_create_draft_offer": "Creating your draft offer...",
	"ts_create_draft_offer": "Your draft offer was created successfully.",
	"te_create_draft_offer": "Draft offer failed to be created.",
	"te_price_exceeds_1bil": "Price by value must be less than 1000000000. Please try again.",
	"tl_remove_casepack_from_offer": "Removing casepacks from your offer...",
	"ts_remove_casepack_from_offer": "Casepacks removed from your offer successfully.",
	"te_remove_casepack_from_offer": "Casepacks failed to be removed from your offer.",
	"pp_data_import": "data import processing",
	"pc_data_import": "data import complete",
	"pf_data_import": "data import failed",
	"pp_replace_qty": "update folder processing",
	"pc_replace_qty": "update folder complete",
	"pf_replace_qty": "update folder failed",
	"pp_update_attributes": "update Attributes processing",
	"pc_update_attributes": "update attributes complete",
	"pf_update_attributes": "update attributes failed",
	"pp_image_sync": "image sync processing",
	"pc_image_sync": "image sync complete",
	"pf_image_sync": "image sync failed",
	"pp_upload_images": "upload images processing",
	"pc_upload_images": "upload images complete",
	"pf_upload_images": "upload images failed",
	"end_negotiation_modal__disclaimer": "You are about to end negotiation with %{counterParty}.",
	"end_negotiation_modal__disclaimer--strong": "This cannot be undone",
	"end_negotiation_modal__explanation": "We value your feedback! Please tell us why you are ending this offer. This information will be shared with the %{counterPartyType} and with our account management team, in an effort to provide you with better service in the future.",
	"end_negotiation_modal__reason-label": "Please select the reason(s) why you are declining this offer",
	"end_negotiation_modal__other-reason-label": "Is there anything else that you would like to add?",
	"end_negotiation_modal__other-reason-placeholder": "You can leave a comment for the %{counterPartyType} or you can expand about your reason.",
	"end_negotiation_modal__button--submitting": "Ending negotiation...",
	"end_negotiation__offer_declined_by_me": "This offer was declined by you for the following reason(s):",
	"end_negotiation__offer_declined_by": "This offer was declined by %{userName} from %{companyName} for the following reason(s):",
	"end_negotiation__price_point_too_low": "Price point",
	"end_negotiation__price_point_too_high": "Price point",
	"end_negotiation__low_quantities_volume": "Low quantities / volume",
	"end_negotiation__products_distribution_mismatch": "Size distribution",
	"end_negotiation__categories_mismatch": "Category relevance or coverage",
	"end_negotiation__restrictions_mismatch": "Seller guidelines/restrictions",
	"end_negotiation__brand_mismatch": "Brand fit",
	"end_negotiation__missing_images": "Missing images",
	"end_negotiation__other": "Other (Please elaborate below)",
	"offerstatus__to_company": "to %{companyName}",
	"offerstatus__you_agreed": "You agreed to this offer",
	"offerstatus__someone_else_agreed": "%{creatorName} agreed to this offer",
	"offerstatus__offer_agreed": "Offer agreed upon",
	"offerstatus__you_sent": "You sent this offer",
	"offerstatus__someone_else_sent": "%{creatorName} sent this offer",
	"offerstatus__offer_received": "Offer received",
	"offerstatus__counteroffer_received": "Counteroffer Received",
	"offerstatus__you_sent_counteroffer": "You sent this counteroffer",
	"offerstatus__someone_else_sent_counteroffer": "%{creatorName} sent this counteroffer",
	"offerstatus__offer_accepted": "Offer accepted",
	"offerstatus__you_accepted": "You accepted this offer",
	"offerstatus__someone_else_accepted": "%{creatorName} accepted this offer",
	"offerstatus__you_ended": "You ended this offer",
	"offerstatus__someone_else_ended": "%{creatorName} ended this offer",
	"offerstatus__offer_was_ended": "Offer was ended",
	"offerstatus__offer_expired": "Offer expired",
	"offerstatus__offer_pending_changes": "Offer processing",
	"offerstatus__created_by_you": "Created by you",
	"offerstatus__created_by_someone_else": "Created by %{creatorName}",
	"offerstatus__from_name_of_company": "from %{userName} of %{companyName}",
	"offerstatus__by_name_of_company": "by %{userName} of %{companyName}",
	"offerstatus__by_name_from_company": "by %{userName} from %{companyName}",
	"offerstatus__to_name_of_company": "to %{userName} of %{companyName}",
	"offerstatus__for_name_of_company": "for %{userName} of %{companyName}",
	"offerstatus__from_name_of_company__multiple": "from %{count} users of %{companyName}",
	"offerstatus__by_name_of_company__multiple": "by %{count} users of %{companyName}",
	"offerstatus__by_name_from_company__multiple": "by %{count} users from %{companyName}",
	"offerstatus__to_name_of_company__multiple": "to %{count} users of %{companyName}",
	"offerstatus__for_name_of_company__multiple": "for %{count} users of %{companyName}",
	"full_state_name_AL": "Alabama",
	"full_state_name_AK": "Alaska",
	"full_state_name_AS": "American Samoa",
	"full_state_name_AZ": "Arizona",
	"full_state_name_AR": "Arkansas",
	"full_state_name_CA": "California",
	"full_state_name_CO": "Colorado",
	"full_state_name_CT": "Connecticut",
	"full_state_name_DE": "Delaware",
	"full_state_name_DC": "District Of Columbia",
	"full_state_name_FM": "Federated States Of Micronesia",
	"full_state_name_FL": "Florida",
	"full_state_name_GA": "Georgia",
	"full_state_name_GU": "Guam",
	"full_state_name_HI": "Hawaii",
	"full_state_name_ID": "Idaho",
	"full_state_name_IL": "Illinois",
	"full_state_name_IN": "Indiana",
	"full_state_name_IA": "Iowa",
	"full_state_name_KS": "Kansas",
	"full_state_name_KY": "Kentucky",
	"full_state_name_LA": "Louisiana",
	"full_state_name_ME": "Maine",
	"full_state_name_MH": "Marshall Islands",
	"full_state_name_MD": "Maryland",
	"full_state_name_MA": "Massachusetts",
	"full_state_name_MI": "Michigan",
	"full_state_name_MN": "Minnesota",
	"full_state_name_MS": "Mississippi",
	"full_state_name_MO": "Missouri",
	"full_state_name_MT": "Montana",
	"full_state_name_NE": "Nebraska",
	"full_state_name_NV": "Nevada",
	"full_state_name_NH": "New Hampshire",
	"full_state_name_NJ": "New Jersey",
	"full_state_name_NM": "New Mexico",
	"full_state_name_NY": "New York",
	"full_state_name_NC": "North Carolina",
	"full_state_name_ND": "North Dakota",
	"full_state_name_MP": "Northern Mariana Islands",
	"full_state_name_OH": "Ohio",
	"full_state_name_OK": "Oklahoma",
	"full_state_name_OR": "Oregon",
	"full_state_name_PW": "Palau",
	"full_state_name_PA": "Pennsylvania",
	"full_state_name_PR": "Puerto Rico",
	"full_state_name_RI": "Rhode Island",
	"full_state_name_SC": "South Carolina",
	"full_state_name_SD": "South Dakota",
	"full_state_name_TN": "Tennessee",
	"full_state_name_TX": "Texas",
	"full_state_name_UT": "Utah",
	"full_state_name_VT": "Vermont",
	"full_state_name_VI": "Virgin Islands",
	"full_state_name_VA": "Virginia",
	"full_state_name_WA": "Washington",
	"full_state_name_WV": "West Virginia",
	"full_state_name_WI": "Wisconsin",
	"full_state_name_WY": "Wyoming",
	"full_country_code_name_AF": "Afghanistan",
	"full_country_code_name_AX": "Åland Islands",
	"full_country_code_name_AL": "Albania",
	"full_country_code_name_DZ": "Algeria",
	"full_country_code_name_AS": "American Samoa",
	"full_country_code_name_AD": "Andorra",
	"full_country_code_name_AO": "Angola",
	"full_country_code_name_AI": "Anguilla",
	"full_country_code_name_AQ": "Antarctica",
	"full_country_code_name_AG": "Antigua and Barbuda",
	"full_country_code_name_AR": "Argentina",
	"full_country_code_name_AM": "Armenia",
	"full_country_code_name_AW": "Aruba",
	"full_country_code_name_AU": "Australia",
	"full_country_code_name_AT": "Austria",
	"full_country_code_name_AZ": "Azerbaijan",
	"full_country_code_name_BS": "Bahamas",
	"full_country_code_name_BH": "Bahrain",
	"full_country_code_name_BD": "Bangladesh",
	"full_country_code_name_BB": "Barbados",
	"full_country_code_name_BY": "Belarus",
	"full_country_code_name_BE": "Belgium",
	"full_country_code_name_BZ": "Belize",
	"full_country_code_name_BJ": "Benin",
	"full_country_code_name_BM": "Bermuda",
	"full_country_code_name_BT": "Bhutan",
	"full_country_code_name_BO": "Bolivia (Plurinational State of)",
	"full_country_code_name_BA": "Bosnia and Herzegovina",
	"full_country_code_name_BW": "Botswana",
	"full_country_code_name_BV": "Bouvet Island",
	"full_country_code_name_BR": "Brazil",
	"full_country_code_name_IO": "British Indian Ocean Territory",
	"full_country_code_name_BN": "Brunei Darussalam",
	"full_country_code_name_BG": "Bulgaria",
	"full_country_code_name_BF": "Burkina Faso",
	"full_country_code_name_BI": "Burundi",
	"full_country_code_name_KH": "Cambodia",
	"full_country_code_name_CM": "Cameroon",
	"full_country_code_name_CA": "Canada",
	"full_country_code_name_CV": "Cabo Verde",
	"full_country_code_name_KY": "Cayman Islands",
	"full_country_code_name_CF": "Central African Republic",
	"full_country_code_name_TD": "Chad",
	"full_country_code_name_CL": "Chile",
	"full_country_code_name_CN": "China",
	"full_country_code_name_CX": "Christmas Island",
	"full_country_code_name_CC": "Cocos (Keeling) Islands",
	"full_country_code_name_CO": "Colombia",
	"full_country_code_name_KM": "Comoros",
	"full_country_code_name_CG": "Congo",
	"full_country_code_name_CD": "Congo (Democratic Republic of the)",
	"full_country_code_name_CK": "Cook Islands",
	"full_country_code_name_CR": "Costa Rica",
	"full_country_code_name_CI": "Côte d'Ivoire",
	"full_country_code_name_HR": "Croatia",
	"full_country_code_name_CU": "Cuba",
	"full_country_code_name_CY": "Cyprus",
	"full_country_code_name_CZ": "Czech Republic",
	"full_country_code_name_DK": "Denmark",
	"full_country_code_name_DJ": "Djibouti",
	"full_country_code_name_DM": "Dominica",
	"full_country_code_name_DO": "Dominican Republic",
	"full_country_code_name_EC": "Ecuador",
	"full_country_code_name_EG": "Egypt",
	"full_country_code_name_SV": "El Salvador",
	"full_country_code_name_GQ": "Equatorial Guinea",
	"full_country_code_name_ER": "Eritrea",
	"full_country_code_name_EE": "Estonia",
	"full_country_code_name_ET": "Ethiopia",
	"full_country_code_name_FK": "Falkland Islands (Malvinas)",
	"full_country_code_name_FO": "Faroe Islands",
	"full_country_code_name_FJ": "Fiji",
	"full_country_code_name_FI": "Finland",
	"full_country_code_name_FR": "France",
	"full_country_code_name_GF": "French Guiana",
	"full_country_code_name_PF": "French Polynesia",
	"full_country_code_name_TF": "French Southern Territories",
	"full_country_code_name_GA": "Gabon",
	"full_country_code_name_GM": "Gambia",
	"full_country_code_name_GE": "Georgia",
	"full_country_code_name_DE": "Germany",
	"full_country_code_name_GH": "Ghana",
	"full_country_code_name_GI": "Gibraltar",
	"full_country_code_name_GR": "Greece",
	"full_country_code_name_GL": "Greenland",
	"full_country_code_name_GD": "Grenada",
	"full_country_code_name_GP": "Guadeloupe",
	"full_country_code_name_GU": "Guam",
	"full_country_code_name_GT": "Guatemala",
	"full_country_code_name_GG": "Guernsey",
	"full_country_code_name_GN": "Guinea",
	"full_country_code_name_GW": "Guinea-Bissau",
	"full_country_code_name_GY": "Guyana",
	"full_country_code_name_HT": "Haiti",
	"full_country_code_name_HM": "Heard Island and McDonald Islands",
	"full_country_code_name_VA": "Holy See",
	"full_country_code_name_HN": "Honduras",
	"full_country_code_name_HK": "Hong Kong",
	"full_country_code_name_HU": "Hungary",
	"full_country_code_name_IS": "Iceland",
	"full_country_code_name_IN": "India",
	"full_country_code_name_ID": "Indonesia",
	"full_country_code_name_IR": "Iran",
	"full_country_code_name_IQ": "Iraq",
	"full_country_code_name_IE": "Ireland",
	"full_country_code_name_IM": "Isle of Man",
	"full_country_code_name_IL": "Israel",
	"full_country_code_name_IT": "Italy",
	"full_country_code_name_JM": "Jamaica",
	"full_country_code_name_JP": "Japan",
	"full_country_code_name_JE": "Jersey",
	"full_country_code_name_JO": "Jordan",
	"full_country_code_name_KZ": "Kazakhstan",
	"full_country_code_name_KE": "Kenya",
	"full_country_code_name_KI": "Kiribati",
	"full_country_code_name_KR": "Korea (Republic of)",
	"full_country_code_name_KW": "Kuwait",
	"full_country_code_name_KG": "Kyrgyzstan",
	"full_country_code_name_LA": "Lao People's Democratic Republic",
	"full_country_code_name_LV": "Latvia",
	"full_country_code_name_LB": "Lebanon",
	"full_country_code_name_LS": "Lesotho",
	"full_country_code_name_LR": "Liberia",
	"full_country_code_name_LY": "Libya",
	"full_country_code_name_LI": "Liechtenstein",
	"full_country_code_name_LT": "Lithuania",
	"full_country_code_name_LU": "Luxembourg",
	"full_country_code_name_MO": "Macao",
	"full_country_code_name_MK": "Macedonia (the former Yugoslav Republic of)",
	"full_country_code_name_MG": "Madagascar",
	"full_country_code_name_MW": "Malawi",
	"full_country_code_name_MY": "Malaysia",
	"full_country_code_name_MV": "Maldives",
	"full_country_code_name_ML": "Mali",
	"full_country_code_name_MT": "Malta",
	"full_country_code_name_MH": "Marshall Islands",
	"full_country_code_name_MQ": "Martinique",
	"full_country_code_name_MR": "Mauritania",
	"full_country_code_name_MU": "Mauritius",
	"full_country_code_name_YT": "Mayotte",
	"full_country_code_name_MX": "Mexico",
	"full_country_code_name_FM": "Micronesia (Federated States of)",
	"full_country_code_name_MD": "Moldova (Republic of)",
	"full_country_code_name_MC": "Monaco",
	"full_country_code_name_MN": "Mongolia",
	"full_country_code_name_ME": "Montenegro",
	"full_country_code_name_MS": "Montserrat",
	"full_country_code_name_MA": "Morocco",
	"full_country_code_name_MZ": "Mozambique",
	"full_country_code_name_MM": "Myanmar",
	"full_country_code_name_NA": "Namibia",
	"full_country_code_name_NR": "Nauru",
	"full_country_code_name_NP": "Nepal",
	"full_country_code_name_NL": "Netherlands",
	"full_country_code_name_NC": "New Caledonia",
	"full_country_code_name_NZ": "New Zealand",
	"full_country_code_name_NI": "Nicaragua",
	"full_country_code_name_NE": "Niger",
	"full_country_code_name_NG": "Nigeria",
	"full_country_code_name_NU": "Niue",
	"full_country_code_name_NF": "Norfolk Island",
	"full_country_code_name_MP": "Northern Mariana Islands",
	"full_country_code_name_NO": "Norway",
	"full_country_code_name_OM": "Oman",
	"full_country_code_name_PK": "Pakistan",
	"full_country_code_name_PW": "Palau",
	"full_country_code_name_PS": "Palestine, State of",
	"full_country_code_name_PA": "Panama",
	"full_country_code_name_PG": "Papua New Guinea",
	"full_country_code_name_PY": "Paraguay",
	"full_country_code_name_PE": "Peru",
	"full_country_code_name_PH": "Philippines",
	"full_country_code_name_PN": "Pitcairn",
	"full_country_code_name_PL": "Poland",
	"full_country_code_name_PT": "Portugal",
	"full_country_code_name_PR": "Puerto Rico",
	"full_country_code_name_QA": "Qatar",
	"full_country_code_name_RE": "Réunion",
	"full_country_code_name_RO": "Romania",
	"full_country_code_name_RU": "Russian Federation",
	"full_country_code_name_RW": "Rwanda",
	"full_country_code_name_BL": "Saint Barthélemy",
	"full_country_code_name_SH": "Saint Helena, Ascension and Tristan da Cunha",
	"full_country_code_name_KN": "Saint Kitts and Nevis",
	"full_country_code_name_LC": "Saint Lucia",
	"full_country_code_name_MF": "Saint Martin (French part)",
	"full_country_code_name_PM": "Saint Pierre and Miquelon",
	"full_country_code_name_VC": "Saint Vincent and the Grenadines",
	"full_country_code_name_WS": "Samoa",
	"full_country_code_name_SM": "San Marino",
	"full_country_code_name_ST": "Sao Tome and Principe",
	"full_country_code_name_SA": "Saudi Arabia",
	"full_country_code_name_SN": "Senegal",
	"full_country_code_name_RS": "Serbia",
	"full_country_code_name_SC": "Seychelles",
	"full_country_code_name_SL": "Sierra Leone",
	"full_country_code_name_SG": "Singapore",
	"full_country_code_name_SK": "Slovakia",
	"full_country_code_name_SI": "Slovenia",
	"full_country_code_name_SB": "Solomon Islands",
	"full_country_code_name_SO": "Somalia",
	"full_country_code_name_ZA": "South Africa",
	"full_country_code_name_GS": "South Georgia and the South Sandwich Islands",
	"full_country_code_name_ES": "Spain",
	"full_country_code_name_LK": "Sri Lanka",
	"full_country_code_name_SD": "Sudan",
	"full_country_code_name_SR": "Suriname",
	"full_country_code_name_SJ": "Svalbard and Jan Mayen",
	"full_country_code_name_SZ": "Swaziland",
	"full_country_code_name_SE": "Sweden",
	"full_country_code_name_CH": "Switzerland",
	"full_country_code_name_SY": "Syrian Arab Republic",
	"full_country_code_name_TW": "Taiwan",
	"full_country_code_name_TJ": "Tajikistan",
	"full_country_code_name_TZ": "Tanzania, United Republic of",
	"full_country_code_name_TH": "Thailand",
	"full_country_code_name_TL": "Timor-Leste",
	"full_country_code_name_TG": "Togo",
	"full_country_code_name_TK": "Tokelau",
	"full_country_code_name_TO": "Tonga",
	"full_country_code_name_TT": "Trinidad and Tobago",
	"full_country_code_name_TN": "Tunisia",
	"full_country_code_name_TR": "Turkey",
	"full_country_code_name_TM": "Turkmenistan",
	"full_country_code_name_TC": "Turks and Caicos Islands",
	"full_country_code_name_TV": "Tuvalu",
	"full_country_code_name_UG": "Uganda",
	"full_country_code_name_UA": "Ukraine",
	"full_country_code_name_AE": "United Arab Emirates",
	"full_country_code_name_GB": "United Kingdom of Great Britain",
	"full_country_code_name_US": "United States of America",
	"full_country_code_name_UM": "United States Minor Outlying Islands",
	"full_country_code_name_UY": "Uruguay",
	"full_country_code_name_UZ": "Uzbekistan",
	"full_country_code_name_VU": "Vanuatu",
	"full_country_code_name_VE": "Venezuela",
	"full_country_code_name_VN": "Viet Nam",
	"full_country_code_name_VG": "Virgin Islands (British)",
	"full_country_code_name_VI": "Virgin Islands (U.S.)",
	"full_country_code_name_WF": "Wallis and Futuna",
	"full_country_code_name_EH": "Western Sahara",
	"full_country_code_name_YE": "Yemen",
	"full_country_code_name_ZM": "Zambia",
	"full_country_code_name_ZW": "Zimbabwe",
	"manage_inventory_items": "Manage Inventory Items",
	"manage_inventory_casepacks": "Manage Inventory Casepacks",
	"casepack_profile": "View Casepack",
	"update_Casepack_profile": "Update Casepack",
	"update_product_profile": "Update Product",
	"product_profile": "View Product",
	"offers_in_negotiation": "Offers in Negotiation",
	"accepted_offers": "Accepted Offers",
	"ended_offers": "Ended Offers",
	"update_offer": "Update Offer",
	"offer_negotiation_overview": "Negotiation Overview",
	"offer_negotiation": "Offer Negotiation",
	"add_items_to_offer": "Add to Offer",
	"add_casepacks_to_offer": "Add to Offer",
	"price_offer_products": "Price Offer",
	"company_profile": "Company Profile",
	"update_company_profile": "Update Company Profile",
	"user_profile": "User Profile",
	"update_user_profile": "Update Profile",
	"unpublished_offers": "Unpublished Offers",
	"item_bid_history": "Negotiation History",
	"casepack_bid_history": "Negotiation History",
	"Move_Units": "Move Units",
	"catalog_error_no_data": "There is no valid data in your file to import. Please check your file or contact support.",
	"catalog_error_bad_format": "The header columns in your file are different than expected. Please check your file or contact support.",
	"catalog_error_could_not_create_items": "Item data is not valid. Please check your file or contact support.",
	"catalog_error_could_not_create_casepacks": "Casepack data is not valid. Please check your file or contact support.",
	"Processes": "Processes",
	"fullName_from_companyName_has_sent_you_a_new_offer.": "%{fullName} from %{companyName} has sent you a new offer.",
	"fullName_from_companyName_has_accepted_your_offer_on_offerName": "%{fullName} from %{companyName} has accepted your offer on %{offerName}",
	"fullName_from_companyName_has_sent_you_a_counter-offer_on_offerName": "%{fullName} from %{companyName} has sent you a counter-offer on %{offerName}.",
	"fullName_from_companyName_has_declined_your_offer_on_offerName": "%{fullName} from %{companyName} has declined your offer on %{offerName}",
	"fullName_from_companyName_has_revoked_their_offer_on_offerName": "%{fullName} from %{companyName} has revoked their offer on %{offerName}",
	"fullName_from_companyName_has_closed_negotiations__on_offerName": "%{fullName} from %{companyName} has closed negotiations on %{offerName}",
	"fullName_from_companyName_has_withdrawn_the_offer_offerName": "%{fullName} from %{companyName} has withdrawn the offer %{offerName}",
	"nt_upload_started": "Offer Upload Started",
	"nt_upload_completed": "Offer Upload Completed",
	"nt_upload_failed": "Offer Upload Failed",
	"items_in_your_ATS": "Products in your ATS",
	"items_in_your_offer": "Products in your Offer",
	"only_show": "only show",
	"items_in_my_offer": "Products IN my offer",
	"items_not_in_my_offer": "Products NOT IN my offer",
	"unpriced_items_in_my_offer": "UNPRICED products IN my offer",
	"filter_view_all": "All",
	"filter_view_in_offer": "In Offer",
	"filter_view_not_in_offer": "Not In Offer",
	"filter_view_unpriced": "Unpriced",
	"filter_view_item": "Item",
	"filter_view_casepack": "Casepack",
	"offer_available_to_sell": "Offer Available to Sell",
	"offers_received": "Received Offers",
	"offers_sent": "Sent Offers",
	"empty_sent_offers": "sent offers",
	"empty_received_offers": "received offers",
	"lineSheet_header_product": "products",
	"lineSheet_header_inventory": "inventory",
	"lineSheet_header_pricing": "pricing",
	"lineSheet_header_quantity": "quantity",
	"lineSheet_header_details": "details",
	"productNameInturnId": "Product Name / Inturn ID",
	"not_visible_to_seller": "Not visible to seller",
	"not_visible_to_buyer": "Not visible to buyer",
	"productName": "Product Name",
	"totalPrice": "total price",
	"unitPrice": "unit price",
	"percentOffWholesale": "% off WHL",
	"percentOffMSRP": "% off MSRP",
	"totalQuantity": "total units",
	"sizing": "sizing",
	"retailPrice": "retail price",
	"column_settings_CSPK_Cost": "CSPK Cost",
	"column_settings_Unit_Margin": "Unit Margin",
	"column_settings_Unit_Retail_Price": "Unit Retail Price",
	"column_settings_brand": "Brand",
	"column_settings_casepackPrice": "CSPK Price",
	"column_settings_casepackQuantity": "Casepack Quantity",
	"column_settings_category": "Category",
	"column_settings_classification": "Classification",
	"column_settings_color_title": "Color Title",
	"column_settings_cost": "Cost",
	"column_settings_department": "Department",
	"column_settings_division": "Division",
	"column_settings_margin": "Margin",
	"column_settings_markup": "Markup",
	"column_settings_material": "Material",
	"column_settings_percentOffMSRP": "% Off MSRP (MSRP Price)",
	"column_settings_percentOffWholesale": "% Off WHL (WHL Price)",
	"column_settings_program": "Program",
	"column_settings_retailPrice": "Retail Price",
	"column_settings_season": "Season",
	"column_settings_sizing": "Sizing",
	"column_settings_style": "Style",
	"column_settings_totalPrice": "Total Price",
	"column_settings_totalQuantity": "Total Units",
	"column_settings_unitPrice": "Unit Price",
	"column_settings_unitQuantity": "Unit Quantity",
	"column_settings_unitsInCasepack": "Units In Casepack",
	"column_order": "Column Order",
	"show_hide": "Show/Hide from View",
	"lowToHigh": "Low to High",
	"highToLow": "High to Low",
	"aToZ": "A to Z",
	"zToA": "Z to A",
	"cannot_hide_column": "Cannot hide this column",
	"sort_by_productName": "Sort Product Name By",
	"sort_by_sku": "Sort Inturn ID By",
	"sort_by_wholesalePercent": "Sort Wholesale Percent By",
	"sort_by_wholesalePrice": "Sort Wholesale Price By",
	"sort_by_msrpPercent": "Sort MSRP Percent By",
	"sort_by_msrpPrice": "Sort MSRP Price By",
	"sort_by_casepackQuantity": "Sort Casepack Total Units By",
	"sort_by_totalAvailableCasepacks": "Sort Total Available Casepacks By",
	"sort_by_unitQuantity": "Sort Total Units By",
	"sort_by_unitsAvailable": "Sort Units Available By",
	"sort_by_totalQuantity": "Sort Total Quantity By",
	"sort_by_totalAvailable": "Sort Total Available By",
	"seeAll": "See All",
	"linesheet_no_results": "Uh oh, no results to show.",
	"restore_version": "restore version...",
	"download_dropdown": "download...",
	"send_message_dropdown": "send a message",
	"view_keyboard_shortcuts": "view keyboard shortcuts",
	"advanced_actions": "advanced actions",
	"youve_accepted_offer": "You've accepted the offer",
	"counterparty_accepted_offer": "%{firstName} accepted your offer",
	"build_offer_or_go_back": "Build your offer or go back",
	"(%creator_name)_sent_you_an_offer.": "%{creator_name} sent you an offer.",
	"waiting_to_hear_from": "We are waiting to hear from %{firstName}",
	"send_message": "Questions? Send a message",
	"offer_ended_early": "Offer (ended early)",
	"include_max_quantity_up_to": "Include max quantity up to...",
	"counter_offer_not_allowed_tooltip_quantity": "Offer does not allow counter-offering on quantity",
	"counter_offer_not_allowed_tooltip_price": "Offer does not allow counter-offering on price",
	"counter_offer_not_allowed_tooltip_size": "Offer does not allow counter-offering on size",
	"take_all_offer_tooltip": "This is a take-all offer",
	"download_buyer_excel_view": "Download Excel (Buyer View)",
	"download_my_view": "Download Excel (My View)",
	"error_saving_retrying": "error saving...retrying in %{count} seconds",
	"retry_now": "retry now",
	"welcome_create_ats": "Hi %{creator_name}, let's create an offer",
	"add_items_back_overview": "Add items or go back to overview",
	"added_items_of_total_items": "You've added %{added_items} of %{total_items}",
	"add_and_price": "Add more and price",
	"add_or_continue": "Add more or continue",
	"casepackQuantity": "CSPK QTY",
	"unitQuantity": "Total Units",
	"number_of_sizes": "number of sizes",
	"Number_of_Sizes": "Number of Sizes",
	"Units_Per_CSPK": "Units Per CSPK",
	"cspks": "CSPKs",
	"CSPKs": "CSPKs",
	"filtered_not_in_offer": "filtered not in offer",
	"filtered_in_offer": "filtered in offer",
	"bid_status_changed_by_you": "you changed the %{type}",
	"bid_status_changed_by_counterparty": "%{counterParty} changed the %{type}",
	"bid_status_agreed": "you and %{counterParty} agreed on %{type}",
	"inturn_color": "Inturn Color",
	"inturn_color_title": "Inturn Color",
	"draft_offers": "draft offers",
	"offer_overview_title": "Offer",
	"offers_offer_overview": "Offers",
	"draft_offers_offer_overview": "Draft offers",
	"sizing_breakdown": "Sizing Breakdown",
	"Sizing_Breakdown": "Sizing Breakdown",
	"contacts": "contacts",
	"discover_contacts": "discover contacts",
	"my_contacts": "my contacts",
	"not_in_your_contacts": "not in your contacts",
	"searching_all_buyers": "searching all buyers",
	"Add_to_Contacts": "Add to Contacts",
	"Added_Contact": "Added Contact",
	"Remove_Contact": "Remove Contact",
	"remove_contact_modal_desc": "You are about to remove this user as a contact.",
	"You_are_about_to_remove_this_user_as_a_contact": "You are about to remove this user as a contact.",
	"select_or_search": "Select or Search...",
	"order_details_seller": "Order Details",
	"order_details_description": "Includes price and quantity details for the products in the offer.",
	"negotiation_exports_seller": "Negotiation Exports",
	"negotiation_exports_description": "Includes price, quantity and attribute details for all the products in the initial offer.",
	"linesheet_viewer_description": "As the seller, you can choose which view of the linesheet you want to download",
	"include_product_images": "Include Product Images",
	"include_product_images_description": "Images will be embedded into the excel file.",
	"include_product_images_warning": "Including images may increase the time it takes to download.",
	"seller_view": "Seller View",
	"buyer_view": "Buyer View",
	"download_options": "Download Options",
	"download_options_subtitle": "Choose your options and click Download Excel",
	"select_a_view": "Select A View",
	"need_to_add_buyer": "You must add at least one buyer to download.",
	"sales_restrictions": "sales restrictions",
	"sf_manage_linesheet": "Manage Linesheet",
	"sf_send_offer": "Send Offer",
	"personal_email_warning": "It looks like %{email} might be a personal email address. Most people use their business emails on the Inturn App.",
	"press_enter_to_add_email_buyer": "Press enter to add email to offer...",
	"something_wrong": "Something wrong? We're here to help:",
	"your_company_name": "your company name",
	"your_first_name": "your first name",
	"your_last_name": "your last name",
	"set_password": "set password",
	"show_password": "show password",
	"accept_terms_and_conditions": "accept terms & conditions",
	"Accept_Terms_&_Conditions": "Accept Terms & Conditions",
	"checking_this_box": "Checking this box means you agree to our",
	"Checking_this_box_means_you_agree_to_our": "Checking this box means you agree to our",
	"terms_and_conditions": "terms & conditions",
	"Terms_&_Conditions": "Terms & Conditions",
	"and": "and",
	"wrong_email": "Wrong email or already have an account?",
	"were_here_to_help": "We're here to help",
	"register_to_view": "register to view",
	"email_verification_sent": "email verification sent",
	"email_verification_sent_message": "We have sent a verification email to %{email}. Please click the link in the email to continue.",
	"send_again": "send again",
	"api_unable_to_connect": "Unable to connect at this time. Try again in a few minutes.",
	"offer_overview_v2__accept_it_as_is_or_edit_the_linesheet_to_counter": "Accept it as is, or edit the linesheet to counter.",
	"offer_overview_v2__accept_offer": "Accept Offer",
	"offer_overview_v2__accept_this_offer_to_continue_or_edit_the_linesheet_to_counter": "Accept this offer to continue, or edit the linesheet to counter.",
	"offer_overview_v2__complete_negotiations": "Complete Negotiations",
	"offer_overview_v2__complete_the_negotiations_or_edit_the_linesheet_to_counter": "Complete the negotiations, or edit the linesheet to counter.",
	"offer_overview_v2__congratulations_negotiations_are_complete": "Congratulations! Negotiations are complete.",
	"offer_overview_v2__edit_linesheet": "Edit Linesheet",
	"offer_overview_v2__negotiations_completed": "Negotiations Completed",
	"offer_overview_v2__negotiations_have_been_cancelled": "Negotiations have been cancelled.",
	"offer_overview_v2__negotiations_will_be_complete_as_soon_as_recipient_signs_off": "Negotiations will be complete as soon as %{counterPartyName} signs off.",
	"offer_overview_v2__offer_cancelled": "Offer Cancelled",
	"offer_overview_v2__offer_pending": "Offer Pending",
	"offer_overview_v2__offer_processing": "Offer Processing",
	"offer_overview_v2__offer_sent": "Offer Sent",
	"offer_overview_v2__please_check_back_soon": "Please check back soon.",
	"offer_overview_v2__products": "Products",
	"offer_overview_v2__recipient_hasnt_responded_yet": "%{counterPartyName} hasn't responded yet.",
	"offer_overview_v2__sales_restrictions": "Sales Restrictions",
	"offer_overview_v2__send_offer": "Send Offer",
	"offer_overview_v2__send_your_counteroffer_or_keep_editing": "Send your counteroffer, or keep editing.",
	"offer_overview_v2__sender_accepted_your_offer": "%{previousCreatorName} accepted your offer.",
	"offer_overview_v2__sender_from_your_team_accepted_this_offer": "%{creatorName} from your team accepted this offer.",
	"offer_overview_v2__sender_from_your_team_signed_off_on_this_offer": "%{creatorName} from your team signed off on this offer.",
	"offer_overview_v2__sender_sent_you_a_counteroffer": "%{counterPartyName} sent you a counteroffer.",
	"offer_overview_v2__sender_sent_you_a_take_all_offer": "%{counterPartyName} sent you a take-all offer.",
	"offer_overview_v2__sender_sent_you_an_offer": "%{counterPartyName} sent you an offer.",
	"offer_overview_v2__sender_signed_off_on_this_offer": "%{counterPartyName} signed off on this offer.",
	"offer_overview_v2__start_by_going_to_the_linesheet": "Start by going to the linesheet.",
	"offer_overview_v2__this_offer_has_ended": "This offer has ended.",
	"offer_overview_v2__this_offer_isnt_ready_yet": "This offer isn't ready yet.",
	"offer_overview_v2__view_linesheet": "View Linesheet",
	"offer_overview_v2__you_accepted_this_offer": "You accepted this offer.",
	"offer_overview_v2__you_added_all_products_without_making_changes": "You added all products without making changes.",
	"offer_overview_v2__you_can_accept_this_offer_or_end_it_to_decline": "You can accept this offer, or end it to decline.",
	"offer_overview_v2__you_ended_this_offer": "You ended this offer.",
	"offer_overview_v2__you_made_some_changes": "You made some changes.",
	"offer_overview_v2__you_signed_off_on_this_offer": "You signed off on this offer.",
	"%{declinerFirstName}_ended_this_offer.": "%{declinerFirstName} ended this offer.",
	"%{declinerFirstName}_from_your_team_ended_this_offer.": "%{declinerFirstName} from your team ended this offer.",
	"item_not_found": "Could not find item with style: %{style}, %{color}",
	"size_not_found": "Could not find size %{size} with style: %{style}, %{color}",
	"Offer_Upload_Summary": "Offer Upload Summary",
	"Offer_Upload_Description": "Uploading and processing your offer may take several minutes, especially for a larger file. You may close this message while the process continues. We will notify you when upload is completed.",
	"upload_completed": "Upload Completed %{percentage}%",
	"upload_not_completed": "Upload Not Completed",
	"Let's_work_together": "Let's work together",
	"Tell_the_brand_what_you're_looking_for": "Tell the brand what you're looking for",
	"Any": "Any",
	"Apply": "Apply",
	"Back": "Back",
	"Budget": "Budget",
	"Cancel": "Cancel",
	"Discard": "Discard",
	"Categories": "Categories",
	"Delete_Category": "Delete Category",
	"Expiration_Date": "Expiration Date",
	"Go_Back": "Go Back",
	"I_am_done": "I'm Done",
	"Give_the_seller_a_deadline_to_respond_to_your_request.": "Give the seller a deadline to respond to your request.",
	"Manage_Categories": "Manage Categories",
	"Additional_Information_Optional": "Additional Information (Optional)",
	"Message": "Message",
	"None": "None",
	"Please_provide_more_details_for_this_category,_if_applicable.": "Please provide more details for this category, if applicable.",
	"Send_Now": "Send Now",
	"Send_Request": "Send Request",
	"Total_Number_of_Styles": "Total Number of Styles",
	"Total_Budget": "Total Budget",
	"Total_Units": "Total Units",
	"Summary": "Summary",
	"Unit_Depth_per_Style": "Unit Depth per Style",
	"units_in_offer": "Units in Offer",
	"Uncategorized": "Uncategorized",
	"View_Message": "View Message",
	"Provide_the_seller_with_more_information_on_your_request.": "Provide the seller with more information on your request.",
	"You_are_about_to_send_your_request": "You are about to send your request",
	"Choose_which_categories_you_are_interested_in.": "Choose which categories you are interested in. This will help the brand create a more relevant offer for you.",
	"Your_request_was_sent": "Your request was sent",
	"Choose_Category": "Choose Category",
	"No_customization_provided_yet": "No customization provided yet",
	"Number_of_Styles": "Number of Styles",
	"Request_To_Buy": "Request To Buy",
	"My_Departments": "My Departments",
	"Budget_for_Category": "Budget for Category",
	"Additional_Category_Information": "Additional Category Information",
	"Get_In_Touch": "Get In Touch",
	"Total": "Total",
	"remove_from_offer": "Remove from Offer",
	"label_is_not_visible_to_counter_party": "%{label} is not visible to %{counterParty}",
	"item_information": "Item Information",
	"added_to_offer": "Added to Offer",
	"quantity_and_pricing": "Quantity and Pricing",
	"more_pricing_options": "More Pricing Options",
	"multi_item_casepack_info": "Refer to individual item for more details.",
	"multi_item_casepack_description": "Quantity of Casepacks will reflect in individual items below according to the casepack ratio.",
	"this_is_a_takeall_offer_for_review_only": "This is a take-all offer, for review only.",
	"changes_are_autosaved": "Changes are Autosaved",
	"Drag_&_Drop_to_Add_%fileType": "Drag & Drop to Add %{fileType}",
	"Drag_&_Drop": "Drag & Drop",
	"Or": "Or",
	"Select_%fileType_to_Upload": "Select %{fileType} to Upload",
	"Drop_to_Upload": "Drop to Upload",
	"Max._filesize_%fileSize": "Max. filesize %{fileSize}",
	"Uploading...": "Uploading...",
	"Deleting...": "Deleting...",
	"Upload_Error": "Upload Error",
	"Error_Deleting": "Error Deleting",
	"Upload_%fileType": "Upload %{fileType}",
	"Try_again?": "Try again?",
	"Company_Website": "Company Website",
	"Pinterest": "Pinterest",
	"LinkedIn": "LinkedIn",
	"Instagram": "Instagram",
	"No_phone_number_provided.": "No phone number provided.",
	"No_social_info_provided.": "No social info provided.",
	"No_address_provided.": "No address provided.",
	"Delete_Products_(%count)": "Delete Products (%{count})",
	"Delete_Products": "Delete Products",
	"These_products_will_no_longer_appear_in_your_inventory.": "This product will no longer appear in your inventory. |||| These products will no longer appear in your inventory.",
	"You_will_not_be_able_to_include_these_products_in_future_offers.": "You will not be able to include this product in future offers. |||| You will not be able to include these products in future offers.",
	"These_products_will_be_removed_from_any_unpublished_offers...": "This product will be removed from any unpublished offers it is currently in. |||| These products will be removed from any unpublished offers they are currently in.",
	"This_will_impact_%smart_count_unpublished_offers.": "This will impact (%{smart_count}) unpublished offer. |||| This will impact (%{smart_count}) unpublished offers.",
	"%count_of_these_products_cannot_be_deleted...": "%{count} of these products cannot be deleted because they are in active offers. If you choose to proceed, the delete action will not apply to them. because they are in active offers. If you choose to proceed, the delete action will not apply to them.",
	"Any_allocations_including_these_products_will": "Any allocations including these products will also be deleted. You will need to reassign allocation for the other products that currently share the same allocation(s). This will impact (%{count}) allocation(s).",
	"This_action_is_irreversible.": "This action is irreversible.",
	"Are_you_sure_you_want_to_delete?": "Are you sure you want to delete?",
	"Deleting_products...": "Deleting products...",
	"Products_deleted": "Products deleted",
	"No_products_matching_the_criteria_for_deletion.": "No products matching the criteria for deletion.",
	"%{smart_count}_of_these_products_cannot_be_deleted_because_they_are_already_in_offers,_the_delete_action_will_not_apply_to_them.": "%{smart_count} of these products cannot be deleted because it is already in an offer, the delete action will not apply to it. |||| %{smart_count} of these products cannot be deleted because they are already in offers, the delete action will not apply to them.",
	"Some_of_the_selected_products_are_in_offers._Any_products_in_offers_that_are_in_negotiation_will_not_be_deleted_from_your_inventory.": "Some of the selected products are in offers. Any products in offers that are in negotiation will not be deleted from your inventory.",
	"Some_of_the_selected_products_are_in_offers_and_will_not_be_deleted_from_your_inventory.": "Some of the selected products are in offers and will not be deleted from your inventory.",
	"All_selected_products_are_in_offers._We_are_unable_to_delete_these_products.": "All selected products are in offers. We are unable to delete these products.",
	"We’re_unable_to_delete_these_products_from_your_inventory.": "We’re unable to delete this product from your inventory. |||| We’re unable to delete these products from your inventory.",
	"This_action_is_irreversible._Do_you_want_to_continue?": "This action is irreversible. Do you want to continue?",
	"If_you_choose_to_proceed,_the_delete_action_will_not_apply_to_them.": "If you choose to proceed, the delete action will not apply to it. |||| If you choose to proceed, the delete action will not apply to them.",
	"Any_allocations_including_these_products_will_also_be_deleted.": "Any allocations including this product will also be deleted. |||| Any allocations including these products will also be deleted.",
	"You_will_need_to_reassign_allocation_for_the_other_products_that_currently_share_the_same_allocations.": "You will need to reassign allocation for the other products that currently share the same allocation. |||| You will need to reassign allocation for the other products that currently share the same allocations.",
	"This_will_impact_%smart_count_allocations.": "This will impact (%{smart_count}) allocation. |||| This will impact (%{smart_count}) allocations.",
	"View_Сomparison": "View Comparison",
	"Bulk_allocation_by_percent_will_round_to_the_closest_achievable_distribution": "Bulk allocation by percent will round to the closest achievable distribution.",
	"Enter_your_fixed_metric_and_lock_it_and_the_other_fields_will_calculate_accordingly": "Enter your fixed metric and lock it, and the other fields will calculate accordingly.",
	"Use_this_section_to_incorporate_your_buyer’s_estimated_pricing_as_you_draft_your_offer._Lock_price_values_to_help_calculate_your_intended_pricing.": "Use this section to incorporate your buyer’s estimated pricing as you draft your offer. Lock price values to help calculate your intended pricing.",
	"Fill_in_this_section_with_your_target_profit_and_use_the_lock_functionality_to_optimize_your_pricing.": "Fill in this section with your target profit and use the lock functionality to optimize your pricing.",
	"Estimate_Buyer_Pricing": "Estimate Buyer Pricing",
	"Set_Target_Profit": "Set Target Profit",
	"Offer_from:": "Offer from:",
	"Is_there_anything_else_that_you_would_like_to_add?": "Is there anything else that you would like to add?",
	"No_options...": "No options...",
	"All": "All",
	"Go_to:": "Go to:",
	"Search_this_Style": "Search this Style",
	"Company_Edit": "Company Edit",
	"Edit_Company": "Edit Company",
	"View_Company": "View Company",
	"Manage_My_Team": "Manage My Team",
	"Edit_Company_Profile": "Edit Company Profile",
	"Company_Logo": "Company Logo",
	"HQ_Phone_Number": "HQ Phone Number",
	"Contact_Info": "Contact Info",
	"How_would_you_describe_your_company_in_one_sentence?": "How would you describe your company in one sentence?",
	"The_company_logo_will_be_the_face_of_your_company_on_the_platform.": "The company logo will be the face of your company on the platform.",
	"Make_sure_to_upload_a_high_quality_image.": "Make sure to upload a high quality image.",
	"Company_Information": "Company Information",
	"Our_customer_is_always_looking_for_[XXXXXX]_and_we_deliver_exceptional_[XXXXXX]_and_[XXXXXX].": "Our customer is always looking for [XXXXXX] and we deliver exceptional [XXXXXX] and [XXXXXX].",
	"About_Us": "About Us",
	"Social": "Social",
	"You_have_unsaved_changes.": "You have unsaved changes.",
	"Make_your_company_profile_stand_out.": "Make your company profile stand out.",
	"Upload_at_least_4_images_to_start,_and_continue_updating_them_to_keep_your_profile_fresh.": "Upload at least 4 images to start, and continue updating them to keep your profile fresh.",
	"Lookbooks": "Lookbooks",
	"Upload_a_lookbook_to_let_buyers_know_what_your_brand_is_all_about.": "Upload a lookbook to let buyers know what your brand is all about.",
	"Gallery": "Gallery",
	"Users_love_a_good_lookbook.": "User’s love a good lookbook.",
	"We_recommend_at_least_10_high-quality_images_and_that_you_update_throughout_the_year.": "We recommend at least 10 high-quality images and that you update throughout the year.",
	"Delete": "Delete",
	"Delete_brand?": "Delete brand?",
	"If_you_have_more_than_one_brand,_you_can_display_all_of_them_on_your_company_profile.": "If you have more than one brand, you can display all of them on your company profile.",
	"Be_sure_to_include_the_brand_name_and_logo_for_each_one_that_you_add.": "Be sure to include the brand name and logo for each one that you add.",
	"Add_Brand": "Add Brand",
	"Save": "Save",
	"Save_Distribution": "Save Distribution",
	"Edit": "Edit",
	"Your_Brands": "Your Brands",
	"Product_Categories": "Product Categories",
	"Our_Brands": "Our Brands",
	"This_section_aggregates_categories_your_team_members_sell...": "This section aggregates categories your team members sell as represented in their user profiles.",
	"This_section_aggregates_categories_your_team_members_buy...": "This section aggregates categories your team members buy as represented in their user profiles.",
	"Interested_in_working_with_%companyName?": "Interested in working with %{companyName}?",
	"Tell_them_what_youre_looking_for.": "Tell them what you're looking for.",
	"Website_URL": "Website URL",
	"Category_Breakdown": "Category Breakdown",
	"Quantity": "Quantity",
	"Products": "Products",
	"Pricing": "Pricing",
	"Total_Price": "Total Price",
	"Margin": "Margin",
	"AVG": "AVG",
	"Total_Profit": "Total Profit",
	"WHL": "WHL",
	"Total_WHL_Value": "Total WHL Value",
	"Total_WHL": "Total WHL",
	"MSRP": "MSRP",
	"Total_MSRP_Value": "Total MSRP Value",
	"Total_MSRP": "Total MSRP",
	"Total_Cost_Value": "Total Cost Value",
	"Total_Retail_Price": "Total Retail Price",
	"OFF": "OFF",
	"ON": "ON",
	"Draft_Offer": "Draft Offer",
	"Final_Offer": "Final Offer",
	"Current_Offer": "Current Offer",
	"Initial_Offer": "Initial Offer",
	"Received_Offer": "Received Offer",
	"Sent_Offer": "Sent Offer",
	"Agreed_Offer": "Agreed Offer",
	"Ended_Offer": "Ended Offer",
	"Offer_Settings": "Offer Settings",
	"Quantities_Setting": "Quantities Setting",
	"Negotiation_Setting": "Negotiation Setting",
	"No_sales_restriction_provided": "No sales restriction provided",
	"You_can_purchase_selected_items": "You can purchase selected items",
	"Dimension_1": "Dimension 1",
	"Dimension_2": "Dimension 2",
	"View_Full_List": "View Full List",
	"Message_%user": "Message %{user}",
	"No_message_or_description_provided": "No message or description provided",
	"Offer_Summary": "Offer Summary",
	"This_offer_has_expired.": "This offer has expired.",
	"Upload_Counteroffer": "Upload Counteroffer",
	"Complete_the_negotiations,_or_edit_linesheet_to_counter.": "Complete the negotiations, or edit linesheet to counter.",
	"Additional_Settings": "Additional Settings",
	"Display_Settings_&_Sales_Restrictions": "Display Settings & Sales Restrictions",
	"Which_settings_would_you_like_the_buyer_to_see?": "Which settings would you like the buyer to see?",
	"Sales_Restrictions": "Sales Restrictions",
	"Are_there_any_sales_restrictions_or_other_information_the_buyer_needs_to_know?": "Are there any sales restrictions or other information the buyer needs to know?",
	"Show_WHL": "Show WHL",
	"Show_MSRP": "Show MSRP",
	"Show_Sizes": "Show Sizes",
	"Lets_get_started!": "Let's get started!",
	"Describe_the_offer_in_more_detail.": "Describe the offer in more detail.",
	"I've_put_together_a_selection_of_products_that_I_think_you'll_really_like._Please_review_and_let_me_know_what_you_think.": "I've put together a selection of products that I think you'll really like. Please review and let me know what you think.",
	"What_do_you_want_to_name_the_offer?": "What do you want to name the offer?",
	"Who_are_you_sending_the_offer_to?": "Who are you sending the offer to?",
	"Choose_a_market": "Choose a market",
	"Choose_a_channel": "Choose a channel",
	"Include_a_product_allocation": "Include a product allocation",
	"Select_buyers": "Select buyers",
	"Offer_name": "Offer name",
	"Select_an_Allocation": "Select an Allocation",
	"(%count)_Not_all_items_priced": "(%{count}) Not all items priced",
	"(%count)_Not_all_products_priced": "(%{count}) Not all products priced",
	"All_items_priced": "All items priced",
	"You_have_items_in_your_linesheet_that_have_not_been_assigned_a_price.": "You have items in your linesheet that have not been assigned a price.",
	"You_have_products_in_your_linesheet_that_have_not_been_assigned_a_price.": "You have products in your linesheet that have not been assigned a price.",
	"Great._All_your_items_have_prices.": "Great. All your items have prices.",
	"You_have_no_items_in_the_offer_yet.": "You have no items in the offer yet.",
	"Edit_Linesheet": "Edit Linesheet",
	"Send_Offer": "Send Offer",
	"Your_offer_is_ready.": "Your offer is ready.",
	"Send_your_offer,_or_keep_editing.": "Send your offer, or keep editing.",
	"We_need_a_bit_more_information_before_you_can_send_your_offer.": "We need a bit more information before you can send your offer.",
	"Keep_working_on_it.": "Keep working on it.",
	"Ensure_all_products_have_been_priced_and_offer_settings_are_complete.": "Ensure all products have been priced and offer settings are complete.",
	"Your_offer_is_looking_good.": "Your offer is looking good.",
	"You_have_%smart_count_products_in_your_offer.": "You have %{smart_count} product in your offer. |||| You have %{smart_count} products in your offer.",
	"Create_a_new_offer_or_allocate_units_to_an_existing_offer.": "Create a new offer or allocate units to an existing offer.",
	"Add_products_to_this_offer_to_get_started.": "Add products to this offer to get started.",
	"You've_added_all_products_to_this_offer_without_any_changes.": "You've added all products to this offer without any changes.",
	"You_can_keep_editing_or_accept_this_offer.": "You can keep editing or accept this offer.",
	"You_can_counter_on_price,_or_accept_this_offer.": "You can counter on price, or accept this offer.",
	"You_can_accept_this_offer,_or_end_it_to_decline.": "You can accept this offer, or end it to decline.",
	"You_can_keep_editing_or_send_this_offer.": "You can keep editing or send this offer.",
	"You_can_counter_or_accept_this_offer_as_is.": "You can counter or accept this offer as is.",
	"You_can_complete_the_negotiations,_or_edit_the_linesheet_to_counter.": "You can complete the negotiations, or edit the linesheet to counter.",
	"You_can_accept_this_offer,_or_edit_the_linesheet_to_counter.": "You can accept this offer, or edit the linesheet to counter.",
	"download_offer": "download offer",
	"Searching_all_buyers...": "Searching all buyers...",
	"Press_enter_to_add_%value_to_the_offer": "Press enter to add %{value} to the offer",
	"Buyer_can_choose_products_by_style,_quantities_per_style_and_quantities_per_style_size": "Buyer can choose products by style, quantities per style and quantities per style size",
	"Buyer_can_choose_products_by_style_and_quantities_per_style": "Buyer can choose products by style and quantities per style",
	"Buyer_can_choose_products_by_style": "Buyer can choose products by style",
	"This_is_a_TAKE-ALL_OFFER": "This is a TAKE-ALL OFFER",
	"Buyer_can_counter_on_price": "Buyer can counter on price",
	"Buyer_cannot_counter_on_price": "Buyer cannot counter on price",
	"Quantity_and_Sizing_Negotiation": "Quantity and Sizing Negotiation",
	"Pricing_Negotiation": "Pricing Negotiation",
	"Add_an_Offer_Expiration_Date": "Add an Offer Expiration Date",
	"Expires_on": "Expires on",
	"Expires_On": "Expires On",
	"Offer_response_required_by": "Offer response required by %{date}",
	"Pick_a_date": "Pick a date",
	"Optional": "Optional",
	"This_field_is_mandatory.": "This field is mandatory.",
	"Ready_to_send_your_offer?": "Ready to send your offer?",
	"After_you_send_this_offer,_the_buyer(s)_will_have_the_opportunity_to_review_and_negotiate.": "After you send this offer, the buyer(s) will have the opportunity to review and negotiate.",
	"Sending...": "Sending...",
	"Create_New_Offer": "Create New Offer",
	"View_All_Offers": "View All Offers",
	"New_Offer": "New Offer",
	"Edit_Offer": "Edit Offer",
	"Offer_Overview": "Offer Overview",
	"Offers_In_Channel": "Offers In Channel",
	"QUANTITY": "QUANTITY",
	"PRICING": "PRICING",
	"DIMENSIONS": "DIMENSIONS",
	"Submit_Changes": "Submit Changes",
	"Cancel_Changes": "Cancel Changes",
	"You_are_about_to_finalize_changes_to_your_offer_settings._The_buyer_will_be_notified_once_you_submit.": "You are about to finalize changes to your offer settings. The buyer will be notified once you submit.",
	"Add/Edit_Products": "Add/Edit Products",
	"Add_Products": "Add Products",
	"Let's_start_adding_products_to_your_offer.": "Let's start adding products to your offer.",
	"Other_Product_Details": "Other Product Details",
	"Currently_Visible:": "Currently Visible:",
	"Currently_Hidden:": "Currently Hidden:",
	"Manage": "Manage",
	"Choose_up_to_%maxNumber_recipients": "Choose up to %{maxNumber} recipients",
	"You_can_only_select_up_to_%maxNumber_recipients...": "You can only select up to %{maxNumber} recipients...",
	"No_matching_buyers.": "No matching buyers.",
	"You_re_editing_a_sent_offer.": "You're editing a sent offer.",
	"Your_current_offer_will_be_updated_with_these_changes.": "Your current offer will be updated with these changes.",
	"View_Offer": "View Offer",
	"Markets_are_disabled_when_products_have_been_added.": "Markets are disabled when products have been added.",
	"Channels_are_disabled_when_products_have_been_added.": "Channels are disabled when products have been added.",
	"Buyer_already_exists": "Buyer already exists",
	"Dashboard": "Dashboard",
	"Inventory": "Inventory",
	"Offers": "Offers",
	"My_Network": "My Network",
	"Team": "Team",
	"Company": "Company",
	"Help_Center": "Help Center",
	"Try_Our_Help_Center": "Try Our Help Center",
	"It_looks_like_%email_might_be_a_personal_email_address._Most_people_use_their_business_emails_on_the_Inturn_App.": "It looks like %{email} might be a personal email address. Most people use their business emails on the Inturn App.",
	"Market:": "Market:",
	"There_are_no_products_in_your_inventory.": "There are no products in your inventory.",
	"Deleting_offer...": "Deleting offer...",
	"Offer_deleted_successfully.": "Offer deleted successfully.",
	"Failed_to_delete_offer.": "Failed to delete offer.",
	"Downloading_file._(This_process_may_take_several_minutes,_especially_for_larger_files.)": "Downloading file. (This process may take several minutes, especially for larger files.)",
	"Withdraw_Offer_&_Edit_Products": "Withdraw Offer & Edit Products",
	"Edit_Offer_Settings": "Edit Offer Settings",
	"You_are_about_to_withdraw_your_offer_which_will_allow_you_to_edit_your_products": "You are about to withdraw your offer which will allow you to edit your products.",
	"Withdraw_Offer": "Withdraw Offer",
	"Remove_Quantities": "Remove Quantities",
	"Move_Products": "Move Products",
	"Cost": "Cost",
	"Per_Unit": "Per Unit",
	"Per_CSPK": "Per CSPK",
	"add_allocation_from_card": "Add Allocation",
	"Filters": "Filters",
	"Truckload_Settings": "Truckload Settings",
	"Any_Size": "Any Size",
	"Buyer_must_meet_minimum_offer_size": "Buyer must meet minimum offer size",
	"Minimum_Truckload": "Minimum Truckload",
	"Maximum_Truckload": "Maximum Truckload",
	"Label_%smart_count_Trucks_(lbs)": "%{smart_count} Truck (%{lbs}) |||| %{smart_count} Trucks (%{lbs})",
	"Label_%smart_count_lbs": "%{valueFormatted} lb |||| %{valueFormatted} lbs",
	"Of_%count_Total_Products": "Of %{count} Total Products",
	"Of_%count_Total_Casepacks": "Of %{count} Total Casepacks",
	"Of_%count_Total_Items": "Of %{count} Total Items",
	"Of_%count_Total_Offers": "Of %{count} Total Offers",
	"in-offer": "in-offer",
	"not-in-offer": "not-in-offer",
	"unpriced-in-offer": "unpriced-in-offer",
	"OFF_AVG": "OFF AVG",
	"Totals_may_be_inaccurate_due_to_missing_data_points": "Totals may be inaccurate due to missing data points",
	"Totals_may_be_inaccurate_due_to_missing_data": "Totals may be inaccurate due to missing data",
	"Totals_may_be_inaccurate_-_some_selected_products_are_not_in_offer.": "Totals may be inaccurate - some selected products are not in offer.",
	"Unpriced_Items": "Unpriced Items",
	"Unpriced_Products": "Unpriced Products",
	"Totals_may_be_inaccurate_due_to_missing_pricing_data.": "Totals may be inaccurate due to missing pricing data.",
	"Totals_are_inaccurate_due_to_%smart_count_unpriced_products": "Totals are inaccurate due to %{smart_count} unpriced product |||| Totals are inaccurate due to %{smart_count} unpriced products",
	"Viewing": "Viewing",
	"Need_help?_Visit_our_Help_Center.": "Need help? Visit our %{linkStart}Help Center%{linkEnd}.",
	"About_INTURN": "About INTURN",
	"currency_converter": "currency converter",
	"Unallocated_CSPKs": "Unallocated CSPKs",
	"Unallocated_Casepacks": "Unallocated Casepacks",
	"Unallocated_Units": "Unallocated Units",
	"Details": "Details",
	"Matrix": "Matrix",
	"(%count)_More": "(%{count}) More",
	"+_%count_More": "+ %{count} More",
	"You_havent_sent_your_message.": "You haven't sent your message.",
	"Are_you_sure_you_want_to_close_this_chat_window?": "Are you sure you want to close this chat window?",
	"Adding_%smart_count_Products": "Adding %{smart_count} Product |||| Adding %{smart_count} Products",
	"Allocating_%smart_count_Products": "Allocating %{smart_count} Product |||| Allocating %{smart_count} Products",
	"Removing_%smart_count_Products": "Removing %{smart_count} Product |||| Removing %{smart_count} Products",
	"Pricing_%smart_count_Products": "Pricing %{smart_count} Product |||| Pricing %{smart_count} Products",
	"Processing_%smart_count_Products": "Processing %{smart_count} Product |||| Processing %{smart_count} Products",
	"Deleting_%smart_count_Products": "Deleting %{smart_count} Product |||| Deleting %{smart_count} Products",
	"Removing_%smart_count_Products_From_Allocation": "Removing %{smart_count} Product From Allocation |||| Removing %{smart_count} Products From Allocation",
	"Preparing_to_Remove_Products": "Preparing to Remove Products",
	"Preparing_to_Price_Products": "Preparing to Price Products",
	"Preparing_to_Add_Products": "Preparing to Add Products",
	"Preparing_to_Allocate_Products": "Preparing to Allocate Products",
	"Preparing_to_Delete_Products": "Preparing to Delete Products",
	"Preparing_to_Remove_Products_From_Allocation": "Preparing to Remove Products From Allocation",
	"Unable_to_add_products.": "Unable to add products.",
	"Unable_to_complete_allocation.": "Unable to complete allocation.",
	"Unable_to_remove_products.": "Unable to remove products.",
	"Unable_to_price_products.": "Unable to price products.",
	"Unable_to_process_products.": "Unable to process products.",
	"Unable_to_delete_products.": "Unable to delete products.",
	"Please_try_again.": "Please try again.",
	"Assign_to_Allocation": "Assign to Allocation",
	"Remove_from_Allocation": "Remove from Allocation",
	"Products_could_not_be_removed_from_allocations": "Products could not be removed from allocations",
	"Unable_to_remove_products_from_allocation.": "Unable to remove products from allocation.",
	"Unable_to_clone_this_offer_Please_try_again_and_contact_sellersupport@inturn.co_if_the_problem_persists.": "Unable to clone this offer. Please try again and contact sellersupport@inturn.co if the problem persists.",
	"allocated": "allocated",
	"Allocation_Rollup": "Allocation Rollup",
	"You_have_%smart_count_items_in_your_inventory.": "You have %{smart_count} item in your inventory. |||| You have %{smart_count} items in your inventory.",
	"You_have_%smart_count_casepacks_in_your_inventory.": "You have %{smart_count} casepack in your inventory. |||| You have %{smart_count} casepacks in your inventory.",
	"You_have_%smart_count_products_in_your_inventory.": "You have %{smart_count} product in your inventory. |||| You have %{smart_count} products in your inventory.",
	"Return_to_your_dashboard_to_create_or_view_offers.": "Return to your dashboard to create or view offers.",
	"%minLength_to_%maxLength_characters": "%{minLength} to %{maxLength} characters",
	"No_Expiration_Date": "No Expiration Date",
	"View_rollup": "View rollup",
	"View_rollups": "View rollups",
	"Truckload_rollup": "Truckload rollup",
	"Pricing_rollup": "Pricing rollup",
	"Hide_rollup": "Hide rollup",
	"Hide_rollups": "Hide rollups",
	"Expand_rollup": "Expand rollup",
	"Selection": "Selection",
	"Please_add_the_desired_products_to_your_offer_to_view_the_truckload_rollup": "Please add the desired products to your offer to view the truckload rollup",
	"Truckload": "Truckload",
	"Trucks": "Trucks",
	"Total_Trucks": "Total Trucks",
	"Total_Gross_Weight": "Total Gross Weight",
	"Total_Cube": "Total Cube",
	"Customize_data_points": "Customize data points",
	"Column": "Column",
	"Show/Hide": "Show/Hide",
	"Visible_Data_Points": "Visible Data Points",
	"Manage_Inventory": "Manage Inventory",
	"Advanced_Actions": "Advanced_Actions",
	"Your_upload_is_processing": "Your upload is processing",
	"Your_file_could_not_be_uploaded": "Your file could not be uploaded",
	"File_upload_successful": "File upload successful",
	"Start_uploading_your_inventory_today!": "Start uploading your inventory today!",
	"Upload_your_inventory_to_get_started.": "Upload your inventory to get started.",
	"Actions_can_only_be_performed_on_%maxProductsAllowed_products_at_a_time._Please_filter_down_your_product_set.": "Actions can only be performed on %{maxProductsAllowed} products at a time. Please filter down your product set.",
	"Offers_are_limited_to_%maxProductsAllowed_products.": "Offers are limited to %{maxProductsAllowed} products.",
	"Minimum": "Minimum",
	"Maximum": "Maximum",
	"No_Max": "No Max",
	"No_Min": "No Min",
	"to": "to",
	"To:": "To:",
	"Hide": "Hide",
	"Show": "Show",
	"OK": "OK",
	"%count_Selected": "%{count} Selected",
	"Clear": "Clear",
	"Products_could_not_be_deleted": "Products could not be deleted",
	"%{smart_count}_of_these_products_cannot_be_deleted_because_they_are_in_casepacks.": "%{smart_count} of these products cannot be deleted because it is a casepack. |||| %{smart_count} of these products cannot be deleted because they are in casepacks.",
	"Last_Saved_%timeAgoText": "Last Saved %{timeAgoText}",
	"Autosaved": "Autosaved",
	"Saved": "Saved",
	"Saving...": "Saving...",
	"Saving_Error": "Saving Error",
	"Error_updating_quantity": "Error updating quantity",
	"Error_updating_pricing": "Error updating pricing",
	"Couldn't_Save...": "Couldn't Save...",
	"Retry_Now": "Retry Now",
	"Category_Rollup": "Category Rollup",
	"Bulk_price_items_by_category": "Bulk price items by category",
	"Continue": "Continue",
	"Take_a_look.": "Take a look.",
	"You_ended_this_offer.": "You ended this offer.",
	"Filter_Products": "Filter Products",
	"Manage_Products": "Manage Products",
	"You_must_first_select_the_product_you'd_like_to_manage": "You must first select the product you'd like to manage",
	"You_must_deselect_all_before_filtering": "You must deselect all before filtering",
	"You_must_deselect_all_before_searching": "You must deselect all before searching",
	"Keep_editing_or_continue.": "Keep editing or continue.",
	"You've_added_%added_items_of_%total_items_products.": "You've added %{added_items} of %{total_items} products.",
	"Make_sure_to_price_all_your_products.": "Make sure to price all your products.",
	"Add_products_to_get_started.": "Add products to get started.",
	"Hi,_{firstName}._Let's_build_an_offer.": "Hi, %{firstName}. Let's build an offer.",
	"Hi,_(%name)._Let's_build_an_offer.": "Hi, %{name}. Let's build an offer.",
	"You've_made_edits.": "You've made edits.",
	"You're_viewing_%firstName_'s_offer.": "You're viewing %{firstName}'s offer.",
	"All_products_have_been_added_to_this_offer_without_any_changes.": "All products have been added to this offer without any changes.",
	"Review_and_continue.": "Review and continue.",
	"(%creator_name)_sent_you_a_\"take_all\"_offer.": "%{creator_name} sent you a \"take all\" offer.",
	"(%firstName)_made_some_edits.": "%{firstName} made some edits.",
	"You_can_counter_or_continue.": "You can counter or continue.",
	"Negotiations_have_been_cancelled.": "Negotiations have been cancelled.",
	"You_can_send_them_a_message_to_follow_up.": "You can send them a message to follow up.",
	"This_offer_has_ended.": "This offer has ended.",
	"Once_your_inventory_is_uploaded,_you'll_be_able_to_create_and_send_offers_to_buyers.": "Once your inventory is uploaded, you'll be able to create and send offers to buyers.",
	"Let's_get_your_Inventory_on_INTURN!": "Let's get your Inventory on INTURN!",
	"Allocation": "Allocation",
	"Close_Current_View": "Close Current View",
	"Exit_any_overlay_window_and_return_to_Inventory_Linesheet": "Exit any overlay window and return to Inventory Linesheet",
	"Navigate_to_Next/Previous_Product_in_Allocation": "Navigate to Next",
	"Navigate_to_Next/Previous_Product": "Navigate to Next/Previous Product",
	"In_Allocation_view,_navigate_to_the_next_or_previous_product_in_your_inventory": "In Allocation view, navigate to the next or previous product in your inventory",
	"Select_All_Products": "Select All Products",
	"Select_all_products_in_your_filtered_view": "Select all products in your filtered view",
	"Navigate_Linesheet_Cells": "Navigate Linesheet Cells",
	"Navigate_to_an_adjacent_cell": "Navigate to an adjacent cell",
	"Trigger_Button_or_Link_in_a_Selected_Cell": "Trigger Button or Link in a Selected Cell",
	"Click_the_button_or_link_of_the_cell_you_have_selected": "\"Click\" the button or link of the cell you have selected",
	"Show_%smart_count_Products": "Show %{smart_count} Product |||| Show %{smart_count} Products",
	"%creatorName_sent_you_an_offer.": "%{creatorName} sent you an offer.",
	"currency_conversion": "currency conversion",
	"Reset_Filters": "Reset Filters",
	"You_can_upload_images_in_bulk_and_auto_assign_them_to_your_items.": "You can upload images in bulk and auto assign them to your items.",
	"Upload_File": "Upload File",
	"Upload_Images": "Upload Images",
	"Upload/Update_Images": "Upload/Update Images",
	"What_would_you_like_to_do?": "What would you like to do?",
	"By_uploading_this_file,_we_will_create_a_folder_for_you.": "By uploading this file, we will create a folder for you.",
	"First_select_the_existing_folder_you_would_like_to_replace.": "First select the existing folder you would like to replace.",
	"Now_select_the_file_that_will_replace_your_existing_inventory_folder.": "Now select the file that will replace your existing inventory folder.",
	"Welcome,_%name!": "Welcome, %{name}!",
	"Selected_Market": "Selected Market",
	"Offers_Waiting_For_You": "Offers Waiting For You",
	"Accepted_Offers": "Accepted Offers",
	"Sent_Offers": "Sent Offers",
	"Unpublished_Offers": "Unpublished Offers",
	"Offers_in_Negotiation": "Offers in Negotiation",
	"Ended_Offers": "Ended Offers",
	"View_Offers": "View Offers",
	"Unit_Price": "Unit Price",
	"(%count_units)": "(%{smart_count} unit) |||| (%{smart_count} units)",
	"Get_started_by_adding_your_inventory_to_an_offer,_pricing_your_items,_and_picking_your_buyers.": "Get started by adding your inventory to an offer, pricing your items, and picking your buyers.",
	"Add_Inventory_To_Offers": "Add Inventory To Offers",
	"Create_Offer_Now": "Create Offer Now",
	"Your_upload_is_converting": "Your upload is converting",
	"Your_upload_is_saving": "Your upload is saving",
	"Indexing_your_inventory": "Indexing your inventory",
	"Syncing_your_listings": "Syncing your listings",
	"Contact_%supportEmail": "Contact %{supportEmail}",
	"%eventName_Error": "%{eventName} Error",
	"Converting": "Converting",
	"Processing": "Processing",
	"PROCESSING": "PROCESSING",
	"Saving": "Saving",
	"Indexing": "Indexing",
	"Syncing": "Syncing",
	"Let's_Get_Your_Inventory_On_INTURN!": "Let's Get Your Inventory On INTURN!",
	"Step": "Step",
	"File": "File",
	"Failed": "Failed",
	"Complete": "Complete",
	"Converting_File_Error_Summary": "Converting File Error Summary",
	"Processing_File_Error_Summary": "Processing File Error Summary",
	"Saving_File_Error_Summary": "Saving File Error Summary",
	"Syncing_File_Error_Summary": "Syncing File Error Summary",
	"Indexing_File_Error_Summary": "Indexing File Error Summary",
	"Please_check_the_following_and_try_again:": "Please check the following and try again:",
	"Please_reach_out_to": "Please reach out to",
	"An_error_occurred_while_uploading_this_file.": "An error occurred while uploading this file.",
	"File_is_less_than_10_MB": "File is less than 10 MB",
	"No_special_characters_in_the_file_name_(&,$,@,_etc.)": "No special characters in the file name (&,$,@, etc.)",
	"Make_sure_your_file_is_not_corrupted_or_protected": "Make sure your file is not corrupted or protected",
	"Column_positions_&_header_names_are_correct": "Column positions & header names are correct",
	"Data_in_cells_are_correctly_formatted_(currency,_date_formats,_etc.)": "Data in cells are correctly formatted (currency, date formats, etc.)",
	"File_contains_all_required_data_points": "File contains all required data points",
	"If_the_error_persists,_please_reach_out_to": "If the error persists, please reach out to",
	"Protecting_the_privacy_of_your_attribute_data": "Protecting the privacy of your attribute data",
	"Pricing_Groups": "Pricing Groups",
	"Unit_Cost": "Unit Cost",
	"%_Off_Unit_WHL": "% Off Unit WHL",
	"%_Off_Unit_MSRP": "% Off Unit MSRP",
	"Currency": "Currency",
	"Sizing_Layout": "Sizing Layout",
	"You_can_choose_what_direction_sizes_will_appear_in_your_file.": "You can choose what direction sizes will appear in your file.",
	"Vertical": "Vertical",
	"Horizontal": "Horizontal",
	"Unallocated_Units_by_Size": "Unallocated Units by Size",
	"On_Hand": "On Hand",
	"(%name)_hasn't_responded yet.": "%{name} hasn't responded yet.",
	"You're_viewing_(%name)'s_offer.": "You're viewing %{name}'s offer.",
	"(%name)_sent_you_a_take-all_offer.": "%{name} sent you a take-all offer.",
	"(%name)_hasn't_responded_yet.": "%{name} hasn't responded yet.",
	"(%name)_made_some_edits.": "%{name} made some edits.",
	"(%name)_sent_you_a_counteroffer.": "%{name} sent you a counteroffer.",
	"Continue_to_complete_the_negotiations,_or_edit_the_linesheet_to_counter.": "Continue to complete the negotiations, or edit the linesheet to counter.",
	"(%name)_accepted_your_offer.": "%{name} accepted your offer.",
	"(%name)_from_your_team_accepted_this_offer.": "%{name} from your team accepted this offer.",
	"Negotiations_will_be_complete_as_soon_as_(%name)_signs_off.": "Negotiations will be complete as soon as %{name} signs off.",
	"You_accepted_this_offer.": "You accepted this offer.",
	"(%name)_signed_off_on_this_offer.": "%{name} signed off on this offer.",
	"Congratulations!_Negotiations_are_complete.": "Congratulations! Negotiations are complete.",
	"The_requested_minimum_truckload_size_is_%{smart_count}_trucks.": "The requested minimum truckload size is %{smart_count} truck. |||| The requested minimum truckload size is %{smart_count} trucks.",
	"You_have_exceeded_the_maximum_truckload_size_of_%{smart_count}_trucks.": "You have exceeded the maximum truckload size of %{smart_count} truck. |||| You have exceeded the maximum truckload size of %{smart_count} trucks.",
	"Please_add_some_products_before_sending_this_offer.": "Please add some products before sending this offer.",
	"Please_add_some_products_before_accepting_this_offer.": "Please add some products before accepting this offer.",
	"Please_add_some_products_before_completing_this_negotiation.": "Please add some products before completing this negotiation.",
	"Please_remove_some_products_before_sending_this_offer.": "Please remove some products before sending this offer.",
	"Please_remove_some_products_before_accepting_this_offer.": "Please remove some products before accepting this offer.",
	"Please_remove_some_products_before_completing_this_negotiation.": "Please remove some products before completing this negotiation.",
	"This_offer_isn't_ready_yet.": "This offer isn't ready yet.",
	"Please_check_back_soon.": "Please check back soon.",
	"You_signed_off_on_this_offer.": "You signed off on this offer.",
	"(%name)_from_your_team_ended_this_offer.": "%{name} from your team ended this offer.",
	"(%name)_ended_this_offer.": "%{name} ended this offer.",
	"(%name)_from_your_team_signed_off_on_this_offer.": "%{name} from your team signed off on this offer.",
	"Published_Offers": "Published Offers",
	"Create_Offer": "Create Offer",
	"Looks_like_you_have_no_received_offers": "Looks like you have no received offers",
	"Looks_like_you_have_no_sent_offers": "Looks like you have no sent offers",
	"Looks_like_you_have_no_accepted_offers": "Looks like you have no accepted offers",
	"Looks_like_you_have_no_ended_offers": "Looks like you have no ended offers",
	"Looks_like_you_have_no_unpublished_offers": "Looks like you have no unpublished offers",
	"but_you_have_existing_archived_offers": "but you have existing archived offers",
	"Newest_to_oldest": "Newest to oldest",
	"Oldest_to_newest": "Oldest to newest",
	"Search_Offers": "Search Offers",
	"Go_to_first_page": "Go to first page",
	"Go_to_last_page": "Go to last page",
	"Next": "Next",
	"%currentRange_of_%totalCount": "%{currentRange} of %{totalCount}",
	"Bulk_Download": "Bulk Download",
	"Show_Results": "Show Results",
	"Hello": "Hello",
	"Your_Inventory": "Your Inventory",
	"Pricing_Markets": "Pricing Markets",
	"There_was_an_error_loading_your_unpublished_offers._Please_refresh_the_page_to_try_again.": "There was an error loading your unpublished offers. Please refresh the page to try again.",
	"There_was_an_error_loading_your_offers_in_negotiation._Please_refresh_the_page_to_try_again.": "There was an error loading your offers in negotiation. Please refresh the page to try again.",
	"There_was_an_error_loading_your_offers._Please_refresh_the_page_to_try_again.": "There was an error loading your offers. Please refresh the page to try again.",
	"No_unpublished_offers": "No unpublished offers",
	"You_have_no_unpublished_offers": "You have no unpublished offers",
	"No_published_offers": "No published offers",
	"You_have_no_offers_in_negotiation": "You have no offers in negotiation",
	"You_currently_have_no_pending_offers": "You currently have no pending offers",
	"You_can_only_send_offers_to_buyers_of_one_company_at_a_time.": "You can only send offers to buyers of one company at a time.",
	"You_can_only_add_users_from_one_company_to_an_offer._We_don't_recognize_the_company_you're_trying_to_add._Please_reach_out_to_%supportEmail%": "You can only add users from one company to an offer. We don't recognize the company you're trying to add. Please reach out to %{supportEmail}",
	"Delete_Product": "Delete Product",
	"Save_&_Exit": "Save & Exit",
	"For_questions_please_contact_our": "For questions please contact our",
	"Back_to_Product_Page": "Back to Product Page",
	"Units_in_Offers": "Units in Offers",
	"INTURN_ID": "INTURN ID",
	"Item_Details": "Item Details",
	"Total_CSPKs": "Total CSPKs",
	"Items_Per_CSPK": "Items Per CSPK",
	"Casepack_Type": "Casepack Type",
	"Multi-Item": "Multi-Item",
	"Multi-Items": "Multi-Items",
	"Single-Item": "Single-Item",
	"Single-Items": "Single-Items",
	"Single-and-Multi-Item": "Single & Multi-Item",
	"Single-and-Multi-Items": "Single & Multi-Items",
	"Unallocated": "Unallocated",
	"Quantity_&_Pricing": "Quantity & Pricing",
	"Sizing": "Sizing",
	"Protecting_Your_Data_Privacy": "Protecting Your Data Privacy",
	"Remove_from_Offer": "Remove from Offer",
	"Choose_an_Inventory_Channel": "Choose an Inventory Channel",
	"Choose_a_Pricing_Market": "Choose a Pricing Market",
	"More_Pricing_Options": "More Pricing Options",
	"Total_Units_in_Offer": "Total Units in Offer",
	"We_will_never_show_your_Cost,_Margin,_Markup_or_Inventory_Data_to_buyers...": "We will never show your %{strongStart}Cost%{strongEnd}, %{strongStart}Margin%{strongEnd}, %{strongStart}Markup%{strongEnd} or %{strongStart}inventory data%{strongEnd} to buyers. In addition, buyers will not be able to see any other attributes that you have chosen to hide in your data configuration or offer settings.",
	"We_will_never_show_your_Retail_Price_or_Margin_data_to_sellers.": "We will never show your %{strongStart}Retail Price%{strongEnd} or %{strongStart}Margin%{strongEnd} data to sellers.",
	"Vist_our_HELP_CENTER_to_learn_how_to_update_inventory_quantities,_pricing_and_attributes.": "Vist our %{linkStart}HELP CENTER%{linkEnd} to learn how to update inventory quantities, pricing and attributes.",
	"Product_Images": "Product Images",
	"Quantity,_Pricing_&_Attributes": "Quantity, Pricing & Attributes",
	"Delete_Image": "Delete Image",
	"Upload_Image": "Upload Image",
	"Image_Editor": "Image Editor",
	"No_Buyer": "No Buyer",
	"Edit_Product": "Edit Product",
	"This_cannot_be_undone.": "This cannot be undone.",
	"Total_Amount": "Total Amount",
	"Changes_are_autosaved": "Changes are autosaved",
	"Delete_File": "Delete File",
	"File_Editor": "File Editor",
	"Color_May_Vary": "Color May Vary",
	"Add_All_Units_to_Offer": "Add All Units to Offer",
	"An_error_has_occurred,_please_contact_support_if_this_persists.": "An error has occurred, please contact support if this persists.",
	"You_must_select_or_filter_to_a_single_channel_and_pricing_market_to_view_the_rollup_metrics": "You must select or filter to a single channel and pricing market to view the rollup metrics",
	"%_Off_WHL": "% Off WHL",
	"%_Off_MSRP": "% Off MSRP",
	"Profit": "Profit",
	"Select_the_Channel_you_would_like_to_manage.": "Select the Channel you would like to manage.",
	"Select_channel_you_would_like_to_manage": "Select channel you would like to manage.",
	"When_checked_Image_Sync_will_run_automatically_after_the_inventory_upload_completes": "When checked, Image Sync will run automatically after the inventory upload completes.",
	"You_are_replacing_inventory_in_the_above_channel._To_change_channels_please_select_the_above_dropdown": "You are replacing inventory in the above channel. To change channels please select the above dropdown",
	"Channel_Validation_warning.": "This action will completely delete and replace your inventory with the products in your file. Be sure the file you selected includes all products you want in your channel’s inventory. Any products not in your file will be deleted from your inventory. Any offers containing updated inventory will be adjusted to reflect your changes.",
	"Delete_and_replace_current_inventory_with_products_in_your_new_file.": "Delete and replace current inventory with products in your new file.",
	"Replace_Inventory": "Replace Inventory",
	"Update_existing_product_quantities_and_attributes,_and_add_new_products_to_inventory.": "Update existing product quantities and attributes, and add new products to inventory.",
	"Update_and_Add_Inventory": "Update and Add Inventory",
	"Upload_or_Sync_Images": "Upload or Sync Images",
	"Upload_new_images,_or_sync_existing_images_with_your_inventory.": "Upload new images, or sync existing images with your inventory.",
	"Upload_Inventory": "Upload Inventory",
	"Upload_new_inventory_to_your_channel.": "Upload new inventory to your channel.",
	"Select_Your_File": "Select Your File",
	"This_cannot_be_undone._This_will_update_existing_products...": "%{boldStart}This cannot be undone.%{boldEnd} This will update existing products with information in your file. Any products not in your file will not be updated, but will remain in your inventory. Any new products in your file will be added to your inventory. Any offers containing updated inventory will be adjusted to reflect your changes.",
	"This_cannot_be_undone._This_action_will_completely_delete_and_replace...": "%{boldStart}This cannot be undone.%{boldEnd} This action will completely delete and replace your inventory with the products in your file. Be sure the file you selected includes all products you want in your channel’s inventory. Any products not in your file will be deleted from your inventory. Any offers containing updated inventory will be adjusted to reflect your changes.",
	"Product_depletion:_If_quantities_for_products_in_offers_are_reduced...": "%{boldStart}Product depletion:%{boldEnd}  If quantities for products in offers are reduced, they will be removed proportionally first from unpublished offers, followed by published offers. All affected offers out to buyers will automatically be sent an updated offer.",
	"Replace_Total_Units": "Replace Total Units",
	"Update_Total_Units": "Update Total Units",
	"Replace_Unallocated_Units": "Replace Unallocated Units",
	"Update_Unallocated_Units": "Update Unallocated Units",
	"Update_only_the_unallocated_units_(i.e._units_not_in_offers)_with_quantities_from_your_new_file,_and_add_any_new_products": "Update only the unallocated units (i.e. units not in offers) with quantities from your new file, and add any new products.",
	"Replace_the_total_units_for_all_products_with_quantities_from_your_new_file,_and_add_any_new_products.": "Replace the total units for all products with quantities from your new file, and add any new products.",
	"Replace_only_the_unallocated_units...": "Replace only the unallocated units (i.e. units not in offers) with quantities from your new file, and add any new products.",
	"Update_only_the_unallocated_units...": "Update only the unallocated units (i.e. units not in offers) with quantities from your new file, and add any new products.",
	"You_can_upload_images_in_bulk_and_auto_assign_them_to_your_items,_or_resync_images_with_your_existing_inventory": "You can upload images in bulk and auto assign them to your items, or resync images with your existing inventory.",
	"Update_All_and_Add_Products": "Update All and Add Products",
	"Update_quantities,_attributes,_and_pricing_for_all_existing_products_and_add_new_products_to_inventory.": "Update quantities, attributes, and pricing for all existing products and add new products to inventory.",
	"Update_pricing_and_attributes_of_products.": "Update pricing and attributes of products.",
	"Update_Attributes": "Update Attributes",
	"Show_%smart_count_products_without_%attribute_data": "Show %{smart_count} product without %{attribute} data |||| Show %{smart_count} products without %{attribute} data",
	"Single_Item_CSPK": "Single-Item CSPK",
	"Multi_Item_CSPK": "Multi-Item CSPK",
	"Multi_Color": "Multi-Color",
	"Units_per_CSPK": "Units per CSPK",
	"Items_per_CSPK": "Items per CSPK",
	"CSPK_Cost": "CSPK Cost",
	"ACCEPTED_by_%name": "ACCEPTED by %{name}",
	"ACCEPTED": "ACCEPTED",
	"COMPLETED_by_%name": "COMPLETED by %{name}",
	"COMPLETED": "COMPLETED",
	"Counteroffer_RECEIVED_from_%name": "Counteroffer RECEIVED from %{name}",
	"Counteroffer_SENT_by_%name1_to_%name2": "Counteroffer SENT by %{name1} to %{name2}",
	"Counteroffer_SENT_to_%name": "Counteroffer SENT to %{name}",
	"ENDED_by_%name": "ENDED by %{name}",
	"ENDED": "ENDED",
	"EXPIRED": "EXPIRED",
	"Delete_from_Inventory": "Delete from Inventory",
	"You_are_about_to_delete_%smart_count_products_from_your_inventory._This_action_cannot_be_undone.": "You are about to delete %{smart_count} product from your inventory. This action cannot be undone. |||| You are about to delete %{smart_count} products from your inventory. This action cannot be undone.",
	"CREATED": "CREATED",
	"CREATED_by_%name": "CREATED by %{name}",
	"RECEIVED_from_%name": "RECEIVED from %{name}",
	"SENT_to_%name": "SENT to %{name}",
	"SENT_by_%name1_to_%name2": "SENT by %{name1} to %{name2}",
	"Selected": "Selected",
	"-_no_available_quantity_to_allocate": "- no available quantity to allocate",
	"Channels": "Channels",
	"DETAILS": "DETAILS",
	"INVENTORY_COUNTS": "INVENTORY COUNTS",
	"PRODUCTS": "PRODUCTS",
	"Hide_Sizing": "Hide Sizing",
	"Show_Sizing": "Show Sizing",
	"Products_Selected": "Products Selected",
	"Allocation_Limit_Reached": "Allocation Limit Reached",
	"*You've_reached_the_maximum_number_of_allocations._To_add_new_allocations,_you_must_clear_out_the_existing_ones.": "*You've reached the maximum number of allocations. To add new allocations, you must clear out the existing ones.",
	"Channel_Inventory": "Channel Inventory",
	"No_Channel_Inventory": "No Channel Inventory",
	"This_channel's_inventory_is_empty._Get_started_by_uploading_some_products_to_this_channel.": "This channel's inventory is empty. Get started by uploading some products to this channel.",
	"Pricing_totals_may_be_inaccurate_due_to_missing_market_price_data": "Pricing totals may be inaccurate due to missing market price data",
	"Distribute_Quantities": "Distribute Quantities",
	"Would_you_like_to_save_these_changes_or_discard?": "Would you like to save these changes or discard?",
	"Are_you_sure_you_want_to_leave?": "Are you sure you want to leave?",
	"Any_unsaved_allocations_will_be_discarded": "Any unsaved allocations will be discarded",
	"Retail": "Retail",
	"Suggested": "Suggested",
	"Wholesale": "Wholesale",
	"Upload_new_images_in_bulk,_or_sync_existing_images.": "Upload new images in bulk, or sync existing images.",
	"Sync_existing_images_with_your_inventory.": "Sync existing images with your inventory.",
	"Allocated": "Allocated",
	"#Units": "Unit |||| Units",
	"#CSPKs": "CSPK |||| CSPKs",
	"OFFERS": "OFFERS",
	"Category_Insights": "Category Insights",
	"Units_in_Offer": "Units in Offer",
	"Of_Total_Offer": "Of Total Offer",
	"CSPK_Allocation": "CSPK Allocation",
	"Sort_Total_Units_By": "Sort Total Units By",
	"Sort_Unallocated_Units_By": "Sort Unallocated Units By",
	"Sort_Units/CSPK_By": "Sort Units/CSPK By",
	"CSPK_Type": "CSPK Type:",
	"CSPKs_Type": "CSPKs Type:",
	"%CSPKs_remains_available": "CSPK Remains Available |||| CSPKs Remain Available",
	"%units_remains_available": "unit remains available |||| units remain available",
	"Add_All": "Add All",
	"Retail_Price": "Retail Price",
	"No_Products_in_Offer": "No Products in Offer",
	"There_are_no_products_yet_in_this_offer._You_can_add_products_from_your_channel_inventory.": "There are no products yet in this offer. You can add products from your channel inventory.",
	"Buyer_not_found.": "Buyer not found.",
	"Pricing_Market": "Pricing Market",
	"You_cannot_send_an_offer_to_yourself.": "You cannot send an offer to yourself.",
	"You_cannot_send_an_offer_to_seller.": "You cannot send an offer to seller.",
	"You_cannot_send_an_offer_to_deleted_buyer.": "You cannot send an offer to deleted buyer.",
	"You_can_only_add_other_users_from_%companyName_to_this_offer._If_you_want_to_send_this_offer_to_a_different_company,_please_clone_the_offer.": "You can only add other users from %{companyName} to this offer. If you want to send this offer to a different company, please clone the offer.",
	"This_product_has_a_unique_size_configuration._You_can_adjust_quantities_in_your_Offer_Linesheet.": "This product has a unique size configuration. You can adjust quantities in your Offer Linesheet.",
	"#Offers_Selected": "%{smart_count} Offer Selected |||| %{smart_count} Offers Selected",
	"Maximum_Selection_of_%smart_count_Offers": "Maximum Selection of %{smart_count} Offer |||| Maximum Selection of %{smart_count} Offers",
	"Remaining:": "Remaining:",
	"Quantities_may_be_rounded": "Quantities may be rounded",
	"There_are_no_offers_available.": "There are no offers available.",
	"Create_a_new_offer_to_allocate_inventory.": "Create a new offer to allocate inventory.",
	"No_Markets_Found:_Please_upload_inventory_in_this_channel_to_continue.": "No Markets Found: Please upload inventory in this channel to continue.",
	"Show_More": "Show More",
	"Showing_%amountAlreadyShownOffers_of_%amountTotalOffers": "Showing %{amountAlreadyShownOffers} of %{amountTotalOffers}",
	"Clear_Draft": "Clear Draft",
	"Simply_drag_and_drop": "Simply drag and drop",
	"...Or_select_a_file": "...Or select a file",
	"Select_a_file": "Select a file",
	"Discard_unsaved_changes?": "Discard unsaved changes?",
	"Go_back": "Go back",
	"You_are_about_to_agree_to_this_offer_from_%name.": "You are about to agree to this offer from %{name}.",
	"You_are_about_to_accept_to_this_offer_from_%name.": "You are about to accept to this offer from %{name}.",
	"The_respective_parties_will_be_notified.": "The respective parties will be notified.",
	"Accept_Offer": "Accept Offer",
	"Agree_to_Offer": "Agree to Offer",
	"Offer_Price": "Offer Price",
	"By_accepting_this_offer,_you_will_be_submitting...": "By accepting this offer, you will be submitting %{overlaps} updated offers and declining %{conflicts} offers.",
	"End_Negotiation": "End Negotiation",
	"You_are_about_to_end_negotiation_with_%counterParty.": "You are about to end negotiation with %{counterParty}.",
	"Ending_negotiation...": "Ending negotiation...",
	"%names_Offer": "%{name}'s Offer",
	"Create_a_new_offer_using_an_old_offer_as_a_template": "Create a new offer using an old offer as a template.",
	"Clone_an_Existing_Offer": "Clone an Existing Offer",
	"This_process_may_take_a_few_minutes": "This process may take a few minutes.",
	"Any_team_members_actively_working_in_the_same_channel_will_be_paused_until_the_cloning_process_is_complete": "Any team members actively working in the same channel will be paused until the cloning process is complete.",
	"What_do_you_want_to_name_your_new_offer?": "What do you want to name your new offer?",
	"How_cloning_works": "How cloning works",
	"Give_your_new_offer_a_unique_name_to_distinguish_it_from_the_original": "Give your new offer a %{boldStart}unique name%{boldEnd} to distinguish it from the original.",
	"A_new_offer_will_be_created_with_the_same_settings,_products,_quantities_and_pricing": "A new offer will be created with the same %{boldStart}settings%{boldEnd}, %{boldStart}products%{boldEnd}, %{boldStart}quantities%{boldEnd} and %{boldStart}pricing%{boldEnd}.",
	"For_products_that_don't_have_enough_inventory_to_duplicate_the_original,_all_remaining_quantities_will_be_added_to_the_new_offer": "For products that don't have enough inventory to duplicate the original, %{boldStart}all remaining quantities%{boldEnd} will be added to the new offer.",
	"There_was_a_problem_accepting_this_offer.": "There was a problem accepting this offer.",
	"There_was_a_problem_agreeing_to_this_offer.": "There was a problem agreeing to this offer.",
	"Offer_submitted_successfully.": "Offer submitted successfully.",
	"Offer_accepted_successfully.": "Offer accepted successfully.",
	"Offer_agreed_to_successfully.": "Offer agreed to successfully.",
	"There_was_a_problem_ending_this_offer.": "There was a problem ending this offer.",
	"Offer_ended_successfully.": "Offer ended successfully.",
	"Price_per_Unit": "Price per Unit",
	"Saving_Allocation": "Saving Allocation",
	"Preparing_to_Process_Products": "Preparing to Process Products",
	"CSPK_Price": "CSPK Price",
	"%name_will_be_notified.": "%{name} will be notified.",
	"You_are_about_to_submit_your_draft_offer_to_%name.": "You are about to submit your draft offer to %{name}.",
	"Submit_Offer": "Submit Offer",
	"Please_review_your_offer_before_submitting_to_%company.": "Please review your offer before submitting to %{company}.",
	"Your_counterparty_can_either_accept_or_counter_your_offer.": "Your counterparty can either accept or counter your offer.",
	"Keep_Editing": "Keep Editing",
	"Sending_your_offer...": "Sending your offer...",
	"Please_review_your_offer_before_sending_to_%company.": "Please review your offer before sending to %{company}.",
	"Once_sent,_they_can_negotiate_and_send_it_back_to_you.": "Once sent, they can negotiate and send it back to you.",
	"An_error_ocurred_sending_your_offer.Please_try_again.": "An error ocurred sending your offer. Please try again.",
	"Submitting_your_offer...": "Submitting your offer...",
	"Accepting_offer...": "Accepting offer...",
	"An_error_occurred_submitting_your_offer._Please_try again.": "An error occurred submitting your offer. Please try again.",
	"An_error_occurred_sending_your_offer._Please_try again.": "An error occurred sending your offer. Please try again.",
	"Offer_failed_to_submit.": "Offer failed to submit.",
	"Previous_Offer": "Previous Offer",
	"My_Offer": "My Offer",
	"UNITS/CSPK:": "UNITS/CSPK:",
	"Actualize_Offer": "Actualize Offer",
	"Total_Items": "Total Items",
	"Comments": "Comments",
	"From_%name": "From %{name}",
	"High_to_Low": "High to Low",
	"Low_to_High": "Low to High",
	"Remove_All": "Remove All",
	"Offer_Actualized_on_%date": "Offer Actualized on %{date}",
	"Allocation_Failed": "Allocation Failed",
	"You_have_exceeded_the_maximum_amount_of_inventory_you_can_place_in_an_offer.You_can_either_break_the_offer_into_two_separate_offers_or_reduce_the_number_of_products_your_are_trying_to_place_in_this_offer._For_additional_help,_please_visit_our_help_center.": "You have exceeded the maximum amount of inventory you can place in an offer. You can either break the offer into two separate offers or reduce the number of products your are trying to place in this offer. For additional help, please visit our help center.",
	"Initial_Offer:": "Initial Offer:",
	"Allocate_to_Offer": "Allocate to Offer",
	"Total_CSPKs_in_Offer": "Total CSPKs in Offer",
	"invited": "invited",
	"you_to_join": "you to join",
	"INTURN": "INTURN",
	"Free_to_register": "Free to register",
	"Access_offers_right_way": "Access offers right way",
	"View_product_images_&_data": "View product images & data",
	"Negotiate_even_faster": "Negotiate even faster",
	"Interested_in_learning_more?": "Interested in learning more?",
	"Get_in_touch_at": "Get in touch at",
	"Create_an_Account": "Create an Account",
	"Wrong_email_or_already_have_an_account?_We're_here": "Wrong email or already have an account? We're here",
	"to_help": "to help",
	"Confirm": "Confirm",
	"Your_first_name": "Your first name",
	"Your_last_name": "Your last name",
	"Your_company_name": "Your company name",
	"Something_wrong?_We_are_here_to_help": "Something wrong? We're here to help",
	"Type_a_Password": "Type a Password",
	"At_least_one_letter": "At least one letter",
	"At_least_one_number": "At least one number",
	"At_least_one_capital_letter": "At least one capital letter",
	"At_least_%smart_count_Characters": "At least %{smart_count} Character |||| At least %{smart_count} Characters",
	"First_name_must_be_%smart_count_or_more_characters": "First name must be %{smart_count} or more characters",
	"Last_name_must_be_%smart_count_or_more_characters": "Last name must be %{smart_count} or more characters",
	"Company_name_must_be_%smart_count_or_more_characters": "Last name must be %{smart_count} or more characters",
	"Verification_Email_Sent": "Verification Email Sent",
	"We_have_sent_a_verification_email_to": "We have sent a verification email to",
	"Please_click_the_link_in_the_email_to_continue.": "Please click the link in the email to continue.",
	"If_you_do_not_receive_a_verification_email_in_your_inbox_within_a_few_minutes,_please_check_your_spam_folder.": "If you do not receive a verification email in your inbox within a few minutes, please check your spam folder.",
	"Send_Again": "Send Again",
	"Sent": "Sent",
	"Error_summary": "Error summary",
	"An_error_occurred:": "An error occurred:",
	"%keyModifier_Expand_or_collapse_the_sidebar": "%{keyModifier} Expand or collapse the sidebar",
	"Oops!_Something_went_wrong!": "Oops! Something went wrong!",
	"Exit_any_overlay_window_and_return_to_Negotiation_Linesheet": "Exit any overlay window and return to Negotiation Linesheet",
	"Navigate_to_Next/Previous_Product_in_Product_Description_Page": "Navigate to Next/Previous Product in Product Description Page",
	"In_Product_Description_Page,_navigate_to_the_next_or_previous_product_in_your_offer": "In Product Description Page, navigate to the next or previous product in your offer",
	"Trigger_Button_or_Link,_or_Submit_Value_in_a_Selected Cell": "Trigger Button or Link, or Submit Value in a Selected Cell",
	"“Click”_the_button_or_link_of,_or_saving_an_updated_value_in,_the_cell_you_have_selected": "“Click” the button or link of, or saving an updated value in, the cell you have selected",
	"Received_→_Draft": "Received → Draft",
	"Notes...": "Notes...",
	"Save_Changes": "Save Changes",
	"View_Linesheet": "View Linesheet",
	"Linesheet": "Linesheet",
	"Download_Offer": "Download Offer",
	"Converting_File": "Converting File",
	"Processing_File": "Processing File",
	"Saving_File": "Saving File",
	"Matching_Images": "Matching Images",
	"Saving_Images": "Saving Images",
	"Compiling_Images": "Compiling Images",
	"Syncing_Images": "Syncing Images",
	"Your_offer_has_been_cloned.To_go_out_to_your_new_offers_overview_click_view_new_offer_below": "Your offer has been cloned. To go out to your new offer's overview, click \"View New Offer\" below.",
	"This_process_may_take_a_few_minutes._You_will_be_able_to_resume_working_once_the_cloning_process_is_complete": "This process may take a few minutes. You will be able to resume working once the cloning process is complete.",
	"Preparing_to_Clone_Offer": "Preparing to Clone Offer",
	"View_New_Offer": "View New Offer",
	"Save_allocation_to_update": "Save allocation to update",
	"Previously:": "Previously:",
	"Indexing_File": "Indexing File",
	"Select/Deselect_All_Products": "Select/Deselect All Products",
	"Select_or_deselect_all_products_you_are_currently_viewing": "Select or deselect all products you are currently viewing",
	"Select/Deselect_a_Single_Product": "Select/Deselect a Single Product",
	"Select_or_deselect_a_single_product_row": "Select or deselect a single product row",
	"\"Click\"_the_button_or_link_of_the_cell_you_have_selected": "\"Click\" the button or link of the cell you have selected",
	"Exit_any_overlay_view_and_return_to_the_linesheet": "Exit any overlay view and return to the linesheet",
	"Navigate_to_Next/Previous_Product_in_Overlay_Views": "Navigate to Next/Previous Product in Overlay Views",
	"In_overlay_views,_navigate_to_the_next_or_previous_product": "In overlay views, navigate to the next or previous product",
	"Load_More": "Load More",
	"Image_Sync": "Image Sync",
	"Unit_Retail_Price": "Unit Retail Price",
	"Unit_Margin": "Unit Margin",
	"Deleting_Products": "Deleting Products",
	"Preparing_to_Upload_Offer": "Preparing to Upload Offer",
	"Uploading_offer": "Uploading offer",
	"Units_in_Offer_Per_CSPK": "Units in Offer Per CSPK",
	"We're_unable_to_upload_your_offer.": "We're unable to upload your offer.",
	"Unallocated_Units_•_Units_in_Offer": "Unallocated Units • Units in Offer",
	"Available_Units_•_Units_in_Offer": "Available Units • Units in Offer",
	"Unallocated_CSPKs_•_CSPKs_in_Offer": "Unallocated CSPKs • CSPKs in Offer",
	"Available_CSPKS_•_CSPKs_in_Offer": "Available CSPKs • CSPKs in Offer",
	"Update_the_total_units_for_all_products_with_quantities_from_your_new_file,_and_add_any_new_products.": "Update the total units for all products with quantities from your new file, and add any new products.",
	"Has_less_length_than_allowed": "Has less length than allowed",
	"Unsaved_field": "Unsaved field",
	"Nothing_has_been_changed.": "Nothing has been changed.",
	"Contact_has_been_successfully_established.": "Contact has been successfully established.",
	"Contact_has_been_successfully_removed.": "Contact has been successfully removed.",
	"Could_not_make_contact.": "Could not make contact.",
	"Could_not_remove_contact.": "Could not remove contact.",
	"User_Avatar": "User Avatar",
	"Sort_Inturn_ID_By": "Sort Inturn ID By",
	"Sort_Product_Name_By": "Sort Product Name By",
	"This_information_will_be_used_in_your_profile": "This information will be used in your profile",
	"Add/Remove_All": "Add/Remove All",
	"Multiple": "Multiple",
	"Buyer_Margin": "Buyer Margin",
	"Profile": "Profile",
	"Delete_Offer": "Delete Offer",
	"v01_Toggle": "v01 Toggle",
	"Do_not_leave": "Do not leave",
	"Continue_to_old_version": "Continue to old version",
	"Enable_Edit_Mode_or_Trigger_the_Action_in_a_Selected_Cell": "Enable Edit Mode or Trigger the Action in a Selected Cell",
	"Enable_edit_mode_in_a_cell,_or_“click”_the_contents_of_the_cell": "Enable edit mode in a cell, or “click” the contents of the cell",
	"Exit_Edit_Mode_in_a_Selected_Cell_or_Close_Current_View": "Exit Edit Mode in a Selected Cell or Close Current View",
	"Exit_edit_mode_in_a_cell,_or_close_an_overlay_view": "Exit edit mode in a cell, or close an overlay view",
	"Beta": "Beta",
	"Alert:": "Alert:",
	"You_are_in_an_older_version_of_INTURN,_with_viewing_access_only._Switch_to_the_new_version_of_INTURN_by_clicking_the_toggle_to_the_right.": "You are in an older version of INTURN, with viewing access only. Switch to the new version of INTURN by clicking the toggle to the right.",
	"You_are_in_the_older_version_of_INTURN._Switch_to_the_new_version_of_INTURN_by_clicking_the_toggle_to_the_right.": "You are in the older version of INTURN. Switch to the new version of INTURN by clicking the toggle to the right.",
	"There_are_no_new_processes.": "There are no new processes.",
	"There_are_no_new_notifications.": "There are no new notifications.",
	"Completed": "Completed",
	"Notifications": "Notifications",
	"Sizing_distributions_can_only_be_calculated_after_saving_your_allocation.": "Sizing distributions can only be calculated after saving your allocation.",
	"There_are_no_products_in_this_offer.": "There are no products in this offer.",
	"Add_products_to_view_the_category_breakdown.": "Add products to view the category breakdown.",
	"Add_products_to_view_the_sizing_breakdown.": "Add products to view the sizing breakdown.",
	"Allocating_products_in_bulk_must_be_assigned_by_a_percent_(%)_value.": "Allocating products in bulk must be assigned by a percent (%) value.",
	"Remaining_CSPKs": "Remaining CSPKs",
	"Offer_does_not_allow_counteroffering_on_price": "Offer does not allow counteroffering on price",
	"There_are_no_results_for_your_search_or_filter_selection": "There are no results for your search or filter selection",
	"Include_Additional_Buyers": "Include Additional Buyers",
	"You_can_only_add_buyers_from_the_same_company_to_this_offer.": "You can only add buyers from the same company to this offer.",
	"Save_and_Send_Offer": "Save and Send Offer",
	"Select_additional_buyers": "Select additional buyers",
	"You_can_only_add_up_to_10_buyers_per_offer.": "You can only add up to 10 buyers per offer.",
	"Choose_up_to_10_recipients_from_the_same_company.": "Choose up to 10 recipients from the same company.",
	"Actions_can_only_be_performed_on_15,000_products_at_a_time._Please_filter_down_your_product_set.": "Actions can only be performed on 15,000 products at a time. Please filter down your product set.",
	"CSPKs_in_Offers": "CSPKs in Offers",
	"Sizing_Breakdown_Unavailable": "Sizing Breakdown Unavailable",
	"Category_Breakdown_Unavailable": "Category Breakdown Unavailable",
	"Casepacks_do_not_have_a_breakdown_due_to_the_nature_of_multiple_products_and_sizes_being_bundled_together": "Casepacks do not have a breakdown due to the nature of multiple products and sizes being bundled together",
	"No_company_assigned": "No company assigned",
	"Casepack_Ratio": "Casepack Ratio",
	"No_Category": "No Category",
	"Unallocated:": "Unallocated:",
	"Load_%smart_count_Unpublished_Offers": "Load %{smart_count} Unpublished Offer |||| Load %{smart_count} Unpublished Offers",
	"Load_Next_%smart_count_Unpublished_Offers": "Load Next %{smart_count} Unpublished Offer |||| Load Next %{smart_count} Unpublished Offers",
	"Load_%smart_count_Offers_in_Negotiation": "Load %{smart_count} Offer in Negotiation |||| Load %{smart_count} Offers in Negotiation",
	"Load_Next_%smart_count_Offers_in_Negotiation": "Load Next %{smart_count} Offer in Negotiation |||| Load Next %{smart_count} Offers in Negotiation",
	"Load_%smart_count_Offers": "Load %{smart_count} Offer |||| Load %{smart_count} Offers",
	"Load_Next_%smart_count_Offers": "Load Next %{smart_count} Offer |||| Load Next %{smart_count} Offers",
	"Back_to_Overview": "Back to Overview",
	"User_Role": "User Role",
	"Search_Team": "Search Team",
	"Invite_Team_Members": "Invite Team Members",
	"Team_Members": "Team Members",
	"Invite_Sent": "Invite Sent",
	"First_Name_A-Z": "First Name A-Z",
	"First_Name_Z-A": "First Name Z-A",
	"Last_Name_A-Z": "Last Name A-Z",
	"Last_Name_Z-A": "Last Name Z-A",
	"To_invite_multiple_team_members,_use_a_comma_between_email_addresses.": "To invite multiple team members, use a comma between email addresses.",
	"Complete_Negotiations": "Complete Negotiations",
	"Error_Creating_Offer": "Error Creating Offer",
	"Could_not_create_the_Offer": "Could not create the Offer",
	"You_cannot_create_an_offer_in_an_empty_channel._Choose_another_channel,_or_upload_inventory_to_this_channel_before_creating_an_offer.": "You cannot create an offer in an empty channel. Choose another channel, or upload inventory to this channel before creating an offer.",
	"Ok": "Ok",
	"Enter_your_message...": "Enter your message...",
	"Please_upload_one_file_at_a_time.": "Please upload one file at a time.",
	"Thank_you_for_verifying_your_email!_You_may_now_log_in_with_your_email_and_password.": "Thank you for verifying your email! You may now log in with your email and password.",
	"The_offer_you_are_trying_to_clone_has_no_remaining_inventory.": "The offer you are trying to clone has no remaining inventory.",
	"Load_more": "Load more",
	"Welcome_To_INTURN": "Welcome To INTURN",
	"Were_ready_to_streamline_your_buying_process_and_give_you_access_to_new_brands.": "We're ready to streamline your buying process and give you access to new brands.",
	"Click_Get_Started_and_answer_a_few_short_questions_to_get_your_account_profile_fully_set_up.": "Click “Get Started” and answer a few short questions to get your account profile fully set up.",
	"We_just_need_to_know_a_little_more_about_you.": "We just need to know a little more about you.",
	"Click_Get_Started_to_answer_a_few_short_questions_and_youll_be_on_your_way!": "Click \"Get Started\" to answer a few short questions and you'll be on your way!",
	"Get_Started": "Get Started",
	"Re-enter_new_password": "Re-enter new password",
	"Admin": "Admin",
	"Manager": "Manager",
	"Compose_Message": "Compose Message",
	"Whats_your_first_name?": "What's your first name?",
	"Whats_your_last_name?": "What's your last name?",
	"Whats_your_title?": "What's your title?",
	"Which_department_do_you_work_in?": "Which department do you work in?",
	"Upload_your_profile_picture": "Upload your profile picture",
	"Upload_your_company_logo": "Upload your company logo",
	"Oops!_The_link_that_brought_you_here_has_expired.": "Oops! The link that brought you here has expired.",
	"Please_contact_your_company_admin_to_send_you_a_new_link.": "Please contact your company admin to send you a new link.",
	"Learn_More": "Learn More",
	"File_Upload": "File Upload",
	"When_the_clock_starts,_your_file_will_begin_processing_in_the_background._You_may_leave_this_page_while_this_continues.": "When the clock starts, your file will begin processing in the background. You may leave this page while this continues.",
	"Processing_your_file_now_enables_a_smoother,_faster_experience_while_viewing_inventory_and_creating_offers.": "Processing your file now enables a smoother, faster experience while viewing inventory and creating offers.",
	"Index_Pending": "Index Pending",
	"Processing_Time": "Processing Time",
	"Workflow_Interruption": "Workflow Interruption",
	"Tips": "Tips",
	"Updating_your_inventory_may_interrupt_the_workflow...": "Updating your inventory may interrupt the workflow of anyone else working in the same channel. While this is happening, you will be unable to perform actions within certain parts of the platform.",
	"To_minimize_interruptions...": "To minimize interruptions, start the process of updating inventory at the end of the work day. Once you start, you can leave and it will finish processing in the background. Be sure to notify any colleagues who are working in the same channel.",
	"Processing_time_can_vary_depending_on_the_data...": "Processing time can vary depending on the data complexity and the number of rows in your inventory file or images you are trying to upload.",
	"Once_you_upload_inventory_or_images,_the_system_will_continue_processing...": "Once you upload inventory or images, the system will continue processing, even if you leave the browser tab. Just come back when it’s finished!",
	"Image_Upload": "Image Upload",
	"Minutes": "Minutes",
	"5k_Products": "5k Products",
	"10k_Products": "10k Products",
	"20k_Products": "20k Products",
	"Powered_by_INTURN": "Powered by INTURN",
	"Inventory_Overview": "Inventory Overview",
	"Select_a_different_file": "Select a different file",
	"Replace_or_update_your_inventory_and_images.": "Replace or update your inventory and images.",
	"File_Upload_-_Failed": "File Upload - Failed",
	"Uploading_your_file...": "Uploading your file...",
	"Processing_will_continue_in_the_background._You_can_close_this_page.": "Processing will continue in the background. You can close this page.",
	"Complete._Your_inventory_is_now_ready.": "Complete. Your inventory is now ready.",
	"Something_went_wrong._Please_try_again.": "Something went wrong. Please try again.",
	"Messages": "Messages",
	"Read": "Read",
	"Delivered": "Delivered",
	"When_the_clock_starts,_your_images_will_begin_syncing_in_the_background._You_may_leave_this_page_while_this_continues.": "When the clock starts, your images will begin syncing in the background. You may leave this page while this continues.",
	"Image_sync_is_up_to_date.": "Image sync is up to date.",
	"Complete._Your_images_are_now_in_inventory.": "Complete. Your images are now in inventory.",
	"Uploading_your_images...": "Uploading your images...",
	"%smart_count_More": "%{smart_count} More",
	"%smart_count_Members": "%{smart_count} Member |||| %{smart_count} Members",
	"Try_Again": "Try Again",
	"You_are_about_to_report_this_message_thread_for_possible_spam_or_abuse": "You are about to report this message thread for possible spam or abuse",
	"Tell_us_a_little_more_below_and_a_customer_service_representitive_will_look_into_this_case_for_you": "Tell us a little more below and a customer service representitive will look into this case for you",
	"Error_sending_report._Please_try_again": "Error sending report. Please try again",
	"Forgot_password?": "Forgot password?",
	"Company_Details": "Company Details",
	"You're_editing_your_company.": "You're editing your company.",
	"Your_Profile": "Your Profile",
	"Save_Profile_Changes": "Save Profile Changes",
	"The_file_uploaded_doesn’t_follow_the_format_defined_for_your_company.": "The file uploaded doesn’t follow the format defined for your company.",
	"Exporting_order_details...": "Exporting order details...",
	"Export_order_details_successful.": "Export order details successful.",
	"Once_you_upload_inventory_or_images...": "Once you upload inventory or images, the system will continue processing, even if you leave the browser tab. Just come back when it’s finished!",
	"If_you_continue_to_the_older_version_of_INTURN,_you_will_have_limited_functionality.": "If you continue to the older version of INTURN, you will have limited functionality.",
	"Message_%userName": "Message %{userName}",
	"About_This_Offer": "About This Offer",
	"Initially_Sent_on": "Initially Sent on",
	"Send_Message": "Send Message",
	"We're_unable_to_process_your_file.": "We're unable to process your file.",
	"Error_Code:": "Error Code:",
	"Correlation_ID:": "Correlation ID:",
	"Your_attempted_inventory_upload_has_failed._Please_make_sure_your_file_has_only_one_value_for_%attribute_and_try_again.": "Your attempted inventory upload has failed. Please make sure your file has a value for %{attribute} and that it is unique, and try again.",
	"Your_attempted_inventory_upload_has_failed._Please_make_sure_the_value_for_%attribute_in_your_file_already_exists_in_your_inventory_and_try_again.": "Your attempted inventory upload has failed. Please make sure the value of %{attribute} in your file already exists in your inventory and try again.",
	"Your_attempted_inventory_upload_has_failed._Please_make_sure_the_%attribute_value_for_your_existing_products_has_not_changed_and_try_again.": "Your attempted inventory upload has failed. Please make sure the %{attribute} value for your existing products has not changed and try again.",
	"1._Select_a_Buyer": "1. Select a Buyer",
	"2._What_do_you_want_to_name_the_offer": "2. What do you want to name the offer",
	"3._Describe_the_offer_(optional)": "3. Describe the offer (optional)",
	"Give_your_buyer_an_overview_of_this_offer": "Give your buyer an overview of this offer",
	"Name_your_offer": "Name your offer",
	"Share_any_additional_information_that_you_want_your_buyer_to_know": "Share any additional information that you want your buyer to know",
	"10k_Rows": "10k Rows",
	"50k_Rows": "50k Rows",
	"1k_Images": "1k Images",
	"5k_Images": "5k Images",
	"Est._Time:_%min_min": "Est. Time: %{min} min",
	"Est._Time:_%min_-_%max_min": "Est. Time: %{min} - %{max} min",
	"Inventory_Upload": "Inventory Upload",
	"Image_Update": "Image Update",
	"Cloning_Listing": "Cloning Listing",
	"Moving_Products": "Moving Products",
	"Publishing_Offer": "Publishing Offer",
	"Uploading_Counter_Offer": "Uploading Counter Offer",
	"Send_OFFER": "Send Offer",
	"Allocating_Inventory": "Allocating Inventory",
	"Pricing_Products": "Pricing Products",
	"You_can_only_manage_%{num_products}_products_at_a_time": "You can only manage %{num_products} products at a time",
	"You_can_only_allocate_%{num_products}_products_at_a_time": "You can only allocate %{num_products} products at a time",
	"Est._Time:_%strongStart%Calculating%strongEnd": "Est. Time: %{strongStart}Calculating%{strongEnd}",
	"Est._Time:_--": "Est. Time: --",
	"Est._Time:_%strongStart%min_min%strongEnd": "Est. Time: %{strongStart}%{min} min%{strongEnd}",
	"Est._Time:_%strongStart%min_-_%max_min%strongEnd": "Est. Time: %{strongStart}%{min} - %{max} min%{strongEnd}",
	"Preparing_to_process_your_products.": "Preparing to process your products.",
	"Please_wait_while_we_add_your_products.": "Please wait while we add your products.",
	"Please_wait_while_the_process_completes.": "Please wait while the process completes.",
	"This_channel_is_temporarily_locked.": "This channel is temporarily locked.",
	"This_channel_is_currently_locked_due_to_an_ongoing_process._Please_try_again_when_the_process_completes.": "This channel is currently locked due to an ongoing process. Please try again when the process completes.",
	"Process_complete!": "Process complete!",
	"Please_wait_while_we_update_your_products.": "Please wait while we update your products.",
	"Process_failed._Please_try_again.": "Process failed. Please try again.",
	"You_are_about_to_clear_your_draft_offer.": "You are about to clear your draft offer and reset all changes to the version you received.",
	"You_are_about_to_clear_your_draft_offer.This_cannot_be_undone": "You are about to clear your draft offer and reset all changes to the version you received. This cannot be undone.",
	"This_cannot_be_undone.Do_you_want_to_continue?": "This cannot be undone. Do you want to continue?",
	"Please_wait_while_we_clear_your_draft_offer.": "Please wait while we clear your draft offer.",
	"We're_unable_to_clear_your_draft_at_this_time.": "We're unable to clear your draft at this time.",
	"Clearing_Draft": "Clearing Draft",
	"Please_wait_while_we_allocate_your_products.": "Please wait while we allocate your products.",
	"To_get_started,_select_up_to_%{maxOffers}_offers_from_the_panel_on_the_left.": "To get started, select up to %{maxOffers} offers from the panel on the left.",
	"Export_offer_successful": "Export offer successful.",
	"There_was_an_error_downloading_this_offer._Please_try_again._If_you_have_questions_please_reach_out_to_the_INTURN_Support_Team.": "There was an error downloading this offer. Please try again. If you have questions please reach out to the INTURN Support Team.",
	"Replace_your_entire_inventory_with_the_products_in_your_new_source-of-truth_file.": "Replace your entire inventory with the products in your new source-of-truth file.",
	"Replace_Entire_Inventory": "Replace Entire Inventory",
	"Partial_Replace_by_Attribute": "Partial Replace by Attribute",
	"Please_wait_while_your_file_processes.": "Please wait while your file processes.",
	"You_can_close_this_page_while_processing_continues.": "You can close this page while processing continues.",
	"When_the_clock_starts,_your_file_will_begin_processing_in_the_background.": "When the clock starts, your file will begin processing in the background.",
	"You_can_now_close_this_page,_we’ll_continue_processing_your_file_in_the_background._When_the_process_completes,_you’ll_get_a_notification.": "You can now close this page, we’ll continue processing your file in the background. When the process completes, you’ll get a notification.",
	"Replace_only_the_products_that_match_the_%attributeName_attribute_with_the_products_in_your_file.": "Replace only the products that match the %{attributeName} attribute with the products in your file.",
	"You_must_first_select_the_products_you'd_like_to_manage.": "You must first select the products you'd like to manage.",
	"We're_unable_to_process_your_request": "We're unable to process your request",
	"Channel_temporarily_locked": "Channel temporarily locked.",
	"The_channel_is_temporarily_locked._It_should_unlock_automatically._Please_try_again_in_a_few_moments.": "The channel is temporarily locked. It should unlock automatically. Please try again in a few moments.",
	"The_channel_is_temporarily_locked_because_there_is_a_process_still_in_progress._Please_wait_until_the_process_is_complete_to_try_your_action_again.": "This Channel is temporarily locked because there’s a process still in progress. Please wait until the process is complete to try your action again.",
	"Max_inventory_exceeded.": "Max inventory exceeded.",
	"You_have_exceeded_the_maximum_amount_of_inventory_you_can_allocate_at_one_time._Please_select_fewer_products_and_try_again.": "You have exceeded the maximum amount of inventory you can allocate at one time. Please select fewer products and try again.",
	"Offer_maximum_exceeded.": "Offer maximum exceeded.",
	"You_have_exceeded_the_maximum_amount_of_inventory_you_can_place_in_an_offer._You_can_either_break_this_offer_into_two,_or_reduce_the_number_of_products_you_are_trying_to_place_in_this_offer._For_additional_help,_please_visit_our_help_center.": "You have exceeded the maximum amount of inventory you can place in an offer. You can either break this offer into two, or reduce the number of products you are trying to place in this offer. For additional help, please visit our help center.",
	"When_an_inventory_channel_is_in_use,_it's_temporarily_locked_to_ensure_your_quantities_remain_accurate_and_your_work_doesn't_get_overwritten.": "When an inventory channel is in use, it's temporarily locked to ensure your quantities remain accurate and your work doesn't get overwritten.",
	"This_offer_is_currently_being_updated._When_the_process_completes,_please_try_again.": "Inventory in this offer is currently being updated. Please check in with any users who may be editing the offer, or try again later when the updates have completed.",
	"Inventory_in_this_offer_is_currently_being_updated._Please_try_again_later_when_the_updates_have_completed.": "Inventory in this offer is currently being updated. Please try again later when the updates have completed.",
	"Please_wait_while_we_delete_your_products...": "Please wait while we delete your products...",
	"These_products_will_no_longer_appear_in_your_inventory._You_will_not_be_able_to_include_these_products_in_future_offers.": "This product will no longer appear in your inventory. You will not be able to include this product in future offers. |||| These products will no longer appear in your inventory. You will not be able to include these products in future offers.",
	"Cloning_your_offer...": "Cloning your offer...",
	"Complete._You_can_now_view_your_cloned_offer.": "Complete. You can now view your cloned offer.",
	"We're_unable_to_clone_your_offer.": "We're unable to clone your offer.",
	"We're_unable_to_withdraw_your_offer.": "We're unable to withdraw your offer.",
	"An_error_occurred_while_cloning_this_listing.": "An error occurred while cloning this listing.",
	"An_error_occurred_while_withdrawing_this_listing.": "An error occurred while withdrawing this listing.",
	"This_may_take_a_while._Do_you_want_to_continue?": "This may take a while. Do you want to continue?",
	"New_Offer_Name": "New Offer Name",
	"You_cannot_counter_on_price_for_this_offer.": "You cannot counter on price for this offer.",
	"You_cannot_pick_items_for_this_offer.": "You cannot pick items for this offer.",
	"You_cannot_pick_quantities_for_this_offer.": "You cannot pick quantities for this offer.",
	"Bulk_actions_are_unavailable_because_this_is_a_take-all_offer_and_you_cannot_counter_on_price.": "Bulk actions are unavailable because this is a take-all offer and you cannot counter on price.",
	"View_Inventory": "View Inventory",
	"Allocate": "Allocate",
	"Price": "Price",
	"Enter_New_Password": "Enter New Password",
	"Re-enter_New_Password": "Re-enter New Password",
	"Passwords_do_not_match": "Passwords do not match",
	"Something_went_wrong_try_again.": "Something went wrong try again.",
	"No_results": "No results",
	"Login": "Login",
	"Remove": "Remove",
	"Reset": "Reset",
	"Done": "Done",
	"Page_Not_Found_(404)": "Page Not Found (404)",
	"Sorry_the_requested_URL_could_not_be_found.": "Sorry the requested URL could not be found.",
	"Retry": "Retry",
	"Clear_draft": "Clear draft",
	"Download_Excel": "Download Excel",
	"View_Summary": "View Summary",
	"Current_password_does_not_match.": "Current password does not match.",
	"Hello,_%name": "Hello, %{name}",
	"Business_Phone_Number": "Business Phone Number",
	"Items": "Items",
	"Casepacks": "Casepacks",
	"Total_Cases": "Total Cases",
	"Forgot_Password": "Forgot Password",
	"Job_Title": "Job Title",
	"Zip_/_Postal_Code": "Zip / Postal Code",
	"We're_having_trouble_reconciling_your_inventory_with_your_offers.": "We're having trouble reconciling your inventory with your offers.",
	"You_are_attempting_to_change_one_or_more_casepacks_that_are_currently_in_offers._Please_check_your_file_and_try_again.": "You are attempting to change one or more casepacks that are currently in offers. Please check your file and try again.",
	"There_was_an_error_inviting_this_team_member._Please_check_the_email_and_try_again.": "There was an error inviting this team member. Please check the email and try again.",
	"Units_In_Offers": "Units In Offers",
	"Order_Export": "Order Export",
	"Visible_Attributes": "Visible Attributes",
	"Products_Breakdown": "Products Breakdown",
	"You_are_about_to_delete_this_offer._This_will_send_all_products_back_to_inventory.": "You are about to delete this offer. This will send all products back to inventory.",
	"Please_wait_while_we_delete_your_offer.": "Please wait while we delete your offer.",
	"We're_unable_to_delete_this_offer.": "We're unable to delete this offer.",
	"In_Offer": "In Offer",
	"Not_In_Offer": "Not In Offer",
	"You_selected_%{count}_products_to_include_a_max_quantity.": "You selected %{count} products to include a max quantity.",
	"You_selected_%{smart_count}_products_to_include_a_max_quantity.": "You selected %{smart_count} product to include a max quantity. |||| You selected %{smart_count} products to include a max quantity.",
	"When_an_inventory_channel_is_in_use,_it’s_temporarily_locked_to_ensure_your_quantities_remain_accurate_and_your_work_doesn’t_get_overwritten.": "When an inventory channel is in use, it’s temporarily locked to ensure your quantities remain accurate and your work doesn’t get overwritten.",
	"You_selected_%{count}_products_to_price.": "You selected %{count} products to price.",
	"You_selected_%{count}_products_to_apply.": "You selected %{count} products to apply.",
	"You_selected_%{smart_count}_products_to_price.": "You selected %{smart_count} product to price. |||| You selected %{smart_count} products to price.",
	"Please_wait_while_we_price_your_products.": "Please wait while we price your products.",
	"We’re_unable_to_price_your_products.": "We’re unable to price your products.",
	"You_selected_%{count}_products_to_add.": "You selected %{count} products to add.",
	"You_selected_%{smart_count}_products_to_add.": "You selected %{smart_count} product to add. |||| You selected %{smart_count} products to add.",
	"We’re_unable_to_add_your_products.": "We’re unable to add your products.",
	"You_selected_%{count}_products_to_remove.": "You selected %{count} products to remove.",
	"You_selected_%{smart_count}_products_to_remove.": "You selected %{smart_count} product to remove. |||| You selected %{smart_count} products to remove.",
	"We’re_unable_to_remove_your_products.": "We’re unable to remove your products.",
	"Please_wait_while_we_remove_your_products.": "Please wait while we remove your products.",
	"You_can’t_manage_products_because_this_channel_is_temporarily_locked.": "You can’t manage products because this channel is temporarily locked.",
	"Offer_Upload": "Offer Upload",
	"Offer_uploaded": "Offer uploaded",
	"You_selected_%count_products_to_allocate.": "You selected %{count} product to allocate. |||| You selected %{count} products to allocate.",
	"You_selected_%count_products_to_delete_from_your_inventory.": "You selected %{count} product to delete from your inventory. |||| You selected %{count} products to delete from your inventory.",
	"Select_All": "Select All",
	"Deselect_All": "Deselect All",
	"Drop_your_file_here,_or": "Drop your file here, or",
	"Drop_your_image_here,_or": "Drop your image here, or",
	"select_a_new_file": "select a new file",
	"Something_went_wrong._Please_try_again,_and_refer_to_our_%linkStartHelp_Center%linkEnd_or_contact_%supportEmail_if_the_issue persists.": "Something went wrong. Please try again, and refer to our %{linkStart}Help Center%{linkEnd} or contact %{supportEmail} if the issue persists.",
	"Column_A_(“ID”)_is_missing_in_your_file._Please_update_the_file_with_the_required_column_and_try_again._Refer_to_%linkStartthis_article%endLink_or_reach_out_to_%supportEmail_for_additional_help.": "Column A (“ID”) is missing in your file. Please update the file with the required column and try again. Refer to %{linkStart}this article%{linkEnd} or reach out to %{supportEmail} for additional help.",
	"We_noticed_your_tab_names_have_changed._Please_revert_them_to_the_original_names_in_the_negotiation_download,_and_refer_to_our_%linkStartHelp_Center%linkEnd_or_contact_%supportEmail_if_the_issue_persists.": "We noticed your tab names have changed. Please revert them to the original names in the negotiation download, and refer to our %{linkStart}Help Center%{linkEnd} or contact %{supportEmail} if the issue persists.",
	"Deleting_Offer": "Deleting Offer",
	"Accepting_Offer": "Accepting Offer",
	"Declining_Offer": "Declining Offer",
	"Supports": "Supports",
	"Made_in_NYC": "Made in NYC",
	"All_units_are_currently_in_offers": "All units are currently in offers",
	"By_Unit": "By Unit",
	"Up_To": "Up To",
	"By_Case": "By Case",
	"Cases_per_Product": "Cases per Product",
	"Units_per_Product": "Units per Product",
	"If_any_product_has_less_than_the_desired_quantity,_it_will_add_the_maximum_available.": "If any product has less than the desired quantity, it will add the maximum available.",
	"Cases_In_Offer": "Cases In Offer",
	"Unallocated_Cases": "Unallocated Cases",
	"Units/CSPK:": "Units/CSPK:",
	"Units/Case:": "Units/Case:",
	"Case_Cost": "Case Cost",
	"%_Off_Case_WHL": "% Off Case WHL",
	"%_Off_Case_MSRP": "% Off Case MSRP",
	"%_Off_CSPK_WHL": "% Off CSPK WHL",
	"%_Off_CSPK_MSRP": "% Off CSPK MSRP",
	"Unallocated_Cases_•_Cases_in_Offer": "Unallocated Cases • Cases in Offer",
	"Case_Price": "Case Price",
	"Available_Cases_•_Cases_in_Offer": "Available Cases • Cases in Offer",
	"Cases_in_Offers": "Cases in Offers",
	"%units_in_%items": "%{units} in %{items}",
	"%units_in_%cases_of_%CSPKs": "%{units} in %{cases} of %{CSPKs}",
	"%units_in_%cases": "%{units} in %{cases}",
	"%units_in_%CSPKs": "%{units} in %{CSPKs}",
	"Channel_is_temporarily_locked": "Channel is temporarily locked",
	"There_are_0_products_in_your_offer._Either_manually_select_products_or_bulk_add_to_begin_negotiations.": "There are 0 products in your offer. Either manually select products or bulk add to begin negotiations.",
	"First_add_the_products_you_want_to_price.": "First add the products you want to price.",
	"Resync": "Resync",
	"Resync_Inventory_For_Active_Channel": "Resync Inventory For Active Channel",
	"Resync_Inventory": "Resync Inventory",
	"Resyncing_your_inventory_may_resolve_issues_you_are_seeing_on_platform._This_process_may_take_a_few_minutes.": "Resyncing your inventory may resolve issues you are seeing on platform. This process may take a few minutes.",
	"Inventory_resync_failed._Please_contact_%supportLink": "Inventory resync failed. Please contact %{supportLink}",
	"Inventory_resync_failed.": "Inventory resync failed.",
	"Please_wait_while_we_sync_your_inventory.": "Please wait while we sync your inventory.",
	"This_may_take_a_few_minutes._Do_you_want_to_continue?": "This may take a few minutes. Do you want to continue?",
	"Resyncing_Inventory": "Resyncing Inventory",
	"Syncing_Inventory": "Syncing Inventory",
	"Looks_like_there_was_in_issue_loading_your_offer.": "Looks like there was in issue loading your offer.",
	"Try_resyncing_your_offer_to_view.": "Try reloading your offer to view.",
	"Resync_Offer": "Reload Offer",
	"Your_offer_is_resyncing,_please_do_not_refresh_your_page.": "Your offer is resyncing, please do not refresh your page",
	"We're_unable_to_resync_your_offer._Please_try_again.": "We're unable to resync your offer. Please try again.",
	"Resync_process_has_failed.": "Resync process has failed",
	"Contact_buyer_support_email.": "Please take a screenshot and email it to buyersupport@inturn.co",
	"Withdraw_modal_title": "Withdraw & Edit Offer",
	"Withdraw_modal_content": "Withdrawing will allow you to edit your offer. Your counterparty will be notified.",
	"Withdraw_modal_alert": "All unsubmitted changes to this offer by your counterparty will be lost when the offer is withdrawn.",
	"Withdraw_modal_action": "Withdraw Offer",
	"Withdraw_modal_status_processing": "Withdrawing your offer...",
	"Withdraw_modal_status_done": "Withdrawn",
	"Withdraw_modal_status_error": "An error ocurred withdrawing your offer. Please try again.",
	"Withdraw_cta_button": "Withdraw & Edit",
	"Withdraw_cta_subtitle": "You can send them a message or withdraw the offer to make edits.",
	"Withdrawing_Offer": "Withdrawing Offer",
	"Sending_Email": "Sending Email",
	"Retrieving_Offer_Information": "Retrieving Offer Information",
	"Archive_cta_button": "Archive Offer",
	"ARCHIVED": "ARCHIVED",
	"Show_only_label_filter": "Show only",
	"Saving_Offer_Summary": "Saving Offer Summary",
	"Archiving_Offer": "Archiving Offer",
	"Cleaning_Offer_Indexes": "Cleaning Offer Indexes",
	"Casepack_ID": "Casepack ID",
	"You_are_about_to_download_the_offer_with_no_quantities_populated_in_the_Excel._You_can_add_all_here,_continue_as_is,_or_cancel_and_add_products_individually.": "You are about to download the offer with no quantities populated in the Excel. You can add all here, continue as is, or cancel and add products individually.",
	"Unit_WHL": "Unit WHL",
	"Unit_MSRP": "Unit MSRP",
	"CSPK_MSRP": "CSPK MSRP",
	"CSPK_WHL": "CSPK WHL",
	"Case_MSRP": "Case MSRP",
	"Case_WHL": "Case WHL",
	"This_filter_is_disabled_because_you_have_exceeded_the_max_amount_of_unique_values_allowed_for_filtering.": "This filter is disabled because you have exceeded the max amount of unique values allowed for filtering.",
	"Contact_%supportEmail_for_assistance.": "Contact %{supportEmail} for assistance.",
	"Column_A_(“ID”)_is_missing_in_your_file._Please_update_the_file_with_the_required_column_and_try_again._Refer_to_%linkStartthis_article%linkEnd_for_additional_help.": "Column A (“ID”) is missing in your file. Please update the file with the required column and try again. Refer to %{linkStart}this article%{linkEnd} for additional help.",
	"We_noticed_your_tab_names_have_changed._Please_revert_them_to_the_original_names_in_the_negotiation_download.": "We noticed your tab names have changed. Please revert them to the original names in the negotiation download.",
	"Upload_Counter_Offer_Error": "Upload Counter Offer Error",
	"Your_current_browser_version_is_not_supported_by_INTURN._You_may_lose_some_functionallity_and_the_experience_could_break._Please_update_to_the_latest_version_of_your_browser.": "Your current browser version is not supported by INTURN. You may lose some functionallity and the experience could break. Please update to the latest version of your browser.",
	"Visit_our_help_center_to_learn_more.": "Visit our help center to learn more.",
	"Add_this_product_to_your_offer_in_order_to_price": "Add this product to your offer in order to price",
	"Your_changes_have_been_saved.": "Your changes have been saved.",
	"Due_to_your_recent_changes,_the_current_filters_are_no_longer_applicable_for_this_product._Reset_your_filters_to_view_product_details.": "Due to your recent changes, the current filters are no longer applicable for this product. Reset your filters to view product details.",
	"%{value}_OFF": "%{value} OFF",
	"%{value}_Total_WHL_Value": "%{value} Total WHL Value",
	"%{value}_Total_MSRP_Value": "%{value} Total MSRP Value",
	"Sending_to:_%{recipients}": "Sending to: %{recipients}",
	"You’ve_made_some_edits_to_quantity_and_pricing,_now_we_need_to_get_those_approved.": "%{highlightStart}You’ve made some edits%{highlightEnd} to quantity and pricing, now we need to get those approved.",
	"Your_counterparty_can_either_accept_or_counter_your_offer_and_send_it_back_to_you_for_review.": "Your counterparty can %{highlightStart}either accept or counter%{highlightEnd} your offer and send it back to you for review.",
	"If_they_accept_your_counter_offer,_this_offer_will_close,_otherwise_negotiations_will_continue.": "If they accept your counter offer, this offer will close, otherwise negotiations will continue.",
	"Review_your_updated_offer_and_submit_it_to_your_brand_counterparty.": "%{highlightStart}Review your updated offer%{highlightEnd} and submit it to your brand counterparty.",
	"Once_they_recieve_it,_they_can_negotiate_directly_in_the_linesheet_or_accept_the_offer_as_is.": "Once they recieve it, they can %{highlightStart}negotiate%{highlightEnd} directly in the linesheet or accept the offer as is.",
	"You_are_about_to_accept_this_offer_from_%company.": "You are about to accept to this offer from %{company}.",
	"You_are_about_to_agree_this_offer_from_%company.": "You are about to agree to this offer from %{company}.",
	"It_looks_like_you’ve_agreed_to_your_counteparty’s_offer.": "It looks like you’ve %{highlightStart}agreed%{highlightEnd} to your counteparty’s offer.",
	"By_accepting_this_offer,_you_will_close_negotiations_at_the_agreed_upon_price_and_quantities.": "By accepting this offer, you %{highlightStart}will close negotiations at the agreed upon price and quantities%{highlightEnd}.",
	"Your_counterparty_will_be_notified_that_thier_offer_has_been_accepted_and_closed.": "Your counterparty will be notified that thier offer has been %{highlightStart}accepted and closed%{highlightEnd}.",
	"Review_the_updated_offer_and_click_Agree_when_you’re_ready.": "%{highlightStart}Review the updated offer%{highlightEnd} and click Agree when you’re ready.",
	"Your_brand_counterparty_will_be_notified_that_you_have_agreed_to_their_offer.": "Your brand counterparty will be %{highlightStart}notified%{highlightEnd} that you have %{highlightStart}agreed%{highlightEnd} to their offer.",
	"Your_brand_counterparty_must_then_accept_the_offer_to_complete_negotiations.": "Your %{highlightStart}brand%{highlightEnd} counterparty must then %{highlightStart}accept%{highlightEnd} the offer to complete negotiations.",
	"%units_Units": "%{highlightStart}%{units}%{highlightEnd} Units",
	"Review_your_offer_and_send_it_to_your_Buyer_counterparty.": "%{highlightStart}Review your offer%{highlightEnd} and send it to your Buyer counterparty.",
	"Once_the_buyer_receives_it,_they_can_negotiate_according_to_the_negotiation_settings_before_sending_it_back_to_you.": "Once the buyer receives it, they can %{highlightStart}negotiate%{highlightEnd} according to the negotiation settings before sending it back to you.",
	"PRODUCTS_IN_OFFER": "PRODUCTS IN OFFER",
	"No._Of_Products": "No. Of Products",
	"System_was_unable_to_%title_.Please_reach_out_to_%support_email_with": "System was unable to %{title}. Please reach out to %{supportEmail} with",
	"Reference_ID: [%correlationId]": "Reference ID: [%{correlationId}]",
	"Ended_Offers_cannot_be_downloaded._Please_reach_out_to_buyersupport@inturn.co_for_assistance.": "Ended Offers cannot be downloaded. Please reach out to buyersupport@inturn.co for assistance.",
	"last_units_offered_to_all": "Last Offered Units",
	"last_units_sold_to_all": "Last Sold Units",
	"last_units_offered_to_this_buyer": "Last Offered Units - Retailer",
	"last_units_sold_to_this_buyer": "Last Sold Units - Retailer",
	"highest_units_offered_to_all": "Highest Offered Units",
	"highest_units_sold_to_all": "Highest Sold Units",
	"highest_units_offered_to_this_buyer": "Highest Offered Units - Retailer",
	"highest_units_sold_to_this_buyer": "Highest Sold Units - Retailer",
	"last_unit_price_offered": "Last Offered Unit $",
	"last_unit_price_sold": "Last Sold Unit $",
	"last_unit_price_offered_to_buyer": "Last Offered Unit $ - Retailer",
	"last_unit_price_sold_to_buyer": "Last Sold Unit $ - Retailer",
	"last_percent_off_wholesale_offered": "Last Offered % Off WHL",
	"last_percent_off_wholesale_sold": "Last Sold % Off WHL",
	"last_percent_off_wholesale_offered_to_buyer": "Last Offered % Off WHL - Retailer",
	"last_percent_off_wholesale_sold_to_buyer": "Last Sold % Off WHL - Retailer",
	"last_percent_off_msrp_offered": "Last Offered % Off MSRP",
	"last_percent_off_msrp_sold": "Last Sold % Off MSRP",
	"last_percent_off_msrp_offered_to_buyer": "Last Offered % Off MSRP - Retailer",
	"last_percent_off_msrp_sold_to_buyer": "Last Sold % Off MSRP - Retailer",
	"highest_unit_price_offered": "Highest Offered Unit $",
	"highest_unit_price_sold": "Highest Sold Unit $",
	"highest_unit_price_offered_to_buyer": "Highest Offered Unit $ - Retailer",
	"highest_unit_price_sold_to_buyer": "Highest Sold Unit $ - Retailer",
	"lowest_percent_off_wholesale_offered": "Lowest Offered % Off WHL",
	"lowest_percent_off_wholesale_sold": "Lowest Sold % Off WHL",
	"lowest_percent_off_wholesale_offered_to_buyer": "Lowest Offered % Off WHL - Retailer",
	"lowest_percent_off_wholesale_sold_to_buyer": "Lowest Sold % Off WHL - Retailer",
	"lowest_percent_off_msrp_offered": "Lowest Offered % Off MSRP",
	"lowest_percent_off_msrp_sold": "Lowest Sold % Off MSRP",
	"lowest_percent_off_msrp_offered_to_buyer": "Lowest Offered % Off MSRP - Retailer",
	"lowest_percent_off_msrp_sold_to_buyer": "Lowest Sold % Off MSRP - Retailer",
	"percentage_off_wholesale": "% Off WHL",
	"percentage_off_msrp": "% Off MSRP",
	"Unit_Quantity.": "Unit Quantity",
	"Select_Metrics.": "Select Metrics",
	"Applying_a_pricing_metric_will_have_an_impact_on_the_Price,_%_Off_WHL_&_ Off_MSRP.": "Applying a pricing metric will have an impact on the Price, % Off WHL and % Off MSRP. If a product has no WHL or MSRP value, \"% Off\" changes will not be applied.",
	"Select_Column.": "Select Column",
	"LATEST_OFFERED_QUANTITY": "Last Offered Units",
	"LATEST_SOLD_QUANTITY": "Last Sold Units",
	"LATEST_OFFERED_TO_BUYER_QUANTITY": "Last Offered Units - Retailer",
	"LATEST_SOLD_TO_BUYER_QUANTITY": "Last Sold Units - Retailer",
	"HIGHEST_OFFERED_QUANTITY": "Highest Offered Units",
	"HIGHEST_SOLD_QUANTITY": "Highest Sold Units",
	"HIGHEST_OFFERED_TO_BUYER_QUANTITY": "Highest Offered Units - Retailer",
	"HIGHEST_SOLD_TO_BUYER_QUANTITY": "Highest Sold Units - Retailer",
	"LATEST_OFFERED_PRICE": "Last Offered Unit $",
	"LATEST_SOLD_PRICE": "Last Sold Unit $",
	"LATEST_OFFERED_TO_BUYER_PRICE": "Last Offered Unit $ - Retailer",
	"LATEST_SOLD_TO_BUYER_PRICE": "Last Sold Unit $ - Retailer",
	"HIGHEST_OFFERED_PRICE": "Highest Offered Unit $",
	"HIGHEST_SOLD_PRICE": "Highest Sold Unit $",
	"HIGHEST_OFFERED_TO_BUYER_PRICE": "Highest Offered Unit $ - Retailer",
	"HIGHEST_SOLD_TO_BUYER_PRICE": "Highest Sold Unit $ - Retailer"
};